/* rev 1793012353 */
/**
 * PZ · Pruebas cuadro — logica de los CINCO bloques nuevos de la seccion
 * `pz-pruebas-cuadro`: modalidad, cambios, base, complementos y resumen.
 *
 * Todo lo demas de la ficha (galeria, variantes, precio, boton de compra) lo
 * sigue haciendo `pz-producto.js`, que no se toca. Este fichero no duplica
 * nada de aquello: lee lo que aquel ya publica en el DOM.
 *
 * COMO SE COBRA LO QUE SE ELIGE AQUI
 * Las line item properties de Shopify no suben el precio, asi que nada de esto
 * puede cobrarse "pintando" un total. Lo que se hace es reflejar cada eleccion
 * en un `kc-swatch` dentro de un contenedor oculto con id `kc-supports`, que es
 * UNO DE LOS QUE `pz-prod-tarjeta` ya recorre al anadir al carrito (su lista
 * KCOMBO_IDS). Resultado: el cargo lo hace exactamente el mismo codigo que
 * cobra los upsells de siempre —una sola ruta al /cart/add.js, un solo sitio
 * donde se puede romper— y no hace falta tocar el snippet compartido.
 *
 * Ese id se eligio porque ya estaba en la lista y sin usar en ninguna ficha.
 * Si algun dia se quiere uno con mejor nombre, hay que anadirlo a KCOMBO_IDS
 * en snippets/pz-prod-tarjeta.liquid, que es compartido.
 *
 * Lo que NO tiene id de variante configurado no se ofrece. Preferimos que
 * falte una opcion a que alguien compre un suplemento que no se le cobra.
 */
(function () {
  "use strict";

  /**
   * EN EL EDITOR DE TEMAS ESTO SE VUELVE A EJECUTAR.
   *
   * Cada vez que el merchant cambia un ajuste, Shopify repinta la seccion
   * entera y lanza `shopify:section:load`. El DOM es NUEVO: los escuchadores
   * que se pusieron al cargar la pagina murieron con el viejo, y sin volver
   * a arrancar la ficha se queda muerta en cuanto se toca cualquier cosa.
   * Por eso todo vive dentro de `arrancar()` y no en el cuerpo del fichero.
   */
  var EN_EDITOR = !!(window.Shopify && window.Shopify.designMode);
  // ALEMAN. Este JS es un asset: no pasa por Liquid y no puede usar `t`. Los
  // textos al cliente eligen idioma aqui; lo que viaja al pedido (props,
  // conceptos) sigue en español, que es lo que lee el taller.
  var PZ_LANG = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || "").slice(0, 2);
  var PZ_DE = PZ_LANG === "de";
  var PZ_EN = PZ_LANG === "en";
  var PZ_IT = PZ_LANG === "it";

  function arrancar() {

  var RAIZ = document.querySelector("[data-pz-producto]");

  /**
   * EL PASO DE LA DEDICATORIA DEL CUADRO, y no cualquier nodo que lleve el
   * atributo.
   *
   * El hueco del visor 3D vive arriba, en el marco, antes que los pasos: si
   * algo le anota un `data-pzx-dedi` —paso justo eso, con una anotacion de
   * diagnostico— `querySelector` lo encontraba primero y la ficha trabajaba
   * sobre el visor. `mandaLaMadera` lo escondia creyendo esconder el paso:
   * se elegia la base de madera, el modelado aparecia y desaparecia solo.
   *
   * El de verdad es el unico que lleva dentro los botones Si/No.
   */
  function nodoDedi() {
    var cs = RAIZ.querySelectorAll("[data-pzx-dedi]");
    for (var i = 0; i < cs.length; i++) {
      if (cs[i].querySelector("[data-pzx-dedi-op]")) return cs[i];
    }
    return null;
  }

  /**
   * EN QUE OPCION VIVE EL EJE DE IA.
   *
   * Era siempre la tercera, y dejo de serlo: el portallaves se quedo sin
   * tallas el 29-10-2026 y el eje paso a la segunda. La seccion ya lo busca
   * en todas las opciones y escribe el numero en el portador; aqui solo se
   * lee. Sin numero —el bloque de dedicatoria del cuadro no lo lleva— se
   * queda en la tercera, que es como estaba.
   */
  function ejeIA(caja) {
    var n = caja && caja.dataset ? parseInt(caja.dataset.pzxEje, 10) : NaN;
    return (isNaN(n) || n < 0) ? 2 : n;
  }

  /** La misma variante salvo por ese eje: todo lo demas igual. */
  function mismaSalvoEje(o, ref, eje) {
    for (var i = 0; i < ref.length; i++) {
      if (i === eje) continue;
      if (o[i] !== ref[i]) return false;
    }
    return true;
  }
  if (!RAIZ) return;
  var FORM = RAIZ.querySelector('form[action*="/cart/add"]');

  // ---------------------------------------------------------------- dinero
  var MONEDA = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
  var fmt;
  try {
    fmt = new Intl.NumberFormat(document.documentElement.lang || "es-ES", {
      style: "currency", currency: MONEDA,
    });
  } catch (e) {
    fmt = { format: function (n) { return n.toFixed(2) + " €"; } };
  }
  function dineroIntl(centimos) { return fmt.format((Number(centimos) || 0) / 100); }

  /**
   * Formatea como la tienda SIEMPRE que haya una variante de la que copiar
   * el estilo. Antes el resumen escribia "€39.95" y el precio de arriba
   * "39,95€": dos formas distintas de escribir lo mismo en la misma pantalla.
   */
  function dinero(centimos) {
    var v = (typeof varianteActual === "function") ? varianteActual() : null;
    return comoLaTienda(centimos, v && v.pm);
  }

  /**
   * El mismo importe, escrito como lo escribe la tienda.
   *
   * `pz-producto.js` pinta el precio con la cadena ya formateada que trae
   * cada variante (`pm`), que sale del filtro `money` de Shopify y respeta
   * los ajustes de la tienda: simbolo, lado, separadores. Para no cambiar de
   * aspecto a mitad de ficha, se coge esa cadena de ejemplo y se le sustituye
   * SOLO el numero. Si no hay ejemplo, se cae al formateo propio.
   */
  function comoLaTienda(centimos, ejemplo) {
    if (!ejemplo) return dineroIntl(centimos);
    var m = String(ejemplo).match(/[\d.,]+/);
    if (!m) return dineroIntl(centimos);
    var muestra = m[0];
    // El ultimo separador con dos cifras detras es el decimal.
    var dec = /[.,](\d{2})$/.exec(muestra);
    var sepDec = dec ? muestra.charAt(muestra.length - 3) : ",";
    var sepMil = sepDec === "," ? "." : ",";
    var n = (Number(centimos) || 0) / 100;
    var entero = Math.floor(Math.abs(n)).toString();
    var cents = Math.round((Math.abs(n) - Math.floor(Math.abs(n))) * 100).toString();
    if (cents.length < 2) cents = "0" + cents;
    entero = entero.replace(/\B(?=(\d{3})+(?!\d))/g, sepMil);
    return String(ejemplo).replace(muestra, entero + sepDec + cents);
  }
  function soloDigitos(v) { return String(v || "").replace(/[^\d]/g, ""); }
  function centimos(v) { return parseInt(soloDigitos(v), 10) || 0; }

  // ------------------------------------------------------- espejo kc-swatch
  /**
   * El contenedor oculto por el que cobra pz-prod-tarjeta. Se crea DENTRO del
   * formulario del producto: fuera de el, `extractFormProps` no lo veria y,
   * peor, podria quedar huerfano si el tema reemplaza el panel.
   */
  var espejo = null;
  function cajaEspejo() {
    if (espejo && document.body.contains(espejo)) return espejo;
    espejo = document.getElementById("kc-supports");
    if (!espejo) {
      espejo = document.createElement("div");
      espejo.id = "kc-supports";
      espejo.className = "pzx-espejo";
      espejo.setAttribute("aria-hidden", "true");
      (FORM || RAIZ).appendChild(espejo);
    }
    return espejo;
  }

  /**
   * Deja en el espejo EXACTAMENTE las lineas que hay que cobrar ahora.
   * Se reconstruye entero en cada cambio: es poca cosa y evita el error
   * clasico de quitar una opcion y dejarse su checkbox marcado.
   */
  function sincronizarEspejo(lineas) {
    var caja = cajaEspejo();
    // SI NO HA CAMBIADO, NO SE TOCA. Esto corre en cada tecla —cada letra de
    // la dedicatoria repinta el resumen— y rehacer los nodos, aunque sean
    // invisibles, despista al navegador: pierde el elemento del que se
    // agarra para no mover el scroll y lo corrige a ojo. De ahi los saltos
    // de pantalla escribiendo.
    var firma = JSON.stringify(lineas.map(function (l) {
      return [l.variantId, l.cantidad || 1, l.concepto];
    }));
    if (caja.__pztFirma !== firma) {
      caja.__pztFirma = firma;
      caja.innerHTML = "";
      lineas.forEach(function (l) {
        if (!l.variantId) return;
        var label = document.createElement("label");
        label.className = "kc-swatch";
        label.setAttribute("data-variant-id", l.variantId);
        if (l.cantidad && l.cantidad > 1) label.dataset.qty = String(l.cantidad);
        var inp = document.createElement("input");
        inp.type = "checkbox";
        inp.name = "kc-variant";
        inp.value = l.variantId;
        inp.checked = true;
        label.appendChild(inp);
        // pz-prod-tarjeta saca de aqui el nombre que viaja en properties[Upsell].
        var txt = document.createElement("span");
        txt.className = "kc-swatch__txt";
        var strong = document.createElement("strong");
        strong.textContent = alEspanol(l.concepto);
        txt.appendChild(strong);
        label.appendChild(txt);
        caja.appendChild(label);
      });
    }
    // LO QUE VIAJA CON CADA LINEA SE REFRESCA SIEMPRE, SIN REHACER NADA.
    //
    // El grabado de la base cambia con cada letra, y no puede entrar en la
    // firma de arriba: rehacer el espejo en cada tecla es justo lo que
    // daba los saltos de pantalla que esa firma evita. Asi que los nodos se
    // quedan donde estan y solo se les cambia el dato.
    //
    // `pz-prod-tarjeta` lee este `data-props` y lo mezcla con la property
    // `Upsell` que ya ponia. Sin el atributo, se comporta como siempre.
    lineas.forEach(function (l) {
      if (!l.variantId) return;
      var label = caja.querySelector('.kc-swatch[data-variant-id="' + l.variantId + '"]');
      if (!label) return;
      if (l.props && Object.keys(l.props).length) {
        label.setAttribute("data-props", JSON.stringify(l.props));
      } else {
        label.removeAttribute("data-props");
      }
    });
  }

  // ------------------------------------------------------------- variante
  var datosVar = RAIZ.querySelector("[data-pz-variantes]");
  var VARIANTES = [];
  try { VARIANTES = JSON.parse(datosVar.textContent) || []; } catch (e) { VARIANTES = []; }
  var campoId = RAIZ.querySelector("[data-pz-id]");

  /** La variante elegida ahora mismo, segun el input que mantiene pz-producto.js. */
  function varianteActual() {
    var id = campoId && campoId.value;
    for (var i = 0; i < VARIANTES.length; i++) {
      if (String(VARIANTES[i].id) === String(id)) return VARIANTES[i];
    }
    return VARIANTES[0] || null;
  }

  // ------------------------------------------------------------- bloques
  var bModo = RAIZ.querySelector("[data-pzx-modalidad]");
  var bCambios = RAIZ.querySelector("[data-pzx-cambios]");
  var bBase = RAIZ.querySelector("[data-pzx-base]");
  var bComps = RAIZ.querySelector("[data-pzx-complementos]");
  // TODOS los bloques de este tipo, no solo el primero. La ficha ya usa dos:
  // la caja de regalo y la base de metacrilato, que son el mismo paso de
  // «si o no» con su foto, su variante y su precio.
  var bCajas = Array.prototype.slice.call(RAIZ.querySelectorAll("[data-pzx-caja]"));
  var bResumen = RAIZ.querySelector("[data-pzx-resumen]");

  var estado = {
    modo: null,            // nada elegido: de ahi cuelga el resto de la ficha
    conDedi: false,        // lo manda la variante, no este objeto
    cambios: false,
    base: null,            // {variantId, precio, nombre, luz} o null
    dedibase: false,       // el grabado de la madera, que se cobra aparte
    llavero: null,         // {variantId, precio, nombre} o null
    sueltos: {},           // caja/taza/usb -> {variantId, precio, nombre}
  };

  /**
   * LO QUE VA AL PEDIDO, EN ESPAÑOL.
   *
   * En /de, /en e /it la base, la modalidad y los complementos salen del texto
   * de la tarjeta, que ya llega traducido, y el taller lee el pedido en
   * español. La seccion deja un mapa traduccion -> español
   * ([data-pzx-props-es]) y aqui se devuelven al español SOLO esos valores
   * (nunca lo que escribe el cliente). Lo que no este en el mapa viaja tal cual.
   */
  var PROPS_ES;
  function alEspanol(v) {
    if (PROPS_ES === undefined) {
      PROPS_ES = null;
      var nodo = document.querySelector("[data-pzx-props-es]");
      if (nodo) { try { PROPS_ES = JSON.parse(nodo.textContent) || null; } catch (e) { PROPS_ES = null; } }
    }
    if (!PROPS_ES || v == null) return v;
    var k = String(v).trim();
    return Object.prototype.hasOwnProperty.call(PROPS_ES, k) ? PROPS_ES[k] : v;
  }

  function prop(nombre, valor, activo) {
    var n = RAIZ.querySelector('[data-pzx-prop="' + nombre + '"]');
    if (!n) return;
    n.value = (nombre === "modo" || nombre === "base" ? alEspanol(valor) : valor) || "";
    // Un input deshabilitado no viaja al pedido: es la forma de BORRAR una
    // property, no dejarla vacia.
    if (activo === false) n.setAttribute("disabled", "disabled");
    else n.removeAttribute("disabled");
  }

  // Los valores que ya trae el HTML (la base «sin base» por defecto) tambien.
  ["modo", "base"].forEach(function (k) {
    var n = RAIZ.querySelector('[data-pzx-prop="' + k + '"]');
    if (n && n.value) n.value = alEspanol(n.value);
  });

  function marcar(nodos, elegido) {
    nodos.forEach(function (n) {
      var es = n === elegido;
      n.classList.toggle("is-sel", es);
      n.setAttribute("aria-checked", es ? "true" : "false");
    });
  }

  /**
   * Pone la variante que toca segun lo elegido: dedicatoria sí/no y retrato
   * con IA o foto original. Lo rellena el bloque de la dedicatoria, que es
   * quien conoce los cuatro valores de la opcion; hasta entonces no hace
   * nada. Lo llaman los dos pasos, porque los dos mueven la MISMA opcion.
   */
  var aplicarTipoCuadro = function () {};

  var pintarPrecioIA = function () {};

  /** La ruta del App Proxy, tal como la lleva configurada el widget. */
  function rutaProxy() {
    var n = RAIZ.querySelector(".pr-customizer__config");
    try { return (JSON.parse(n.textContent) || {}).proxyBase || ""; } catch (e) { return ""; }
  }

  // --- modalidad ------------------------------------------------------------
  if (bModo) {
    var tarjetasModo = Array.prototype.slice.call(bModo.querySelectorAll("[data-pzx-modo]"));

    // El widget ya trae los dos caminos; aqui solo se deja a la vista el que
    // toca, para no tener dos sitios donde elegir lo mismo.
    function aplicarModo() {
      var btnIA = RAIZ.querySelector("[data-pr-generate]");
      var btnOrig = RAIZ.querySelector("[data-pr-original]");
      if (btnIA) btnIA.style.display = estado.modo === "ia" ? "" : "none";
      if (btnOrig) btnOrig.style.display = estado.modo === "original" ? "" : "none";
    }

    // LA ETIQUETA SALE DEL PRECIO DE VERDAD. Se calcula restando las dos
    // variantes de la misma pieza, no del ajuste del merchant: asi no puede
    // anunciar +5,99 € y cobrar otra cosa. Si no hay variantes con IA, se
    // cae al ajuste, que es lo unico que queda por decir.
    var etqIA = bModo.querySelector("[data-pzx-ia-precio]");
    var tarjetaIA = bModo.querySelector('[data-pzx-modo="ia"]');
    /**
     * SIN VARIANTES DE IA, NO SE OFRECE IA.
     *
     * El recargo de la IA se cobra cambiando de variante. Un producto que
     * todavia no tiene esas variantes —los cuadros de caricatura, por
     * ejemplo— se quedaba anunciando «+9,95 €» en la tarjeta y cobrando
     * cero: la tienda regalaba la generacion, que ademas cuesta dinero cada
     * vez. Asi que si no estan, la tarjeta no se enseña; en cuanto se creen,
     * aparece sola.
     */
    function hayVariantesIA() {
      var cajaDedi = nodoDedi();
      var vNoIa = cajaDedi && cajaDedi.dataset.pzxValNoIa;
      var vSiIa = cajaDedi && cajaDedi.dataset.pzxValSiIa;
      if (!vNoIa && !vSiIa) return false;
      var eje = ejeIA(cajaDedi);
      for (var i = 0; i < VARIANTES.length; i++) {
        var o = VARIANTES[i].o || [];
        if ((vNoIa && o[eje] === vNoIa) || (vSiIa && o[eje] === vSiIa)) return true;
      }
      return false;
    }

    var seOfreceIA = hayVariantesIA();
    if (tarjetaIA && !seOfreceIA) {
      tarjetaIA.hidden = true;
      // Y que no se quede elegida de una visita anterior.
      if (estado.modo === "ia") estado.modo = null;
    }

    pintarPrecioIA = function () {
      if (!etqIA) return;
      if (!seOfreceIA) { etqIA.textContent = ""; return; }
      var sup = suplementoIA();
      if (!sup) sup = centimos(tarjetaIA && tarjetaIA.dataset.pzxPrecio);
      etqIA.textContent = sup > 0 ? "+" + dinero(sup) : "";
    };
    pintarPrecioIA();

    tarjetasModo.forEach(function (t) {
      t.addEventListener("click", function () {
        var yaElegida = estado.modo === t.dataset.pzxModo;
        estado.modo = t.dataset.pzxModo;
        // El sobreprecio de la IA NO es una linea aparte del carrito: es la
        // variante. Elegir aqui mueve la opcion «tipo de cuadro», igual que
        // hace el paso de la dedicatoria, y el precio viaja dentro del
        // producto —donde el cliente no puede borrarlo.
        aplicarTipoCuadro();
        marcar(tarjetasModo, t);
        var tit = t.querySelector(".pzx__tarjeta-tit");
        prop("modo", tit ? tit.textContent.trim() : estado.modo);
        aplicarModo();
        destapar();
        pintar();

        traerZonaDeSubida();

        // ESTAS TARJETAS SON LOS BOTONES DE GENERAR.
        //
        // Se llaman «Generar con IA» y «Generar original», y el recuadro de
        // subir vive encima, a la vista desde el principio. Asi que pulsar
        // una no es solo elegir: es arrancar. Los botones del widget estan
        // escondidos por CSS dentro del hueco —seria tener dos sitios para
        // lo mismo— y se pulsan por dentro.
        //
        // Sin foto todavia no hay nada que generar: se abre el selector de
        // archivo y el cliente vuelve a pulsar cuando la tenga.
        diag("tarjeta pulsada:", estado.modo,
             "| hay foto:", hayFoto(),
             "| variante:", (RAIZ.querySelector('input[name="id"]') || {}).value,
             "| boton IA:", (function () {
               var b = RAIZ.querySelector("[data-pr-generate]");
               return b ? ("existe, disabled=" + b.disabled) : "NO EXISTE";
             })());
        if (!hayFoto()) { diag("sin foto: abro el selector"); abrirSelectorDeFoto(); return; }
        arrancarGeneracion();
      });
    });

    /**
     * Pulsa por dentro el boton del widget que toca segun la modalidad.
     *
     * Se espera un pelin: al elegir modalidad cambia la variante, y el
     * widget mira la variante para saber que pieza esta fabricando.
     *
     * Y SE INSISTE, QUE ANTES SE TIRABA UNA SOLA VEZ. Era un disparo a los
     * 60 ms: si justo en ese instante el widget estaba rehaciendose por el
     * cambio de variante —mientras tanto deja sus botones apagados— el clic
     * caia en un boton deshabilitado y no pasaba NADA. Ni generacion ni
     * aviso: el cliente pulsaba «GENERAR CON IA» y la ficha se quedaba
     * igual, sin nada que mirar. Ahora se reintenta tres segundos y, si aun
     * asi no arranca, se dice en voz alta.
     */
    function arrancarGeneracion() {
      var sel = estado.modo === "ia" ? "[data-pr-generate]" : "[data-pr-original]";
      var intentos = 0;
      (function intentar() {
        var btn = RAIZ.querySelector(sel);
        if (btn && !btn.disabled) {
          diag("pulso el boton del widget", sel, "al intento", intentos);
          btn.click();
          return;
        }
        // El boton apagado CON la barra de progreso a la vista significa que
        // ya hay una generacion en marcha: insistir seria pedir dos y
        // pagarlas dos.
        if (generando()) { diag("ya hay una generacion en marcha; no insisto"); return; }
        if (++intentos <= 25) { setTimeout(intentar, 120); return; }
        diag("ME RINDO: el boton", sel, btn ? "sigue deshabilitado" : "no aparece");
        avisarNoArranca();
      })();
    }

    /**
     * DIARIO DE A BORDO, SOLO EN LA CONSOLA.
     *
     * Este camino —pulsar la tarjeta, mover la variante, pulsar por dentro el
     * boton del widget— falla en silencio con demasiada facilidad, y sin
     * rastro no hay forma de saber en que escalon se cayo. No estorba a
     * nadie: es un `console.log` con prefijo, apagable y gratis.
     */
    function diag() {
      try {
        if (!window.console || !console.log) return;
        var a = Array.prototype.slice.call(arguments);
        a.unshift("[pzx·generar]");
        console.log.apply(console, a);
      } catch (e) { /* consola capada */ }
    }

    /** Si el widget esta generando, lo canta su barra de progreso. */
    function generando() {
      var p = RAIZ.querySelector("[data-pr-progress], .pr-progress");
      return !!(p && p.getClientRects().length);
    }

    /**
     * QUE NO SE QUEDE EN SILENCIO.
     *
     * Un boton que no hace nada es lo peor que puede pasar aqui: el cliente
     * no sabe si ha pulsado mal, si va lento o si esta roto, y se va. Si el
     * widget no llega a estar disponible, se usa su propio hueco de avisos.
     */
    function avisarNoArranca() {
      var aviso = RAIZ.querySelector("[data-pr-error]");
      if (!aviso) return;
      aviso.textContent = (PZ_DE ? "Das hat leider nicht geklappt. Bitte tippe noch einmal." : PZ_EN ? "Something went wrong. Please tap again." : PZ_IT ? "Qualcosa è andato storto. Tocca di nuovo, per favore." : "No hemos podido empezar. Vuelve a pulsar, por favor.");
      aviso.hidden = false;
    }

    /**
     * Trae al paso de modalidad la zona de subida del widget.
     *
     * Se MUEVE el elemento, no se copia: sigue siendo el mismo nodo con los
     * mismos escuchadores que le puso el widget, asi que arrastrar, soltar,
     * pulsar y el teclado siguen funcionando igual. Copiarlo habria dejado
     * dos zonas de subida, una de ellas muerta.
     *
     * Se lleva tambien la fila de "¿Es esta tu foto? · Cambiar foto": sin
     * ella, el cliente veria su foto arriba y el boton para cambiarla en otro
     * paso, abajo.
     */
    function traerZonaDeSubida() {
      // UN SOLO HUECO, debajo de las dos tarjetas. Antes habia uno detras de
      // cada una y el personalizador se mudaba al de la elegida; con las dos
      // opciones en fila eso ya no cuadra, asi que el sitio es siempre el
      // mismo y lo que cambia al elegir es el boton que se ve dentro.
      var hueco = RAIZ.querySelector("[data-pzx-subida]");
      if (!hueco) return;
      var zona = RAIZ.querySelector("[data-pr-dropzone]");
      if (!zona) return;                      // el widget aun no ha montado

      // TODO EL PERSONALIZADOR, NO SOLO LA SUBIDA. Elegir, subir y generar
      // son un mismo gesto y tienen que estar en el mismo sitio: dejar el
      // boton de generar un paso mas abajo obligaba a bajar, buscarlo y
      // volver. El orden de abajo es el orden en que se usan.
      var piezas = [
        "[data-pr-dropzone]",      // subir / vista previa / "generando…"
        "[data-pr-confirm-row]",   // ¿es esta tu foto? · cambiar foto
        "[data-pr-error]",         // el aviso, junto a lo que lo provoca
        "[data-pr-generate]",      // generar diseño (o volver a personalizar)
        "[data-pr-original]",      // imagen original
        "[data-pr-progress]",      // la barra, justo debajo de su boton
        "[data-pr-quota]",         // generaciones que le quedan hoy
      ];
      for (var i = 0; i < piezas.length; i++) {
        var el = RAIZ.querySelector(piezas[i]);
        // Se MUEVEN, no se copian: siguen siendo los mismos nodos con los
        // escuchadores que les puso el widget.
        if (el && el.parentNode !== hueco) hueco.appendChild(el);
      }
      hueco.hidden = false;

      // El paso del bloque de la app se queda sin contenido visible: se
      // esconde para no dejar un circulo numerado presidiendo un hueco
      // vacio. El widget sigue en el DOM y funcionando; lo que se oculta es
      // el envoltorio que le puso la seccion.
      var raizWidget = RAIZ.querySelector("[data-pr-customizer]");
      var envoltorio = raizWidget && raizWidget.closest(".pz-prod__bloque");
      // En el editor no se esconde: hay que poder seleccionarlo.
      if (!EN_EDITOR && envoltorio) envoltorio.hidden = true;
    }

    /** ¿En cual de los dos huecos esta ahora el personalizador? */
    function huecoConElWidget() {
      var zona = RAIZ.querySelector("[data-pr-dropzone]");
      var p = zona && zona.parentElement;
      return (p && p.hasAttribute && p.hasAttribute("data-pzx-subida")) ? p : null;
    }

    /** ¿El cliente ya tiene una foto puesta en el widget? */
    function hayFoto() {
      var prev = RAIZ.querySelector("[data-pr-preview]");
      return !!(prev && prev.getAttribute("src"));
    }

    /**
     * LA PAPELERA DEL RECUADRO DE SUBIR.
     *
     * Vive en la esquina de la zona de arrastre —es una accion sobre la
     * foto, asi que va encima de ella— y solo se ve cuando hay foto puesta.
     * Quien olvida la foto es el widget: se le pide con un evento y el se
     * encarga de su estado, su vista previa y sus botones.
     */
    var botonQuitar = RAIZ.querySelector("[data-pzx-quitar]");

    /**
     * Encima de la FOTO, no del hueco.
     *
     * Con una foto puesta, el widget estrecha su zona de arrastre para que
     * case con la proporcion de la imagen, asi que la esquina del hueco y la
     * de la foto dejan de ser la misma: la papelera se quedaba flotando en
     * el vacio, a 100px de la foto. Se mide y se coloca sobre la esquina de
     * verdad.
     */
    function colocarQuitar() {
      if (!botonQuitar || botonQuitar.hidden) return;
      var hueco = botonQuitar.parentElement;
      var zona = RAIZ.querySelector("[data-pr-dropzone]");
      if (!hueco || !zona) return;
      var rh = hueco.getBoundingClientRect();
      var rz = zona.getBoundingClientRect();
      if (!rz.height) return;
      botonQuitar.style.top = Math.round(rz.top - rh.top + 8) + "px";
      botonQuitar.style.right = Math.round(rh.right - rz.right + 8) + "px";
    }

    function revisarQuitar() {
      if (!botonQuitar) return;
      botonQuitar.hidden = !hayFoto();
      colocarQuitar();
    }

    if (botonQuitar) {
      botonQuitar.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();          // sin esto, el clic abriria el selector
        try { window.dispatchEvent(new CustomEvent("portrait:quitar-foto")); } catch (err) {}
        // LA PAPELERA EMPIEZA EL PEDIDO DE CERO. Quien quita la foto esta
        // empezando otro regalo: lo elegido para el anterior —base,
        // dedicatoria, llavero, caja, tarjeta— ya no vale, y el diseño que
        // se ve arriba tampoco. Se deja la ficha como recien abierta, con el
        // paso de modalidad en pie para poder subir la foto nueva.
        if (typeof window.__pztEmpezarDeCero === "function") window.__pztEmpezarDeCero();
        setTimeout(revisarQuitar, 60);
      });
      // La vista previa es la que dice si hay foto: se vigila su `src`.
      var vistaPrevia = RAIZ.querySelector("[data-pr-preview]");
      if (vistaPrevia && typeof MutationObserver === "function") {
        new MutationObserver(revisarQuitar).observe(vistaPrevia, {
          attributes: true, attributeFilter: ["src", "hidden"],
        });
      }
      // La zona cambia de tamaño al pintar la vista previa: se repasa un
      // poco despues y al cambiar la ventana.
      setTimeout(revisarQuitar, 400);
      window.addEventListener("resize", function () { setTimeout(revisarQuitar, 60); });
      revisarQuitar();
    }

    /**
     * Abre el selector de archivo del widget. Se pulsa su zona de subida en
     * vez de su <input type=file> directamente: asi pasa por el mismo camino
     * que si el cliente la pulsara, y no se salta nada de lo que el widget
     * haga ahi.
     */
    function abrirSelectorDeFoto() {
      var zona = RAIZ.querySelector("[data-pr-dropzone]");
      if (zona) { zona.click(); return; }
      var inp = RAIZ.querySelector("[data-pr-file]");
      if (inp) inp.click();
    }

    // El widget se carga aparte (script defer de la extension), asi que sus
    // botones pueden llegar despues. Se aplica ya si estan, y si no se espera.
    (function esperarAlWidget() {
      function listo() {
        aplicarModo();
        // EL RECUADRO DE SUBIR, A LA VISTA DESDE EL PRINCIPIO. Antes
        // aparecia al elegir modalidad, pero ahora las tarjetas son los
        // botones de generar: la foto tiene que poder ponerse ANTES de
        // pulsarlas, asi que la zona se trae nada mas montar el widget.
        traerZonaDeSubida();
      }
      // SE ESPERA A QUE EL WIDGET ESTE LISTO, no solo a que su markup
      // exista. Si se le quitan las piezas antes de que enganche sus
      // escuchadores, la zona de arrastre se queda muerta: se ve, pero no
      // responde al clic ni a soltar un fichero. El widget lo marca con
      // `data-pr-listo` y avisa con `portrait:listo`.
      function listoDelTodo() {
        return RAIZ.querySelector("[data-pr-customizer][data-pr-listo]") ||
               RAIZ.querySelector("[data-pr-listo]");
      }
      if (listoDelTodo()) { listo(); return; }
      window.addEventListener("portrait:listo", function alAvisar() {
        window.removeEventListener("portrait:listo", alAvisar);
        listo();
      });
      if (typeof MutationObserver !== "function") return;
      var obs = new MutationObserver(function () {
        if (listoDelTodo()) { listo(); obs.disconnect(); }
      });
      obs.observe(RAIZ, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-pr-listo"] });
    })();
  }

  // --- cambios en el diseño -------------------------------------------------
  if (bCambios) {
    var opsCambios = Array.prototype.slice.call(bCambios.querySelectorAll("[data-pzx-cambios-op]"));
    var campoCambios = bCambios.querySelector("[data-pzx-cambios-campo]");
    var textoCambios = bCambios.querySelector("[data-pzx-cambios-texto]");
    var sufijoCambios = bCambios.querySelector("[data-pzx-cambios-sufijo]");
    var varCambios = bCambios.dataset.pzxVariant || "";
    var preCambios = centimos(bCambios.dataset.pzxPrecio);

    if (sufijoCambios && varCambios) sufijoCambios.textContent = " (+" + dinero(preCambios) + ")";

    /**
     * EL PASO DE CAMBIOS SOLO CON IA.
     *
     * Pedir cambios es pedirle al equipo que retoque un retrato DIBUJADO.
     * Con la foto original no hay diseño que rehacer —es la foto del cliente,
     * restaurada— asi que el paso sobra y solo confunde.
     *
     * Al esconderlo se devuelve a «No» y se vacia lo escrito: si no, el
     * pedido llegaria con una peticion de cambios y sus 2,95 € cobrados por
     * algo que el cliente ya no ve en pantalla.
     */
    function revisarCambios() {
      var toca = estado.modo === "ia";
      var env = bCambios.closest(".pz-prod__bloque") || bCambios;
      // En el editor del tema no se esconde nada: el merchant tiene que
      // poder seleccionar el bloque para configurarlo.
      if (!EN_EDITOR) env.hidden = !toca;
      if (toca || !estado.cambios) return;
      estado.cambios = false;
      var no = bCambios.querySelector('[data-pzx-cambios-op="no"]');
      if (no) marcar(opsCambios, no);
      if (campoCambios) campoCambios.hidden = true;
      if (textoCambios) {
        textoCambios.setAttribute("disabled", "disabled");
        textoCambios.value = "";
      }
    }
    bCambios._revisarCambios = revisarCambios;

    opsCambios.forEach(function (o) {
      o.addEventListener("click", function () {
        estado.cambios = o.dataset.pzxCambiosOp === "si";
        marcar(opsCambios, o);
        if (campoCambios) campoCambios.hidden = !estado.cambios;
        if (textoCambios) {
          // Deshabilitado = no viaja al pedido. Si el cliente dice «No», la
          // peticion tiene que desaparecer, no quedarse escrita.
          if (estado.cambios) textoCambios.removeAttribute("disabled");
          else { textoCambios.setAttribute("disabled", "disabled"); textoCambios.value = ""; }
        }
        pintar();
      });
    });
  }

  // --- base -----------------------------------------------------------------
  if (bBase) {
    var opsBase = Array.prototype.slice.call(bBase.querySelectorAll("[data-pzx-base-op]"));
    var cajaDediBase = bBase.querySelector("[data-pzx-dedibase]");
    var campoDediBase = bBase.querySelector("[data-pzx-dedibase-campo]");
    var opsDediBase = Array.prototype.slice.call(bBase.querySelectorAll("[data-pzx-dedibase-op]"));
    var cajaCampoDedi = bBase.querySelector("[data-pzx-dedibase-caja]");

    /**
     * LA PEANA VA PUESTA Y NO SE ELIGE.
     *
     * El bloque `base` ofrece el soporte como extra, asi que el grabado
     * depende de que haya base elegida. El bloque `dedibase` es para las
     * fichas donde la base viene incluida —la lampara con base de madera—:
     * no pinta tarjetas de soporte, y por eso mismo se reconoce. Sin ellas
     * la peana esta puesta siempre y el grabado se puede ofrecer de entrada.
     */
    var baseFija = opsBase.length === 0;

    /**
     * EL GRABADO COBRADO POR LA OPCION DEL PRODUCTO.
     *
     * En el cuadro el grabado es una variante suelta que se añade al
     * carrito. La lampara con base lo vende desde hace meses como un valor
     * de sus opciones («LÁMPARA» contra «LÁMPARA + DEDICATORIA»): cobrarlo
     * ademas con la variante suelta seria cobrarlo dos veces. Cuando el
     * bloque trae estos dos valores, el si/no mueve el radio de la opcion y
     * el recargo sale por donde sale siempre.
     */
    var dediBaseValSi = (cajaDediBase && cajaDediBase.dataset.pzxDedibaseValSi) || "";
    var dediBaseValNo = (cajaDediBase && cajaDediBase.dataset.pzxDedibaseValNo) || "";
    var dediBaseEsOpcion = !!(dediBaseValSi && dediBaseValNo);

    /**
     * El grupo de radios de la opcion que lleva la dedicatoria.
     *
     * No vale recorrer los de toda la ficha: la lampara con base llama
     * «LÁMPARA» a un valor de su segunda opcion y otra vez al valor sin IA
     * de la tercera, y el clic se lo llevaria la que va antes. El ancla es
     * el valor CON dedicatoria, que no se puede repetir porque lleva
     * sufijo.
     */
    function grupoDediBase() {
      var radios = RAIZ.querySelectorAll('[data-pz-opcion] input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value !== dediBaseValSi) continue;
        return radios[i].closest("[data-pz-opcion]") || RAIZ;
      }
      return RAIZ;
    }

    /** Marca el radio escondido de la opcion cuyo valor es `valor`. */
    function ponerValorOpcion(valor) {
      if (!valor) return;
      var radios = grupoDediBase().querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value !== valor) continue;
        // Si ya estaba, no se vuelve a pulsar: el clic rehace la variante y
        // con ella medio paso.
        if (!radios[i].checked) radios[i].click();
        return;
      }
    }

    /** El valor que hay puesto ahora mismo en esa opcion. */
    function valorOpcionPuesto() {
      var radios = grupoDediBase().querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (!radios[i].checked) continue;
        if (radios[i].value === dediBaseValSi || radios[i].value === dediBaseValNo) return radios[i].value;
      }
      return "";
    }

    // El grabado solo se OFRECE como extra si hay con que cobrarlo: una
    // variante suelta, o el valor de una opcion del propio producto. Sin
    // ninguna de las dos la seccion se comporta como siempre: el campo sale
    // al elegir base y no se cobra nada.
    var seCobraDedi = !!(cajaDediBase && soloDigitos(cajaDediBase.dataset.pzxVariant)) || dediBaseEsOpcion;
    var contDediBase = bBase.querySelector("[data-pzx-dedibase-contador]");

    /**
     * El contador de letras de la peana. La seccion lo pinta a «0/30» y hay
     * que moverlo al escribir: en una base caben pocas letras y el cliente
     * tiene que ver cuantas le quedan MIENTRAS escribe, no descubrir de
     * golpe que el campo ha dejado de aceptarle teclas.
     */
    function contarDediBase() {
      if (!contDediBase || !campoDediBase) return;
      var max = parseInt(campoDediBase.getAttribute("maxlength"), 10) || 30;
      var n = (campoDediBase.value || "").length;
      contDediBase.textContent = n + "/" + max;
      contDediBase.classList.toggle("is-lleno", n >= max);
    }

    opsBase.forEach(function (o) {
      var txt = o.querySelector("[data-pzx-precio-txt]");
      if (txt && o.dataset.pzxPrecio) txt.textContent = "+" + dinero(centimos(o.dataset.pzxPrecio));
      o.addEventListener("click", function () {
        // Volver a pulsar la que ya esta elegida no hace nada: no hay nada
        // que cambiar y lo unico que conseguia era lanzar un segundo montaje
        // del visor encima del primero.
        if (o.classList.contains("is-sel")) return;
        estado.base = o.dataset.pzxBaseOp === "ninguna" ? null : {
          variantId: soloDigitos(o.dataset.pzxVariant),
          precio: centimos(o.dataset.pzxPrecio),
          nombre: o.dataset.pzxNombre || "Base",
          luz: o.dataset.pzxLuz === "1",
        };
        marcar(opsBase, o);
        prop("base", o.dataset.pzxNombre || "Sin base");
        pintar();
        montar3D();
        // El visor tarda en tener el primer fotograma; cuando lo tiene, la
        // foto de la galeria se rehace con la pieza ya montada (o sin ella).
        setTimeout(function () { verEnGaleria(""); }, 1200);
      });
    });

    /**
     * EL GRABADO SE VE EN LA MADERA MIENTRAS SE ESCRIBE.
     *
     * `visor3d` es el visor de ESTA seccion, y solo se monta cuando la peana
     * es un extra que se elige. En la lampara con base de madera no hay nada
     * que elegir: ese visor no existe nunca, y los `setDedication` de aqui
     * abajo no graban a nadie.
     *
     * Quien enseña la lampara es el visor del propio personalizador, que en
     * esta ficha sustituye al lienzo y modela la peana de verdad. Ya sabe
     * regrabar la madera con cada tecla —lo hace con lo que se escribe
     * dentro del editor—, pero escucha a SU campo. El del paso no le
     * llegaba, asi que el cliente escribia la dedicatoria y la madera seguia
     * lisa.
     *
     * Se le pasa por ese mismo campo en vez de buscarle el visor por dentro:
     * el widget guarda ademas el texto en su memoria, y es de ahi de donde
     * lo saca al exportar la imagen que viaja al pedido. Escribiendo en el
     * campo quedan los dos al dia; llamando al visor, solo la pantalla.
     */
    function grabarEnLaMadera(texto) {
      var campo = document.querySelector("[data-pr-dedi-madera]");
      if (!campo) return false;                 // todavia no hay editor
      // Igual que estaba: no se rehornea la textura por nada.
      if (campo.value === texto) return true;
      campo.value = texto;
      try { campo.dispatchEvent(new Event("input", { bubbles: true })); }
      catch (e) { return false; }               // navegador viejo
      return true;
    }

    /**
     * EL EDITOR LLEGA TARDE, Y VUELVE A LLEGAR.
     *
     * Su campo no existe hasta que hay diseño, y se rehace al cambiar de
     * variante. Quien escribio la dedicatoria antes de tener diseño —o quien
     * la tenia puesta cuando el editor se rehizo— se quedaba con la madera
     * lisa. Cada vez que cambia el hueco del editor se le vuelve a pasar lo
     * que haya escrito en el paso.
     */
    var relojMadera = null;
    function repasarMadera() {
      if (relojMadera) return;                  // ya hay uno en camino
      relojMadera = setTimeout(function () {
        relojMadera = null;
        var t = dedicatoriaBase();
        if (t) grabarEnLaMadera(t);
      }, 200);
    }
    if (typeof MutationObserver === "function") {
      var huecoEditor = RAIZ.querySelector("[data-pzx-editor]");
      // El editor incrustado en la galeria.
      if (huecoEditor) new MutationObserver(repasarMadera).observe(huecoEditor, { childList: true, subtree: true });
      // Y el que se abre en ventana, que cuelga del final de la pagina.
      new MutationObserver(repasarMadera).observe(document.body, { childList: true });
    }

    /**
     * LA SEGUNDA DEDICATORIA: la que va grabada en la madera.
     *
     * Son DOS textos distintos y cada uno tiene su sitio. El del paso de
     * arriba va siempre abajo en el marco, haya base o no. Este solo existe
     * si hay base, porque es la madera lo que se graba, y aparece justo
     * debajo de elegirla.
     *
     * Quitar la base borra lo escrito a proposito: dejarlo guardado mandaria
     * al pedido un grabado sobre una pieza que el cliente ya no lleva.
     */
    function limpiarDediBase() {
      if (campoDediBase && campoDediBase.value) campoDediBase.value = "";
      contarDediBase();
      prop("dedibase", "", false);
      if (visor3d && typeof visor3d.setDedication === "function") {
        try { visor3d.setDedication(""); } catch (e) { /* ya no hay visor */ }
      }
      grabarEnLaMadera("");
    }

    /**
     * El si/no del grabado. Decir «No» no es solo esconder el campo: hay que
     * borrar lo que hubiera escrito, o el pedido se llevaria un grabado que
     * el cliente ha dicho que no quiere —y cobrado, porque la linea del
     * espejo va con el.
     */
    function elegirDediBase(si, sinFoco) {
      estado.dedibase = !!si;
      // Cuando el recargo lo lleva una opcion del producto, decir Si o No es
      // cambiar de variante: el precio de arriba y el del carrito se mueven
      // solos, sin una segunda forma de cobrar que mantener.
      if (dediBaseEsOpcion) ponerValorOpcion(si ? dediBaseValSi : dediBaseValNo);
      var sel = null;
      opsDediBase.forEach(function (o) {
        if ((o.dataset.pzxDedibaseOp === "si") === !!si) sel = o;
      });
      if (sel) marcar(opsDediBase, sel);
      if (cajaCampoDedi) cajaCampoDedi.hidden = !si;
      // La seccion deja el campo DESHABILITADO cuando el grabado se cobra:
      // asi nadie escribe —ni manda al pedido— un grabado que no ha pedido.
      // Decir «Si» es justo lo que lo abre.
      if (campoDediBase) {
        if (si) campoDediBase.removeAttribute("disabled");
        else campoDediBase.setAttribute("disabled", "disabled");
      }
      if (!si) {
        limpiarDediBase();
        // Y QUE NO VUELVA POR LA PUERTA DE ATRAS. Al elegir base, lo que
        // habia escrito en el marco se guarda para devolverlo si el cliente
        // se arrepiente de la peana. Pero si acaba de decir que NO quiere
        // grabado, ese texto ya no lo quiere en ningun sitio: se olvida la
        // copia y se vacia tambien el del marco, que es donde el widget lo
        // seguiria leyendo al guardar.
        olvidarDedicatoriaCuadro();
      } else if (campoDediBase && !sinFoco) campoDediBase.focus();
      pintar();
    }
    opsDediBase.forEach(function (o) {
      o.addEventListener("click", function () {
        elegirDediBase(o.dataset.pzxDedibaseOp === "si");
      });
    });
    // AL LLEGAR CON ?variant= DE OTRA VISITA, manda la variante y no el
    // boton: si lo que hay elegido ya lleva dedicatoria, la tarjeta tiene
    // que nacer en «Si» y el campo abierto. Solo se toca en ese caso; la
    // ficha ya nace en «No».
    if (dediBaseEsOpcion && valorOpcionPuesto() === dediBaseValSi) {
      elegirDediBase(true, true);
    }
    if (seCobraDedi) {
      var etqDediPrecio = bBase.querySelector("[data-pzx-dedibase-precio]");
      if (etqDediPrecio) {
        etqDediPrecio.textContent = "+" + dinero(centimos(cajaDediBase.dataset.pzxPrecio));
      }
    }

    /**
     * UNA DEDICATORIA, Y LA MANDA LA MADERA.
     *
     * Hay dos sitios donde se puede grabar un texto: el cuadro y la peana.
     * Pedir los dos en el mismo pedido no tiene sentido —es el mismo regalo
     * y el mismo texto— y encima se cobraba dos veces, cada uno por su lado.
     *
     * Con base puesta manda la madera: el paso del cuadro se esconde y, si
     * ya habia algo escrito ahi, se pasa tal cual al grabado de la peana y
     * se apaga el del cuadro (que es una variante, asi que apagarlo tambien
     * quita su cargo). Al quitar la base, el paso del cuadro vuelve, y con
     * el la eleccion que tenia: lo escrito sigue en el campo del widget, que
     * no se toca.
     *
     * El texto puede venir mas largo de lo que admite la madera (50 contra
     * 30): se corta por donde el campo corta de todas formas.
     */
    var conBaseAntes = !!estado.base;

    function cajaDediCuadro() {
      var c = nodoDedi();
      return c ? (c.closest(".pz-prod__bloque") || c) : null;
    }

    function pulsarDediCuadro(cual) {
      var c = nodoDedi();
      var b = c && c.querySelector('[data-pzx-dedi-op="' + cual + '"]');
      if (b && !b.classList.contains("is-sel")) b.click();
    }

    var cambiandoDedi = false;

    function mandaLaMadera() {
      var bloque = cajaDediCuadro();
      if (!bloque) return;
      var hayBase = !!estado.base;
      // MIENTRAS LOS PASOS SIGAN TAPADOS, AQUI NO SE TOCA NADA.
      //
      // Hasta que el cliente elige modalidad, todo lo que va detras esta
      // escondido a proposito (`taparElResto`). Este repaso corre en cada
      // repintado y, sin base, dejaba el paso de la dedicatoria a la vista:
      // se veia antes de elegir entre original y con IA, cuando todavia no
      // toca. Destapar es cosa de `destapar()`, no de aqui.
      if (pasosTapados && pasosTapados.indexOf(bloque) !== -1) return;
      // SOLO AL CAMBIAR, Y SIN REENTRAR. Esto corre en cada repintado, y lo
      // de dentro —elegir el grabado, apagar la dedicatoria del cuadro—
      // vuelve a repintar: sin las dos guardas se llama a si mismo hasta
      // reventar la pila, y con ella se lleva el resto del repintado.
      if (cambiandoDedi) return;
      if (hayBase === conBaseAntes) {
        // Por si alguien mas ha tocado el paso (un reinicio, el destapado):
        // se deja tapado o destapado segun toque, y nada mas.
        if (bloque.hidden !== hayBase) bloque.hidden = hayBase;
        return;
      }
      conBaseAntes = hayBase;
      cambiandoDedi = true;
      try {
        if (hayBase) {
          // SON DOS DEDICATORIAS DISTINTAS Y NO SE PASAN NADA.
          //
          // Antes, al elegir peana, lo escrito en el marco se copiaba a la
          // madera y se guardaba una copia para devolverlo si el cliente
          // quitaba la base. Se ha quitado a proposito: el texto aparecia
          // solo en un sitio donde nadie lo habia escrito, y volvia a salir
          // despues de haberlo borrado. Cada paso se escribe en su campo.
          bloque.hidden = true;
          pulsarDediCuadro("no");
          // Y SE BORRA AQUI, no solo con el clic de arriba: ese boton puede
          // estar ya en "no" —entonces no hay clic que dar— y el texto se
          // quedaba vivo en un paso escondido, pintandose en el lienzo y
          // viajando al pedido de un cuadro que ya no lleva dedicatoria,
          // porque con peana la dedicatoria se graba en la madera.
          olvidarDedicatoriaCuadro();
        } else {
          // Vuelve a verse el paso del marco, y nada mas: lo que el cliente
          // grabo en la madera se queda en la madera (y `revisarDediBase` lo
          // borra, porque sin peana no hay donde grabarlo).
          bloque.hidden = false;
        }
      } finally {
        cambiandoDedi = false;
      }
    }
    bBase._mandaLaMadera = mandaLaMadera;

    function revisarDediBase() {
      if (!cajaDediBase) return;
      var hay = baseFija || !!estado.base;
      cajaDediBase.hidden = !hay;
      if (!hay) {
        // Sin base no hay madera que grabar: se apaga el extra, se vuelve al
        // «No» y se borra lo escrito.
        estado.dedibase = false;
        if (opsDediBase.length) {
          var no = null;
          opsDediBase.forEach(function (o) { if (o.dataset.pzxDedibaseOp === "no") no = o; });
          if (no) marcar(opsDediBase, no);
          if (cajaCampoDedi) cajaCampoDedi.hidden = true;
          if (campoDediBase) campoDediBase.setAttribute("disabled", "disabled");
        }
        limpiarDediBase();
      }
      var vale = hay && !!dedicatoriaBase() && (!seCobraDedi || estado.dedibase);
      prop("dedibase", dedicatoriaBase(), vale);
      // El si/no y el cambio de base pasan por aqui: la madera los sigue.
      grabarEnLaMadera(dedicatoriaBase());
    }
    bBase._revisarDediBase = revisarDediBase;

    if (campoDediBase) {
      campoDediBase.addEventListener("input", function () {
        contarDediBase();
        prop("dedibase", dedicatoriaBase(), !!dedicatoriaBase());
        // Se graba al vuelo: el visor rehace la textura de la madera sin
        // volver a montar nada.
        if (visor3d && typeof visor3d.setDedication === "function") {
          try { visor3d.setDedication(dedicatoriaBase()); } catch (e) { /* sin visor */ }
        }
        grabarEnLaMadera(dedicatoriaBase());
      });
    }
  }

  // --- tipografia de los pasos ----------------------------------------------
  /**
   * TODOS LOS PASOS, UN PUNTO MAS PEQUEÑOS.
   *
   * Se pidio bajar 8px. Aplicado al pie de la letra dejaria los titulos de
   * paso —17,6px— en 9,6px, que ya no se leen de un vistazo en un movil; y
   * las ayudas de 12px desaparecerian. Asi que se baja todo lo que se puede
   * sin pasar de ahi: los titulos pierden casi 5px y el resto entre 1 y 2,
   * con suelo de 11px en el texto pequeño.
   *
   * Va en una hoja inyectada y NO en el CSS de la seccion a proposito: ese
   * fichero lo publica otro proceso y sobrescribirlo le borraria lo suyo.
   * Scoped a esta ficha —cuelga de la raiz de la seccion— para no tocar las
   * otras 25 plantillas que comparten estas clases.
   */
  (function tipografiaDeLosPasos() {
    if (document.querySelector("[data-pzx-tipografia]")) return;
    var hoja = document.createElement("style");
    hoja.setAttribute("data-pzx-tipografia", "1");
    hoja.textContent = [
      // Los titulos de paso se quedan pequenos; lo que crece es la opcion.
      // El del paso de la tarjeta entra aqui con el `[data-pz-producto]`
      // delante a proposito: el modulo trae su propia regla con el mismo
      // peso —#gcards > .cp-row > .cp-label— y va en el cuerpo, asi que a
      // igualdad de peso ganaba ella y ese titulo se quedaba en 1.1rem.
      // TODOS LOS PASOS, LA MISMA LETRA. Los dos primeros titulos los pinta
      // el tema y venian 2px mas gordos que los nuestros; con diez pasos
      // seguidos, esa diferencia se lee como un descuido. Van los tres al
      // tamaño de los demas, que es el que aguanta las preguntas largas sin
      // partirse en dos y tres lineas.
      "[data-pz-producto] .pz-prod__opcion-nombre,",
      "[data-pz-producto] #gcards > .cp-row > .cp-label,",
      "[data-pz-producto] .pzx__tit { font-size: 0.925rem; line-height: 1.25; }",
      // El nombre de cada opcion a 16px. Las pastillas de los pasos 1 y 2
      // (tamano y personas) van en redonda; las tarjetas, en negrita.
      "[data-pz-producto] .pz-prod__pastilla > span,",
      "[data-pz-producto] .pz-prod__pastilla-txt {",
      "  font-size: 13px !important; font-weight: 400 !important; line-height: 1.25; }",
      "[data-pz-producto] .pzx__tarjeta-tit,",
      "[data-pz-producto] .pzx__comp-tit,",
      "[data-pz-producto] .pzx__pildora {",
      "  font-size: 16px; font-weight: 700; line-height: 1.25; }",
      // QUE NINGUN ROTULO SE SALGA DE SU CAJA, EN NINGUN IDIOMA.
      //
      // Los textos estan pensados en español, que es corto. El aleman tiene
      // palabras de una pieza —«Schlüsselanhänger», 17 letras— que no caben
      // en una pastilla de 69 px y se salian cortadas por la mitad. Con esto
      // la palabra se parte si no hay mas remedio y, donde el navegador sabe
      // el idioma (el `lang` del documento lo lleva), parte por silabas y con
      // guion, que es como se escribe de verdad.
      //
      // Va en la regla compartida a proposito: asi vale para los rotulos de
      // hoy y para los que vengan, sin tener que acordarse de cada sitio.
      "[data-pz-producto] .pz-prod__pastilla > span,",
      "[data-pz-producto] .pz-prod__pastilla-txt,",
      "[data-pz-producto] .pzx__tarjeta-tit,",
      "[data-pz-producto] .pzx__tarjeta-sub,",
      "[data-pz-producto] .pzx__comp-tit,",
      "[data-pz-producto] .pzx__pildora {",
      "  overflow-wrap: anywhere; hyphens: auto; }",
      // LAS DOS DEL PASO 1, 3px MENOS. "GENERAR CON IA" no cabe de ancho en
      // la tarjeta a 16px y se partia en dos lineas, mientras "ORIGINAL" iba
      // en una: dos tarjetas iguales con el texto a distinta altura. A 13px
      // entra entera. Bajan las DOS aunque solo se parta una, porque una al
      // lado de la otra con tamaños distintos se ve peor que el problema.
      "[data-pz-producto] [data-pzx-modo] .pzx__tarjeta-tit { font-size: 13px; }",
      // FUERA LA CASILLA DEL REDISEÑO. El widget cuelga debajo del recuadro
      // de subir un «Quiero rediseño en mi pedido (+2,95€)» con su casilla.
      // En esta ficha ese cargo ya tiene su propio paso —el de «¿quieres
      // solicitar algun cambio?»— y verlo dos veces, con dos cajas distintas
      // y el mismo precio, se lee como que se cobra dos veces.
      //
      // Se tapa aqui y no en el widget, que lo usan las demas fichas.
      "[data-pz-producto] .pr-customizer__redesign,",
      "[data-pz-producto] .pr-modal__redesign { display: none !important; }",
      // LOS LLAVEROS. Son tres tarjetas en una fila, asi que cada una se
      // queda en 69px de ancho util. En español «1 llavero» y «2 llaveros»
      // entran en una linea a 13px; por eso hubo aqui un `nowrap`, para que
      // las dos tarjetas tuvieran el texto a la misma altura.
      //
      // ESE `nowrap` SE HA QUITADO: en aleman la palabra es
      // «Schlüsselanhänger» y no cabe de ninguna manera, asi que el rotulo se
      // salia de la tarjeta cortado por la mitad —peor que partido en dos
      // lineas—. Ahora se parte, con guion donde el navegador sabe hacerlo.
      //
      // Y para que no vuelva el problema que arreglaba el `nowrap`, se le
      // reserva alto de dos lineas: las tres tarjetas quedan a la misma
      // altura tanto si el nombre ocupa una linea (español) como dos
      // (aleman), en vez de bailar segun el idioma.
      "[data-pz-producto] [data-pzx-comp=\"llavero\"] .pzx__tarjeta-tit {",
      "  font-size: 13px; white-space: normal; line-height: 1.15;",
      "  min-height: 2.3em; display: flex; align-items: center;",
      "  justify-content: center; text-align: center; }",
      "[data-pz-producto] [data-pzx-comp=\"llavero\"] .pzx__tarjeta-precio {",
      "  font-size: 12px; white-space: nowrap; }",
      // El precio acompana al nombre, un paso por debajo.
      "[data-pz-producto] .pzx__tarjeta-precio { font-size: 14px; font-weight: 700; }",
      "[data-pz-producto] .pzx__tarjeta-sub { font-size: 12px; }",
      // Ayudas, etiquetas y resumen siguen siendo letra chica.
      "[data-pz-producto] .pzx__ayuda,",
      "[data-pz-producto] .pzx__etq { font-size: 11px; }",
      "[data-pz-producto] .pzx__linea { font-size: 12px; }",
      "[data-pz-producto] .pzx__texto,",
      "[data-pz-producto] .pzx__area { font-size: 13px; }",
      // Escribiendo no hace falta la barra de lupas: lo que importa es ver
      // donde cae la dedicatoria, y con el teclado puesto cada pixel cuenta.
      "[data-pz-producto].pzx-tecleando .pr-modal__toolbar { display: none !important; }",
      // Arriba del todo se aparta lo nuestro y se ve la galeria del tema.
      "[data-pz-producto] .pz-prod__galeria.pzx-arriba .pzx-editor,",
      "[data-pz-producto] .pz-prod__galeria.pzx-arriba .pzx-3d,",
      "[data-pz-producto] .pz-prod__galeria.pzx-arriba .pzx-foto { display: none !important; }",
      // LA CUENTA, SIEMPRE A LA VISTA. Una barra pegada abajo con lo que
      // lleva acumulado el pedido segun se van eligiendo cosas. Solo en
      // movil: en escritorio el precio y el boton de comprar ya estan a la
      // vista en la columna de al lado y taparia el pie de la pagina.
      "[data-pz-producto] .pzx-barra-total { display: none; }",
      "@media (max-width: 1024px) {",
      "  [data-pz-producto] .pzx-barra-total {",
      "    position: fixed; left: 0; right: 0; bottom: 0; z-index: 55;",
      // Dos columnas: a la izquierda los premios —aviso, barra y pies— y a
      // la derecha el total, que cruza las dos filas y nunca se encoge.
      "    display: grid; grid-template-columns: minmax(0, 1fr) auto;",
      "    align-items: center; gap: 5px 13px; box-sizing: border-box;",
      "    padding: 9px 14px calc(9px + env(safe-area-inset-bottom, 0px));",
      "    background: var(--pzp-fondo, #fff);",
      "    border-top: 1px solid rgba(0, 0, 0, 0.08);",
      "    box-shadow: 0 -6px 18px rgba(0, 0, 0, 0.10);",
      "    font-size: 14px; color: var(--pzp-c-texto, #121212);",
      // El rojo de los premios es el que la ficha ya usa en la dedicatoria,
      // no un color nuevo: una pagina con dos rojos parecidos se ve sucia.
      "    --pzx-premio: #ef4444;",
      "    transition: transform .22s ease, opacity .22s ease; }",
      // EL TOTAL ES EL BOTON DE COMPRAR.
      //
      // Era una columna de texto —«Total» y el numero— al otro lado de una
      // raya: el precio mas grande de la pantalla y nada que tocar. Para
      // pagar habia que bajar a buscar el boton al final del formulario con
      // la decision ya tomada.
      //
      // Ahora ese mismo numero vive dentro de una pastilla negra: «COMPRAR»
      // con su carrito arriba, una raya fina, y debajo lo que se paga. La
      // raya vertical que lo separaba de los premios sigue estando, pero
      // fuera de la pastilla —dentro se leeria como parte del boton—.
      "  [data-pz-producto] .pzx-barra-total__cuenta {",
      "    grid-column: 2; grid-row: 1 / span 2; justify-self: end;",
      "    position: relative; margin-left: 13px;",
      "    font: inherit; line-height: 1.1; text-align: center; cursor: pointer;",
      "    display: grid; justify-items: center; gap: 2px;",
      // Estrecha a proposito: cada pixel de mas aqui se lo quita al aviso de
      // los premios, que es de una sola linea y se corta con puntos.
      "    padding: 8px 12px; border: 0; border-radius: 15px;",
      "    background: var(--pzp-c-acento, #121212); color: #fff;",
      "    -webkit-tap-highlight-color: transparent;",
      "    transition: transform .12s ease, opacity .15s ease; }",
      "  [data-pz-producto] .pzx-barra-total__cuenta::before {",
      "    content: ''; position: absolute; left: -13px; top: 4px; bottom: 4px;",
      "    width: 1px; background: rgba(0, 0, 0, 0.08); }",
      "  [data-pz-producto] .pzx-barra-total__cuenta:active { transform: scale(.97); }",
      "  [data-pz-producto] .pzx-barra-total__cuenta[disabled] { opacity: .45; cursor: default; }",
      "  [data-pz-producto] .pzx-barra-total__etq {",
      "    display: flex; align-items: center; gap: 6px; color: #fff;",
      "    font-weight: 800; font-size: 12.5px; letter-spacing: .02em; }",
      "  [data-pz-producto] .pzx-barra-total__carro {",
      "    width: 15px; height: 15px; display: block; }",
      // El numero, debajo de su raya: lo mismo que enseña la pastilla del
      // encabezado de este fichero, pero en blanco sobre negro.
      "  [data-pz-producto] .pzx-barra-total strong {",
      "    width: 100%; padding-top: 3px; margin-top: 1px;",
      "    border-top: 1px solid rgba(255, 255, 255, 0.3);",
      "    font-size: 20px; font-weight: 800; color: #fff;",
      "    font-variant-numeric: tabular-nums; }",
      // EL AVISO. Lo que falta y para que, con el importe y el premio en
      // rojo: son las dos palabras que se leen de un vistazo.
      "  [data-pz-producto] .pzx-premios__aviso {",
      "    grid-column: 1; grid-row: 1; margin: 0; padding-right: 12px;",
      "    font-size: 12px; line-height: 1.25;",
      // En una linea y cortado con puntos suspensivos si no cabe: si parte
      // en dos, la barra crece cada vez que cambia el texto.
      "    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }",
      "  [data-pz-producto] .pzx-premios__aviso b {",
      "    font-weight: 800; color: var(--pzx-premio, #ef4444); }",
      // LA BARRA Y SUS TRES PARADAS. Los tramos son IGUALES aunque los
      // importes no lo sean: con la escala real (35, 50 y 60 sobre 60) las
      // tres paradas se amontonan en el ultimo tercio y la barra se ve
      // torcida. Lo que cuenta aqui es cuanto queda para la siguiente.
      "  [data-pz-producto] .pzx-premios { grid-column: 1; grid-row: 2;",
      // El hueco de la derecha da sitio a la ULTIMA parada, que esta al
      // final de la barra: sin el, su importe no cabria centrado debajo y
      // habia que pegarlo al borde —y entonces las tres paradas dejaban de
      // estar a la misma distancia—. Con el hueco, los tres importes van
      // centrados bajo su icono y separados exactamente lo mismo: un tercio
      // de la barra entre uno y otro.
      "    min-width: 0; padding-right: 30px; display: grid; gap: 8px; }",
      "  [data-pz-producto] .pzx-premios__pista {",
      "    position: relative; height: 8px; border-radius: 999px;",
      "    background: #e9ecef; }",
      "  [data-pz-producto] .pzx-premios__lleno {",
      "    position: absolute; left: 0; top: 0; bottom: 0; border-radius: 999px;",
      "    background: var(--pzx-premio, #ef4444);",
      // SUBIR Y BAJAR NO SE PARECEN. Al avanzar, una curva que sale rapida y
      // frena al llegar: se lee como «ya casi». Al retroceder, una corta y
      // seca, que no invita a quedarse mirandola.
      "    transition: width .52s cubic-bezier(.22, 1, .36, 1); }",
      "  [data-pz-producto] .pzx-premios.is-bajando .pzx-premios__lleno {",
      "    transition: width .3s cubic-bezier(.4, 0, 1, 1); }",
      "  [data-pz-producto] .pzx-premios__hito {",
      "    position: absolute; top: 50%; width: 20px; height: 20px;",
      "    margin: -10px 0 0 -10px; border-radius: 50%;",
      "    display: grid; place-items: center;",
      "    background: #e9ecef; color: #adb5bd;",
      // El aro del color del fondo despega la parada de la barra.
      "    box-shadow: 0 0 0 2px var(--pzp-fondo, #fff);",
      "    transition: background .25s ease, color .25s ease; }",
      "  [data-pz-producto] .pzx-premios__hito.is-logrado {",
      "    background: var(--pzx-premio, #ef4444); color: #fff; }",
      "  [data-pz-producto] .pzx-premios__hito svg { width: 12px; height: 12px; display: block; }",
      "  [data-pz-producto] .pzx-premios__hito .pzx-premios__ok { display: none; }",
      "  [data-pz-producto] .pzx-premios__hito.is-logrado .pzx-premios__ok { display: block; }",
      "  [data-pz-producto] .pzx-premios__hito.is-logrado .pzx-premios__regalo { display: none; }",
      // LOS PIES. Cada parada con su importe y su premio, debajo y
      // centrados; el ultimo se pega al borde derecho porque centrado se
      // saldria de la pantalla.
      "  [data-pz-producto] .pzx-premios__pies { position: relative; height: 25px; }",
      "  [data-pz-producto] .pzx-premios__pie {",
      "    position: absolute; top: 0; display: grid; gap: 0;",
      "    transform: translateX(-50%); text-align: center; white-space: nowrap;",
      "    color: var(--pzp-c-nota, #6b6b6b); }",
      "  [data-pz-producto] .pzx-premios__pie b {",
      "    font-size: 11.5px; font-weight: 800; font-variant-numeric: tabular-nums; }",
      "  [data-pz-producto] .pzx-premios__pie em {",
      "    font-style: normal; font-size: 9.5px; line-height: 1.2; }",
      "  [data-pz-producto] .pzx-premios__pie.is-logrado { color: var(--pzp-c-texto, #121212); }",
      "  [data-pz-producto] .pzx-premios__pie.is-logrado em { opacity: .7; }",
      // CON EL TECLADO ABIERTO SE APARTA. Queda media pantalla, y ese trozo
      // es para el cuadro y para lo que se esta escribiendo. Se mira el
      // teclado y no el foco: escribiendo la tarjeta el campo se queda
      // enfocado despues, y la barra no volvia nunca.
      "  [data-pz-producto].pzx-teclado .pzx-barra-total { display: none !important; }",
      // YA SE VE EL TOTAL DE VERDAD, LA BARRA SE APARTA. La clase la pone y
      // la quita `vigilarTotalDelResumen()` segun el total del ultimo paso
      // entre o salga de pantalla.
      "  [data-pz-producto].pzx-total-a-la-vista .pzx-barra-total {",
      "    transform: translateY(125%); opacity: 0; pointer-events: none; }",
      "}",
      // EL PRECIO YA LO DICE EL TITULO DEL PASO. «Tarjeta con dedicatoria +
      // (2,99€)» esta justo encima; repetirlo debajo del «Si» hacia leer dos
      // veces el mismo cargo y parecia que se sumaban. Se tapa aqui y no en
      // el snippet de la tarjeta, que es de todas las fichas.
      "[data-pz-producto] #gcards .cp-toggle .cp-tarjeta-precio { display: none; }",
      // EL PREMIO RECIEN GANADO. Dos piezas que viven fuera de la ficha,
      // colgadas del `body`: el cartel que dice lo que se ha ganado y la
      // ficha que sale volando hacia el carrito. Por encima de todo lo
      // demas —cajon, WhatsApp, avisos— porque dura un segundo y medio y
      // es lo unico que importa mientras tanto.
      ".pzx-premio-aviso {",
      "  position: fixed; left: 50%; z-index: 2147483009;",
      "  display: flex; align-items: center; gap: 8px; pointer-events: none;",
      "  padding: 9px 15px; border-radius: 999px;",
      "  background: #121212; color: #fff;",
      // El rotulo iba en una sola linea. En español cabe («Ya tienes el
      // llavero gratis»), pero en aleman —«Du bekommst einen gratis
      // Schlüsselanhänger»— se salia por los dos lados de la pantalla. Se le
      // deja partir y se le pone tope de ancho.
      "  font-size: 13px; font-weight: 700; white-space: normal;",
      "  max-width: min(92vw, 420px); text-align: center; line-height: 1.25;",
      "  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.30); }",
      ".pzx-premio-aviso i { display: flex; }",
      ".pzx-premio-aviso svg { width: 15px; height: 15px; display: block;",
      "  color: var(--pzx-premio, #ef4444); }",
      // Al perder un premio el mismo cartel, pero en gris: es un aviso, no
      // una regañina. El rojo esta para lo que se gana.
      ".pzx-premio-aviso--fuera svg { color: #9ca3af; }",
      ".pzx-premio-vuela {",
      "  position: fixed; z-index: 2147483010; width: 46px; height: 46px;",
      "  margin: -23px 0 0 -23px; border-radius: 50%; pointer-events: none;",
      "  display: grid; place-items: center;",
      "  background: var(--pzx-premio, #ef4444); color: #fff;",
      "  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.28); }",
      ".pzx-premio-vuela svg { width: 24px; height: 24px; display: block; }",
      // LA ESTELA. Dos copias por detras, mas chicas y casi transparentes,
      // por el mismo camino y con unos milisegundos de retraso. Es lo que
      // convierte un cambio de sitio en movimiento.
      ".pzx-premio-vuela--estela { opacity: .45; filter: blur(.4px); }",
      // EL RECORRIDO DENTRO DEL CAJON. Las reglas de arriba cuelgan todas de
      // `[data-pz-producto]` y el cajon vive fuera de la ficha, colgado del
      // `body`: hay que repetir las que lo visten. Mismos numeros, mismo
      // aspecto; lo unico que cambia es por donde entra el color.
      ".pzx-cajon-premios { --pzx-premio: #ef4444; padding: 14px 18px 8px; }",
      ".pzx-cajon-premios .pzx-premios__aviso {",
      "  margin: 0 0 9px; font-size: 12px; line-height: 1.25;",
      "  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }",
      ".pzx-cajon-premios .pzx-premios__aviso b {",
      "  font-weight: 800; color: var(--pzx-premio, #ef4444); }",
      ".pzx-cajon-premios .pzx-premios {",
      "  min-width: 0; padding-right: 30px; display: grid; gap: 8px; }",
      ".pzx-cajon-premios .pzx-premios__pista {",
      "  position: relative; height: 8px; border-radius: 999px; background: #e9ecef; }",
      ".pzx-cajon-premios .pzx-premios__lleno {",
      "  position: absolute; left: 0; top: 0; bottom: 0; border-radius: 999px;",
      "  background: var(--pzx-premio, #ef4444);",
      "  transition: width .52s cubic-bezier(.22, 1, .36, 1); }",
      ".pzx-cajon-premios .pzx-premios.is-bajando .pzx-premios__lleno {",
      "  transition: width .3s cubic-bezier(.4, 0, 1, 1); }",
      ".pzx-cajon-premios .pzx-premios__hito {",
      "  position: absolute; top: 50%; width: 20px; height: 20px;",
      "  margin: -10px 0 0 -10px; border-radius: 50%; display: grid; place-items: center;",
      "  background: #e9ecef; color: #adb5bd; box-shadow: 0 0 0 2px #fff;",
      "  transition: background .25s ease, color .25s ease; }",
      ".pzx-cajon-premios .pzx-premios__hito.is-logrado {",
      "  background: var(--pzx-premio, #ef4444); color: #fff; }",
      ".pzx-cajon-premios .pzx-premios__hito svg { width: 12px; height: 12px; display: block; }",
      ".pzx-cajon-premios .pzx-premios__hito .pzx-premios__ok { display: none; }",
      ".pzx-cajon-premios .pzx-premios__hito.is-logrado .pzx-premios__ok { display: block; }",
      ".pzx-cajon-premios .pzx-premios__hito.is-logrado .pzx-premios__regalo { display: none; }",
      ".pzx-cajon-premios .pzx-premios__pies { position: relative; height: 25px; }",
      ".pzx-cajon-premios .pzx-premios__pie {",
      "  position: absolute; top: 0; display: grid; gap: 0;",
      "  transform: translateX(-50%); text-align: center; white-space: nowrap;",
      "  color: #6b7280; }",
      ".pzx-cajon-premios .pzx-premios__pie b {",
      "  font-size: 11.5px; font-weight: 800; font-variant-numeric: tabular-nums; }",
      ".pzx-cajon-premios .pzx-premios__pie em {",
      "  font-style: normal; font-size: 9.5px; line-height: 1.2; }",
      ".pzx-cajon-premios .pzx-premios__pie.is-logrado { color: #121212; }",
      ".pzx-cajon-premios .pzx-premios__pie.is-logrado em { opacity: .7; }",
      // EL ARO que se abre desde la parada al ganarla: a 20px, cambiar de
      // color no se ve; una onda, si.
      ".pzx-premio-aro {",
      "  position: fixed; z-index: 2147483008; width: 20px; height: 20px;",
      "  margin: -10px 0 0 -10px; border-radius: 50%; pointer-events: none;",
      "  border: 2px solid var(--pzx-premio, #ef4444); }",
      // SI EL MOVIMIENTO MOLESTA, NO HAY MOVIMIENTO. El JS ya se salta los
      // vuelos; esto cierra el otro lado, el de las transiciones.
      "@media (prefers-reduced-motion: reduce) {",
      "  [data-pz-producto] .pzx-barra-total,",
      "  [data-pz-producto] .pzx-premios__lleno,",
      "  [data-pz-producto] .pzx-premios.is-bajando .pzx-premios__lleno,",
      "  [data-pz-producto] .pzx-premios__hito { transition: none !important; }",
      "  .pzx-premio-aro, .pzx-premio-vuela--estela { display: none !important; }",
      "}",
      // EL CARRITO FLOTANTE, ENCIMA DEL WHATSAPP. Los dos botones redondos
      // viven pegados a la misma esquina y el del carrito, en el suelo
      // (bottom: 18px), caia justo sobre el total de la barra: el numero
      // quedaba tapado. Se sube por encima del de WhatsApp —que esta en
      // bottom: 90px y mide 45— dejando 12px de aire, y se le alinea el
      // centro con el suyo (right: 30 + 45/2 = 52,5, menos los 28 de medio
      // boton = 24,5) para que la columna salga recta.
      //
      // Va con `!important` porque el cajon pone su sitio con la misma
      // fuerza desde su propia hoja, y no esta dicho quien de las dos carga
      // antes. Y va sin envolver en `[data-pz-producto]` a proposito: el
      // boton cuelga del `body`, fuera de la ficha. Esta hoja solo existe
      // en esta pagina, asi que no se escapa a ningun otro sitio.
      // Y SE VE SIEMPRE, tambien con el carrito vacio: el cajon lo esconde
      // mientras no haya lineas, y justo al ganar el PRIMER premio el boton
      // no tenia caja —la animacion mide su tamaño antes de volar— y el
      // vuelo se iba a la esquina de arriba. Aqui se queda puesto.
      //
      // El z-index empata con el velo del cajon (2147483000): el boton
      // cuelga del `body` DESPUES del cajon, asi que con el mismo numero
      // gana el. El panel del cajon va por encima (2147483001) y se sigue
      // leyendo igual.
      //
      // Solo en movil: en escritorio no hay barra de premios abajo, asi que
      // el cajon se queda con su sitio y sus reglas de siempre.
      "@media (max-width: 1024px) {",
      "  .cd-flotante { display: inline-flex !important; z-index: 2147483000 !important; }",
      // ARRIBA A LA DERECHA. Es donde el cliente ya busca el carrito —ahi
      // esta el de la cabecera— asi que cuando la cabecera se va de
      // pantalla, este ocupa su sitio y no hay que aprender uno nuevo.
      "  .cd-flotante[data-pos=\"abajo-derecha\"] {",
      "    top: 12px !important; right: 12px !important; bottom: auto !important; }",
      // Y SOLO CUANDO HACE FALTA: con el carrito de la cabecera a la vista
      // sobran dos carritos en la misma esquina. La clase la pone y la quita
      // `cestaVaciaSinNumero` segun donde este la pagina.
      "  .cd-flotante.pzx-flot-fuera { display: none !important; }",
      // Con el carrito vacio el distintivo pone «0», que no es informacion.
      // La clase la pone `cestaVaciaSinNumero`.
      "  .cd-flotante.pzx-sin-cuenta .cd-flotante-num { display: none !important; }",
      "}",
      // EL "NO", SIN TACHON Y CON LETRA GRANDE. Las opciones de no querer
      // algo llevaban un circulo rojo tachado enorme y debajo la palabra en
      // letra chica: el dibujo pesaba mas que la respuesta. Fuera el icono y
      // la palabra al tamaño que le toca, para que las dos opciones se lean
      // de un vistazo y con el mismo peso.
      "[data-pz-producto] .pzx-no-grande img { display: none !important; }",
      // La letra grande no es del "no", es de la opcion QUE SE QUEDA SIN
      // DIBUJO: asi las dos de la pareja pesan lo mismo. Donde el "si"
      // enseña el producto, el dibujo ya hace ese trabajo y el texto se
      // queda como esta.
      "[data-pz-producto] .pzx-letra-grande .pzx__tarjeta-tit,",
      "[data-pz-producto] .pzx-letra-grande .cp-tarjeta-tit {",
      "  font-size: 30px !important; font-weight: 800 !important;",
      "  line-height: 1.1; letter-spacing: 0.02em; }",
      // LA TARJETA, EN EL MARCO. Al elegir una tarjeta de dedicatoria su
      // vista previa sube al recuadro de arriba —ahi es donde el cliente
      // esta mirando— y se aparta todo lo demas: el editor del cuadro, el
      // visor de la base y el carrusel del tema. Nada se desmonta: se tapa.
      "[data-pz-producto] .pzx-tarjeta { width: 100%; flex: 1 1 auto; min-height: 0;",
      "  display: flex; align-items: center; justify-content: center; }",
      "[data-pz-producto] .pzx-tarjeta[hidden] { display: none !important; }",
      // Ancho atado al alto del recuadro por la proporcion de la tarjeta
      // (886x591), para que entre de alto sin recortarla.
      "[data-pz-producto] .pzx-tarjeta .cp-preview {",
      "  width: min(100%, calc(var(--pzx-gal-alto, 340px) * 1.4)); margin: 0 auto; }",
      "[data-pz-producto] .pz-prod__galeria.pzx-contarjeta .pzx-editor,",
      "[data-pz-producto] .pz-prod__galeria.pzx-contarjeta .pzx-3d,",
      "[data-pz-producto] .pz-prod__galeria.pzx-contarjeta .pzx-foto,",
      "[data-pz-producto] .pz-prod__galeria.pzx-contarjeta .pz-prod__tira,",
      "[data-pz-producto] .pz-prod__galeria.pzx-contarjeta .pz-prod__flecha,",
      "[data-pz-producto] .pz-prod__galeria.pzx-contarjeta .pz-prod__contador,",
      "[data-pz-producto] .pz-prod__galeria.pzx-contarjeta .pz-prod__miniaturas { display: none !important; }",
      // El recuadro necesita su caja aunque el editor este tapado: en lo mas
      // alto de la pagina `is-editando` se quita, y con el se iba el alto.
      "@media (max-width: 1024px) {",
      "  [data-pz-producto] .pz-prod__galeria.pzx-contarjeta .pz-prod__marco {",
      "    height: var(--pzx-gal-alto, 42vh); max-height: var(--pzx-gal-alto, 42vh);",
      "    overflow: hidden; display: flex; flex-direction: column; justify-content: center; }",
      "}",
    ].join("\n");
    document.head.appendChild(hoja);
  })();

  // --- numeros de paso seguidos ---------------------------------------------
  /**
   * El numero de cada paso lo escribe el merchant en su bloque y es fijo.
   * Pero el paso de los cambios SOLO sale cuando se genera con IA: eligiendo
   * la foto original desaparecia y la ficha se quedaba en 1, 2, 3, 5, 6...,
   * con un hueco que se lee como «me he saltado algo».
   *
   * Asi que el numero se reparte por lo que de verdad se ve: se cuentan los
   * pasos visibles de arriba abajo y cada uno recibe el que le toca. Al
   * volver a IA el paso reaparece y todos vuelven solos a su sitio. En el
   * editor del tema no se toca nada: alli no se esconde ningun paso.
   */
  (function numerosSeguidos() {
    if (!RAIZ || EN_EDITOR) return;
    function visible(e) {
      return !e.hidden && e.offsetParent !== null;
    }
    var pendiente = false;
    function numerar() {
      pendiente = false;
      var n = 0;
      // Los dos sitios donde vive un numero de paso, en el orden en que se
      // leen: el de las opciones del producto (tamano, personas, tipo) va
      // dentro de su propia opcion, y el de los pasos propios, en la caja
      // del bloque. Cada uno se mira donde le toca para saber si se ve.
      var huecos = RAIZ.querySelectorAll(".pz-prod__opcion-num, .pz-prod__paso-num");
      Array.prototype.forEach.call(huecos, function (hueco) {
        var caja = hueco.closest(".pz-prod__opcion") || hueco.closest(".pz-prod__bloque") || hueco.parentElement;
        // Solo se reparten numeros: si alguien escribe una letra o un simbolo
        // en el ajuste, ese paso se queda exactamente como lo puso.
        if (!hueco.getAttribute("data-pzx-num")) {
          if (!/^\s*\d+\s*$/.test(hueco.textContent || "")) return;
          hueco.setAttribute("data-pzx-num", "1");
        }
        if (!caja || !visible(caja)) return;
        n += 1;
        var txt = String(n);
        if (hueco.textContent !== txt) hueco.textContent = txt;
      });
    }
    function pedir() {
      if (pendiente) return;
      pendiente = true;
      (window.requestAnimationFrame || setTimeout)(numerar, 16);
    }
    // Se vigilan los ATRIBUTOS, no el contenido: el numero lo escribimos
    // nosotros y vigilando el texto se llamaria a si mismo sin parar.
    if (window.MutationObserver) {
      new MutationObserver(pedir).observe(RAIZ, {
        attributes: true, subtree: true, attributeFilter: ["hidden", "style", "class"],
      });
    }
    pedir();
    window.addEventListener("load", pedir);
  })();

  // --- caja de regalo (paso propio) -----------------------------------------
  /**
   * La caja de regalo era una casilla pequeña perdida entre los complementos.
   * Ahora es un paso con su numero y su foto, pero por dentro NO cambia nada:
   * sigue siendo `sueltos.caja`, con su variante, su precio y su sitio en el
   * espejo del carrito. Asi el cobro y el resumen siguen igual.
   */
  bCajas.forEach(function (bCaja, iCaja) {
    // Cada bloque guarda lo suyo con su propia clave: el primero mantiene
    // "caja" —asi los pedidos y el espejo del carrito siguen igual— y los
    // siguientes van numerados.
    var claveCaja = iCaja === 0 ? "caja" : "caja" + (iCaja + 1);
    /**
     * LA CAJA, CON LA MISMA CARA QUE LOS DEMAS PASOS.
     *
     * Venia como una fila —foto a un lado, pildoras de Si/No al otro— y
     * desentonaba: el resto de pasos son dos tarjetas con su imagen. Aqui se
     * rehace a tarjetas sobre el markup que ya hay, sin tocar la seccion:
     * la foto de la caja se lleva a la tarjeta del «Si» y la del «No» se
     * toma prestada del paso del llavero, que es la misma señal de prohibido
     * que el cliente ya ha visto ahi arriba.
     *
     * Cuando la seccion vuelva a estar en mis manos, esto se escribe en el
     * liquid con su propio ajuste de imagen para el «No».
     */
    (function tarjetasDeLaCaja() {
      var fila = bCaja.querySelector(".pzx__caja-fila");
      if (!fila) return;                       // ya es de tarjetas
      var pNo = bCaja.querySelector('[data-pzx-caja-op="no"]');
      var pSi = bCaja.querySelector('[data-pzx-caja-op="si"]');
      if (!pNo || !pSi) return;

      var fotoCaja = bCaja.querySelector(".pzx__caja-img");
      // Fuera la clase de la fila: dentro de una tarjeta manda el tamaño de
      // las tarjetas, el mismo que la señal de prohibido de al lado.
      if (fotoCaja) fotoCaja.className = "";
      var fotoNo = RAIZ.querySelector('[data-pzx-comp="llavero"] [data-pzx-ud=""] img');

      function tarjeta(pildora, img, conPrecio) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "pzx__tarjeta" + (pildora.classList.contains("is-sel") ? " is-sel" : "");
        b.setAttribute("role", "radio");
        b.setAttribute("aria-checked", pildora.classList.contains("is-sel") ? "true" : "false");
        b.setAttribute("data-pzx-caja-op", pildora.dataset.pzxCajaOp);
        if (img) b.appendChild(img);
        var t = document.createElement("span");
        t.className = "pzx__tarjeta-tit";
        // El texto del boton, sin el sufijo del precio: ese va aparte.
        t.textContent = (pildora.childNodes[0] && pildora.childNodes[0].nodeValue || pildora.textContent || "").trim();
        b.appendChild(t);
        if (conPrecio) {
          var pr = document.createElement("span");
          pr.className = "pzx__tarjeta-precio";
          pr.setAttribute("data-pzx-caja-precio", "");
          b.appendChild(pr);
        }
        return b;
      }

      /**
       * EL NOMBRE QUE SE OYE DE LA REJILLA, EN EL IDIOMA DE LA PAGINA.
       *
       * `data-pzx-nombre` es el nombre de la property del pedido y va en
       * español a proposito: lo lee el taller. En /de, /en e /it no puede ser
       * lo que oye el cliente, asi que ahi se traduce si es uno de los de
       * siempre (caja, base de metacrilato, enchufe) y, si no, se usa el
       * titulo del paso, que ya llega traducido. La property no se toca:
       * sigue saliendo de `pzxNombre`, mas abajo.
       */
      function nombreDeLaRejilla() {
        var nom = bCaja.dataset.pzxNombre || "";
        if (!PZ_DE && !PZ_EN && !PZ_IT) return nom || "Caja para regalo";
        switch (nom.trim().toLowerCase()) {
          case "caja para regalo":
            return PZ_DE ? "Geschenkbox" : PZ_EN ? "Gift box" : PZ_IT ? "Confezione regalo" : "Caja para regalo";
          case "base de metacrilato":
            return PZ_DE ? "Acrylglas-Ständer" : PZ_EN ? "Acrylic stand" : PZ_IT ? "Supporto in plexiglass" : "Base de metacrilato";
          case "enchufe usb":
            return PZ_DE ? "USB-Netzteil" : PZ_EN ? "USB wall adapter" : PZ_IT ? "Alimentatore USB" : "Enchufe USB";
        }
        var tit = bCaja.querySelector(".pzx__tit");
        return (tit && (tit.textContent || "").trim())
          || (PZ_DE ? "Geschenkbox" : PZ_EN ? "Gift box" : PZ_IT ? "Confezione regalo" : "Caja para regalo");
      }

      var rejilla = document.createElement("div");
      rejilla.className = "pzx__tarjetas";
      rejilla.setAttribute("role", "radiogroup");
      rejilla.setAttribute("aria-label", nombreDeLaRejilla());
      rejilla.appendChild(tarjeta(pNo, fotoNo ? fotoNo.cloneNode(true) : null, false));
      rejilla.appendChild(tarjeta(pSi, fotoCaja || null, true));

      // El texto explicativo se queda arriba, encima de las dos.
      var ayuda = fila.querySelector(".pzx__ayuda");
      if (ayuda) fila.parentNode.insertBefore(ayuda, fila);
      fila.parentNode.replaceChild(rejilla, fila);
    })();

    var opsCaja = Array.prototype.slice.call(bCaja.querySelectorAll("[data-pzx-caja-op]"));
    var sufijoCaja = bCaja.querySelector("[data-pzx-caja-precio]");
    var varCaja = bCaja.dataset.pzxVariant || "";
    var preCaja = centimos(bCaja.dataset.pzxPrecio);
    if (sufijoCaja && varCaja && preCaja > 0) sufijoCaja.textContent = "+" + dinero(preCaja);

    opsCaja.forEach(function (o) {
      o.addEventListener("click", function () {
        if (o.dataset.pzxCajaOp === "si" && varCaja) {
          estado.sueltos[claveCaja] = {
            variantId: soloDigitos(varCaja),
            precio: preCaja,
            nombre: bCaja.dataset.pzxNombre || "Caja para regalo",
          };
        } else {
          delete estado.sueltos[claveCaja];
        }
        marcar(opsCaja, o);
        pintar();
      });
    });
  });

  // --- complementos ---------------------------------------------------------
  if (bComps) {
    /**
     * EL TAMAÑO DE FOTO DEL PASO, TAMBIEN AQUI.
     *
     * Las tarjetas de este bloque viven dentro de `.pzx__comp`, y la hoja
     * del tema le pone a SUS imagenes 44px fijos. Esa regla y la de las
     * tarjetas pesan lo mismo, asi que gana la que va despues en el fichero
     * —la de 44— y el ajuste «Foto de cada opcion» no se notaba aqui.
     *
     * Se resuelve escribiendo la medida en el propio elemento, que gana a
     * las dos, en vez de meter mano en una hoja que publica otro.
     */
    (function fotosDeLasOpciones() {
      var medida = getComputedStyle(bComps).getPropertyValue("--pzx-op-img").trim();
      if (!medida) return;
      var fotos = bComps.querySelectorAll(".pzx__tarjeta img");
      for (var i = 0; i < fotos.length; i++) {
        fotos[i].style.setProperty("width", medida, "important");
        fotos[i].style.setProperty("height", medida, "important");
      }
    })();

    var filaLlavero = bComps.querySelector('[data-pzx-comp="llavero"]');
    if (filaLlavero) {
      var udsLlavero = Array.prototype.slice.call(filaLlavero.querySelectorAll("[data-pzx-ud]"));
      udsLlavero.forEach(function (u) {
        var txt = u.querySelector("[data-pzx-precio-txt]");
        // Sin el punto de separar: el precio ya cae en su propia linea
        // debajo del nombre, y el punto ahi flotando sobraba.
        if (txt && u.dataset.pzxPrecio) txt.textContent = dinero(centimos(u.dataset.pzxPrecio));
        u.addEventListener("click", function () {
          estado.llavero = u.dataset.pzxUd ? {
            variantId: soloDigitos(u.dataset.pzxVariant),
            precio: centimos(u.dataset.pzxPrecio),
            nombre: u.dataset.pzxNombre || "Llavero",
            // Cuantos lleva: de ahi sale cuantos huecos de foto se piden.
            uds: Number(u.dataset.pzxUd) || 0,
          } : null;
          marcar(udsLlavero, u);
          revisarFotosLlavero();
          pintar();
        });
      });
    }

    Array.prototype.slice.call(bComps.querySelectorAll("[data-pzx-check]")).forEach(function (chk) {
      var fila = chk.closest("[data-pzx-comp]");
      var txt = fila.querySelector("[data-pzx-precio-txt]");
      if (txt && fila.dataset.pzxPrecio) txt.textContent = " · " + dinero(centimos(fila.dataset.pzxPrecio));
      chk.addEventListener("change", function () {
        var clave = fila.dataset.pzxComp;
        if (chk.checked) {
          estado.sueltos[clave] = {
            variantId: soloDigitos(fila.dataset.pzxVariant),
            precio: centimos(fila.dataset.pzxPrecio),
            nombre: fila.dataset.pzxNombre || clave,
          };
        } else {
          delete estado.sueltos[clave];
        }
        pintar();
      });
    });

    /**
     * LAS FOTOS DEL LLAVERO.
     *
     * Un hueco por llavero elegido: con dos, dos fotos, que no tienen por que
     * ser la misma. La imagen se sube al servidor nada mas elegirla —igual
     * que la del cuadro— y al pedido viaja su URL; mandar el fichero en una
     * property no se puede, y una `blob:` del navegador no la puede abrir
     * nadie en produccion.
     *
     * Al quitar llaveros, el hueco que sobra se vacia: si no, el pedido
     * llevaria la foto de un llavero que ya no se compra.
     */
    var cajaFotos = bComps.querySelector("[data-pzx-llavero-fotos]");

    function limpiarFoto(hueco) {
      var campo = hueco.querySelector("[data-pzx-prop-foto]");
      var vista = hueco.querySelector("[data-pzx-llavero-vista]");
      var file = hueco.querySelector("[data-pzx-llavero-file]");
      if (campo) { campo.value = ""; campo.setAttribute("disabled", "disabled"); }
      if (file) file.value = "";
      if (vista) { vista.style.backgroundImage = ""; vista.textContent = textoVacio(hueco); }
      hueco.classList.remove("is-puesta");
    }

    function textoVacio(hueco) {
      return hueco.dataset.pzxVacio || (PZ_DE ? "Foto hochladen" : PZ_EN ? "Upload photo" : PZ_IT ? "Carica foto" : "Subir foto");
    }

    function revisarFotosLlavero() {
      if (!cajaFotos) return;
      var n = (estado.llavero && estado.llavero.uds) || 0;
      cajaFotos.hidden = n < 1;
      var huecos = Array.prototype.slice.call(cajaFotos.querySelectorAll("[data-pzx-llavero-foto]"));
      huecos.forEach(function (h) {
        var toca = Number(h.dataset.pzxLlaveroFoto) <= n;
        if (!toca && !h.hidden) limpiarFoto(h);
        h.hidden = !toca;
      });
    }

    if (cajaFotos) {
      Array.prototype.slice.call(cajaFotos.querySelectorAll("[data-pzx-llavero-foto]")).forEach(function (hueco) {
        var vista = hueco.querySelector("[data-pzx-llavero-vista]");
        // El texto de partida se guarda: hace falta para volver a dejarlo
        // como estaba cuando se quita la foto.
        hueco.dataset.pzxVacio = vista ? (vista.textContent || "").trim() : "Subir foto";
        var file = hueco.querySelector("[data-pzx-llavero-file]");
        if (!file) return;
        file.addEventListener("change", function () {
          var archivo = file.files && file.files[0];
          if (!archivo) return;
          var campo = hueco.querySelector("[data-pzx-prop-foto]");
          if (vista) { vista.style.backgroundImage = ""; vista.textContent = (PZ_DE ? "Wird hochgeladen …" : PZ_EN ? "Uploading…" : PZ_IT ? "Caricamento…" : "Subiendo…"); }
          var datos = new FormData();
          datos.append("file", archivo, archivo.name || "llavero.jpg");
          fetch(rutaProxy() + "/upload", { method: "POST", body: datos })
            .then(function (r) { return r.text(); })
            .then(function (t) {
              var d = null;
              try { d = JSON.parse(t); } catch (e) { d = null; }
              if (!d || !d.url) throw new Error((d && d.error) || (PZ_DE ? "Das Foto konnte nicht hochgeladen werden." : PZ_EN ? "We couldn't upload the photo." : PZ_IT ? "Non è stato possibile caricare la foto." : "No se pudo subir la foto."));
              if (campo) { campo.value = d.url; campo.removeAttribute("disabled"); }
              if (vista) { vista.textContent = ""; vista.style.backgroundImage = 'url("' + d.url + '")'; }
              hueco.classList.add("is-puesta");
            })
            .catch(function (e) {
              // Se deja dicho y el hueco vuelve a estar libre para reintentar.
              if (vista) vista.textContent = (!PZ_DE && !PZ_EN && !PZ_IT && e && e.message) || (PZ_DE ? "Fehler beim Hochladen" : PZ_EN ? "Upload failed" : PZ_IT ? "Caricamento non riuscito" : "No se pudo subir");
              if (campo) { campo.value = ""; campo.setAttribute("disabled", "disabled"); }
              file.value = "";
            });
        });
      });
    }

    bComps._revisarFotosLlavero = revisarFotosLlavero;
    revisarFotosLlavero();

    /** El adaptador USB solo tiene sentido con una base con luz. */
    function revisarUsb() {
      // En toda la ficha y no solo en este paso: la fila se muda al paso de
      // la base en cuanto arranca (ver `enchufeConLaBase`), y buscandola
      // aqui dentro dejaba de aparecer.
      var fila = RAIZ.querySelector('[data-pzx-solo-con-luz="1"]');
      if (!fila) return;
      // Colgaba de "admite grabado", que no tiene nada que ver: el adaptador
      // lo pide una base CON LUZ, y para eso hay una bandera propia.
      var conLuz = !!(estado.base && estado.base.luz);
      fila.hidden = !conLuz;
      if (!conLuz && estado.sueltos.usb) {
        delete estado.sueltos.usb;
        var c = fila.querySelector("[data-pzx-check]");
        if (c) c.checked = false;
      }
    }
    bComps._revisarUsb = revisarUsb;
  }

  // ------------------------------------------------------------------ pintar
  /** Todo lo que se va a cobrar, en orden. El cuadro primero. */
  /** Lo que cuesta de mas la variante con dedicatoria, en la combinacion de ahora. */
  /**
   * Lo que cuesta de verdad el retrato con IA: la diferencia entre la
   * variante con IA y la misma sin ella. Cero si el producto no las tiene.
   */
  function suplementoIA() {
    var v = varianteActual();
    var caja = nodoDedi();
    if (!v || !v.o || !caja) return 0;
    var valSin = estado.conDedi ? caja.dataset.pzxValSi : caja.dataset.pzxValNo;
    var valCon = estado.conDedi ? caja.dataset.pzxValSiIa : caja.dataset.pzxValNoIa;
    if (!valCon || !valSin) return 0;
    var eje = ejeIA(caja);
    var con = null, sin = null;
    for (var i = 0; i < VARIANTES.length; i++) {
      var o = VARIANTES[i].o || [];
      if (!mismaSalvoEje(o, v.o, eje)) continue;
      if (o[eje] === valCon) con = VARIANTES[i];
      if (o[eje] === valSin) sin = VARIANTES[i];
    }
    if (!con || !sin) return 0;
    return Math.max(0, Number(con.p) - Number(sin.p));
  }

  function suplementoDedicatoria() {
    var v = varianteActual();
    if (!v || !v.o) return 0;
    var caja = nodoDedi();
    // En que opcion vive el si/no lo dice la seccion: dejo de dar por hecho
    // que es la tercera, que es justo lo que se rompio al quitar el eje de
    // personas de toda la tienda.
    var eje = ejeIA(caja);
    var si = caja && caja.querySelector('[data-pzx-dedi-op="si"]');
    var no = caja && caja.querySelector('[data-pzx-dedi-op="no"]');
    var con = null, sin = null;
    for (var i = 0; i < VARIANTES.length; i++) {
      var o = VARIANTES[i].o || [];
      if (!mismaSalvoEje(o, v.o, eje)) continue;
      if (si && o[eje] === si.dataset.pzxValor) con = VARIANTES[i];
      if (no && o[eje] === no.dataset.pzxValor) sin = VARIANTES[i];
    }
    if (!con || !sin) return 0;
    return Math.max(0, Number(con.p) - Number(sin.p));
  }

  function lineas() {
    var out = [];
    var v = varianteActual();
    if (v) {
      out.push({ concepto: (v.o || []).join(" · "), precio: Number(v.p) || 0, principal: true });
    }
    // LO QUE PIDE CAMBIAR VIAJA CON SU LINEA.
    //
    // El texto se escribe en el paso de los cambios y se mandaba solo en la
    // linea del CUADRO, que es la que lleva las properties del formulario.
    // Pero quien rehace el diseño mira la linea del servicio —es la que le
    // dice que hay trabajo— y ahi llegaba a secas, sin saber que cambiar.
    //
    // El cuadro de texto ES el campo del pedido: lleva el `name` de la
    // property y se deshabilita al decir «No», que es como esta ficha borra
    // una property. Mirando su estado no hacen falta dos criterios.
    var areaCambios = RAIZ.querySelector("[data-pzx-cambios-texto]");
    var pedido = areaCambios && !areaCambios.disabled
      ? String(areaCambios.value || "").trim() : "";
    if (estado.cambios && bCambios && bCambios.dataset.pzxVariant) {
      out.push({
        concepto: "Cambios en el diseño",
        precio: centimos(bCambios.dataset.pzxPrecio),
        variantId: soloDigitos(bCambios.dataset.pzxVariant),
        props: pedido ? { "Cambios solicitados": pedido } : null,
      });
    }
    // EL GRABADO VIAJA CON LA BASE.
    //
    // El texto se escribe en el paso de la base, pero hasta ahora solo iba
    // en la linea del CUADRO, que es la que se lleva las properties del
    // formulario. Quien graba la madera mira su linea, y ahi la base salia
    // a secas: en el carrito y en el pedido no habia forma de saber que
    // poner. Asi que el mismo texto se cuelga tambien de la linea de la
    // base, que es el objeto que se graba.
    //
    // Se lee del campo oculto y no de `estado.dedibase`: ese campo es quien
    // decide si la dedicatoria cuenta —hay base, hay texto y, si se cobra
    // aparte, esta elegida—, y no puede haber dos criterios para lo mismo.
    var campoDB = RAIZ.querySelector('[data-pzx-prop="dedibase"]');
    var grabado = campoDB && !campoDB.disabled ? String(campoDB.value || "").trim() : "";
    if (estado.base) {
      out.push({
        concepto: estado.base.nombre,
        precio: estado.base.precio,
        variantId: estado.base.variantId,
        props: grabado ? { "Dedicatoria en la base": grabado } : null,
      });
    }
    // El grabado de la madera va como linea aparte, igual que la base: es
    // otro producto auxiliar, con su variante y su precio.
    var cajaDB = RAIZ.querySelector("[data-pzx-dedibase]");
    if (estado.dedibase && estado.base && cajaDB && soloDigitos(cajaDB.dataset.pzxVariant)) {
      var etqDB = cajaDB.querySelector(".pzx__etq");
      out.push({
        concepto: (etqDB && etqDB.textContent.trim()) || "Dedicatoria en la base",
        precio: centimos(cajaDB.dataset.pzxPrecio),
        variantId: soloDigitos(cajaDB.dataset.pzxVariant),
      });
    }
    if (estado.llavero) {
      out.push({ concepto: estado.llavero.nombre, precio: estado.llavero.precio, variantId: estado.llavero.variantId });
    }
    // Lo que haya elegido, en el orden en que se eligio: antes era una lista
    // fija —caja, taza, usb— y un paso nuevo del mismo tipo no se cobraba.
    Object.keys(estado.sueltos).forEach(function (k) {
      var c = estado.sueltos[k];
      if (c) out.push({ concepto: c.nombre, precio: c.precio, variantId: c.variantId });
    });
    return out;
  }

  /**
   * LO QUE SE LEE EN EL RESUMEN, EN EL IDIOMA DE LA PAGINA.
   *
   * El `concepto` de cada linea es lo que viaja al pedido (properties[Upsell],
   * a traves del espejo) y va en español a proposito: lo lee el taller. Unos
   * cuantos salen escritos aqui mismo o del ajuste `nombre` de los bloques
   * caja, que no se traduce, y en /de, /en e /it el resumen los enseñaba en
   * español. Se traducen SOLO al pintarlos: el concepto, el espejo y las
   * firmas no cambian. Lo que no esta en la lista ya llega traducido y pasa
   * tal cual.
   */
  function conceptoALaVista(concepto) {
    if (!PZ_DE && !PZ_EN && !PZ_IT) return concepto;
    switch (String(concepto || "").trim().toLowerCase()) {
      case "cambios en el diseño":
        return PZ_DE ? "Änderungen am Design" : PZ_EN ? "Design changes" : PZ_IT ? "Modifiche al design" : concepto;
      case "caja para regalo":
        return PZ_DE ? "Geschenkbox" : PZ_EN ? "Gift box" : PZ_IT ? "Confezione regalo" : concepto;
      case "base de metacrilato":
        return PZ_DE ? "Acrylglas-Ständer" : PZ_EN ? "Acrylic stand" : PZ_IT ? "Supporto in plexiglass" : concepto;
      case "enchufe usb":
        return PZ_DE ? "USB-Netzteil" : PZ_EN ? "USB wall adapter" : PZ_IT ? "Alimentatore USB" : concepto;
      case "dedicatoria en la base":
        return PZ_DE ? "Widmung auf dem Sockel" : PZ_EN ? "Dedication on the base" : PZ_IT ? "Dedica sulla base" : concepto;
      case "llavero":
        return PZ_DE ? "Schlüsselanhänger" : PZ_EN ? "Keychain" : PZ_IT ? "Portachiavi" : concepto;
      case "base":
        return PZ_DE ? "Sockel" : concepto;
    }
    return concepto;
  }

  function pintar() {
    pintarPrecioIA();
    // Se repasa aqui —y no al elegir modalidad— porque `destapar()` levanta
    // los pasos tapados despues, y volveria a enseñar este.
    if (bCambios && bCambios._revisarCambios) bCambios._revisarCambios();
    // Antes del grabado: decide si el paso del cuadro sigue en pie.
    if (bBase && bBase._mandaLaMadera) bBase._mandaLaMadera();
    if (bBase && bBase._revisarDediBase) bBase._revisarDediBase();
    if (bComps && bComps._revisarUsb) bComps._revisarUsb();

    var ls = lineas();
    // Lo que se cobra aparte va al espejo; el cuadro ya lo cobra su variante.
    sincronizarEspejo(ls.filter(function (l) { return !l.principal; }));

    // El precio de arriba se actualiza SIEMPRE, haya bloque de resumen o no:
    // es el numero que mira el cliente, y no puede depender de que la ficha
    // lleve puesto un paso opcional.
    var suma = ls.reduce(function (acc, l) { return acc + l.precio; }, 0);
    pintarPrecioArriba(suma);
    // EL PEDIDO ENTERO, NO SOLO ESTA PIEZA. Arriba va el precio de lo que se
    // esta configurando —eso es lo que cuesta este cuadro— y abajo, con los
    // premios, lo que lleva el pedido: lo que ya esta en el carrito mas lo
    // que se esta eligiendo, si no es lo mismo.
    firmaAhora = JSON.stringify(ls.map(function (l) { return [l.concepto, l.precio]; }));
    var yaDentro = firmaEnElCarrito !== null && firmaEnElCarrito === firmaAhora;
    pintarBarraTotal(dineroCarrito + (yaDentro ? 0 : suma));

    if (!bResumen) return;
    var cont = bResumen.querySelector("[data-pzx-lineas]");
    var firmaLs = JSON.stringify(ls.map(function (l) { return [l.concepto, l.precio]; }));
    if (cont && cont.__pztFirma !== firmaLs) {
      cont.__pztFirma = firmaLs;
      cont.innerHTML = "";
      ls.forEach(function (l) {
        var li = document.createElement("li");
        li.className = "pzx__linea";
        var a = document.createElement("span");
        a.textContent = conceptoALaVista(l.concepto);
        var b = document.createElement("span");
        b.textContent = dinero(l.precio);
        li.appendChild(a); li.appendChild(b);
        cont.appendChild(li);
      });
    }
    var total = ls.reduce(function (acc, l) { return acc + l.precio; }, 0);
    var nTotal = bResumen.querySelector("[data-pzx-total]");
    if (nTotal) nTotal.textContent = dinero(total);
  }

  /**
   * EL PRECIO DE ARRIBA = LO QUE SE VA A PAGAR.
   *
   * `pz-producto.js` pinta ahi el precio de la VARIANTE. Pero en esta ficha
   * casi todo lo que se elige —la IA, los cambios, la base, el llavero, la
   * caja— se cobra como linea aparte, asi que ese numero se quedaba corto: el
   * cliente veia 39,95 € arriba y 48,89 € al final. Aqui se le suma todo.
   *
   * El tachado y el porcentaje se recalculan sobre el MISMO ahorro en euros:
   * los complementos se suman tambien al precio comparativo, asi que lo que
   * se ahorra no cambia ni un centimo y el porcentaje baja, que es lo
   * honesto. Inventar un descuento sobre los complementos seria mentir.
   */
  /**
   * LA CUENTA DE ABAJO.
   *
   * El cliente va eligiendo cosas —tamaño, personas, IA, dedicatoria, base,
   * llavero, caja, tarjeta— y el total vivia en el resumen, al final de la
   * pagina: para saber cuanto llevaba habia que bajar del todo. Ahora va
   * pegado abajo y se actualiza con cada eleccion.
   *
   * Sale del MISMO numero que el precio de arriba y que el resumen: se le
   * pasa la suma ya calculada, no se recalcula nada aqui. Un total que se
   * saque por su cuenta acaba diciendo otra cosa que el de al lado.
   */
  /**
   * COMPRAR DESDE LA BARRA DE ABAJO.
   *
   * La pastilla negra NO abre un segundo camino al carrito: pulsa el boton
   * de comprar de siempre, que es quien guarda el diseño, rehace la
   * miniatura con base y cobra los complementos. Dos rutas al /cart/add.js
   * serian dos sitios donde se puede romper, y es justo lo que la cabecera
   * de este fichero dice que no se haga.
   *
   * Se repite lo que hace un dedo: primero el `pointerdown` —ahi se engancha
   * `guardarAlComprar`, no en el clic— y despues el clic. Si el guardado
   * tiene trabajo, deshabilita el boton en ese mismo pointerdown y el clic
   * se pierde, igual que con el dedo; el propio guardado lo vuelve a pulsar
   * cuando la imagen definitiva ya esta alojada.
   */
  function botonDeComprar() {
    return RAIZ.querySelector("[data-pz-comprar]");
  }

  function comprarDesdeLaBarra(e) {
    if (e) e.preventDefault();
    var real = botonDeComprar();
    if (!real || real.disabled) return;
    // TODAVIA NO TOCA COMPRAR. Hasta que no se elige modalidad, todo lo que
    // va detras —incluido el boton de verdad— sigue tapado a proposito
    // (ver `taparElResto`): sin esa decision no hay ni foto ni variante que
    // mandar. La pastilla esta a la vista desde el primer momento, asi que
    // aqui no se puede pulsar por ella; se lleva al cliente a la eleccion
    // que lo destapa todo, que es lo unico que acerca a comprar.
    if (real.offsetParent === null) {
      var paso = bModo && bModo.closest(".pz-prod__bloque");
      if (paso && paso.scrollIntoView) {
        paso.scrollIntoView({ block: "center", behavior: QUIETO ? "auto" : "smooth" });
      }
      return;
    }
    var ev;
    try {
      ev = new PointerEvent("pointerdown", { bubbles: true, cancelable: true });
    } catch (err) {
      ev = new Event("pointerdown", { bubbles: true, cancelable: true });
    }
    real.dispatchEvent(ev);
    // El guardado puede haberlo deshabilitado ahi mismo: entonces este clic
    // sobra, porque ya se encarga el de volver a pulsar.
    if (!real.disabled) real.click();
  }

  /**
   * Lo que le pasa al boton de verdad se ve en la pastilla: agotado sale
   * apagada, y mientras se compone el diseño dice lo mismo que dice el.
   * Sin esto el cliente pulsa, no ve nada durante unos segundos y vuelve a
   * pulsar.
   */
  function espejoDelComprar(pastilla) {
    var real = botonDeComprar();
    if (!real) return;
    var rotulo = pastilla.querySelector("[data-pzx-barra-etq]");
    function copiar() {
      pastilla.disabled = !!real.disabled;
      // El boton de verdad dice que esta guardando en el idioma de la pagina
      // (ver `guardarAlComprar`): solo con «guardando», en /de, /en e /it la
      // pastilla no se enteraba nunca. Cada idioma con su palabra; en español,
      // la misma expresion de siempre.
      var ocupado = real.disabled && (PZ_DE ? /gespeichert/i : PZ_EN ? /saving/i : PZ_IT ? /salvataggio/i : /guardando/i).test(real.textContent || "");
      if (rotulo) rotulo.textContent = ocupado
        ? (PZ_DE ? "Wird gespeichert …" : PZ_EN ? "Saving…" : PZ_IT ? "Salvataggio…" : "Guardando…")
        : (PZ_DE ? "KAUFEN" : PZ_EN ? "BUY NOW" : PZ_IT ? "ACQUISTA" : "COMPRAR");
    }
    copiar();
    if (!window.MutationObserver) return;
    new MutationObserver(copiar).observe(real, {
      attributes: true, attributeFilter: ["disabled"],
      childList: true, characterData: true, subtree: true,
    });
  }

  var barraTotal = null;
  function pintarBarraTotal(total) {
    if (!barraTotal) {
      barraTotal = RAIZ.querySelector("[data-pzx-barra-total]");
      if (!barraTotal) {
        var caja = document.createElement("div");
        caja.className = "pzx-barra-total";
        caja.setAttribute("data-pzx-barra-total", "");
        caja.appendChild(avisoDePremios());
        caja.appendChild(columnaDePremios());
        var cuenta = document.createElement("button");
        // `button` y no `submit`: la barra vive fuera del formulario y lo
        // que hace es pulsar el boton de verdad, no mandar nada por su
        // cuenta. Ver `comprarDesdeLaBarra`.
        cuenta.type = "button";
        cuenta.className = "pzx-barra-total__cuenta";
        cuenta.setAttribute("data-pzx-barra-comprar", "");
        var etq = document.createElement("span");
        etq.className = "pzx-barra-total__etq";
        // El rotulo va en su propio nodo: el espejo del boton de comprar le
        // cambia el texto y el icono tiene que quedarse donde esta.
        var rotulo = document.createElement("span");
        rotulo.setAttribute("data-pzx-barra-etq", "");
        rotulo.textContent = (PZ_DE ? "KAUFEN" : PZ_EN ? "BUY NOW" : PZ_IT ? "ACQUISTA" : "COMPRAR");
        etq.appendChild(rotulo);
        etq.appendChild(iconoCarrito());
        var num = document.createElement("strong");
        num.setAttribute("data-pzx-barra-num", "");
        // Se lee en voz alta al cambiar, sin interrumpir lo que se este
        // haciendo: es informacion, no un aviso.
        num.setAttribute("aria-live", "polite");
        cuenta.appendChild(etq);
        cuenta.appendChild(num);
        cuenta.addEventListener("click", comprarDesdeLaBarra);
        espejoDelComprar(cuenta);
        caja.appendChild(cuenta);
        RAIZ.appendChild(caja);
        barraTotal = caja;
        vigilarTotalDelResumen();
      }
    }
    var num2 = barraTotal.querySelector("[data-pzx-barra-num]");
    if (num2) pintarNumeroTotal(num2, total);
    pintarPremios(total);
    ajustarHueco();
  }

  /**
   * LOS REGALOS QUE SE VAN GANANDO.
   *
   * La barra de abajo decia cuanto llevaba gastado y nada mas. Ahora dice
   * ademas que se lleva por ese dinero y cuanto falta para lo siguiente: es
   * la misma cuenta mirada desde el otro lado, y es la que hace subir el
   * pedido.
   *
   * Los topes van en CENTIMOS, como todo el dinero de esta ficha: con
   * decimales en coma flotante, 35,00 y 34,999999 acaban siendo cosas
   * distintas y el premio no salta.
   *
   * OJO: esto solo lo ENSEÑA. Quien de verdad regala el envio, el llavero y
   * el envoltorio son los descuentos automaticos de la tienda, que miran el
   * subtotal del carrito. Si un dia se cambia un tope ahi, hay que cambiarlo
   * aqui tambien: dos sitios, y el cliente se enfada si no dicen lo mismo.
   */
  /**
   * Y SE PUEDEN CAMBIAR POR IDIOMA DESDE EL EDITOR.
   *
   * La tabla de abajo es la de fabrica. Encima de ella manda lo que el
   * merchant escriba en «Premios de la barra» (ajustes del tema), que tiene
   * una caja por idioma: asi Italia puede llevar otros importes que España
   * —alli los precios van 5 € por encima— sin tocar codigo.
   *
   * Formato, una linea por premio:
   *
   *     35 | Envio | el envio gratis | camion
   *     50 | Llavero | el llavero gratis | llave
   *     60 | Caja regalo | la caja gratis | caja
   *
   * El importe va en EUROS (se pasa a centimos aqui). El nombre corto es el
   * del pie de la parada; el largo, el del aviso («Te faltan 5 € para EL
   * LLAVERO GRATIS»). El icono es camion, llave o caja. En aleman se puede
   * añadir un quinto campo con el dativo («zum gratis Schlüsselanhänger»).
   *
   * Si la caja del idioma esta vacia, se usa la tabla de fabrica: mientras
   * nadie escriba nada, no cambia nada.
   */
  function premiosDelEditor() {
    var nodo = document.querySelector("[data-pz-premios]");
    if (!nodo) return null;
    var texto = "";
    try { texto = JSON.parse(nodo.textContent || '""'); } catch (e) { texto = nodo.textContent || ""; }
    if (!String(texto).trim()) return null;
    var fuera = [];
    String(texto).split(/\r?\n/).forEach(function (linea) {
      var l = linea.trim();
      if (!l) return;
      var p = l.split("|").map(function (x) { return x.trim(); });
      var euros = parseFloat(String(p[0]).replace(",", "."));
      if (!(euros > 0) || !p[1]) return;             // linea mal puesta: se salta
      fuera.push({
        tope: Math.round(euros * 100),
        corto: p[1],
        largo: p[2] || p[1],
        dativo: p[4] || p[2] || p[1],
        icono: (p[3] || "caja").toLowerCase(),
      });
    });
    if (!fuera.length) return null;
    // De menos a mas: el orden importa para la barra y para los avisos.
    fuera.sort(function (a, b) { return a.tope - b.tope; });
    return fuera;
  }

  var PREMIOS = premiosDelEditor() || [
    // En aleman hacen falta dos casos: acusativo para «Du bekommst …» y dativo
    // para «Noch 5 € bis …».
    { tope: 3500, corto: PZ_DE ? "Versand" : PZ_EN ? "Shipping" : PZ_IT ? "Spedizione" : "Envío", largo: PZ_DE ? "kostenlosen Versand" : PZ_EN ? "free shipping" : PZ_IT ? "la spedizione gratuita" : "el envío gratis", dativo: "zum kostenlosen Versand", icono: "camion" },
    { tope: 5000, corto: PZ_DE ? "Anhänger" : PZ_EN ? "Keychain" : PZ_IT ? "Portachiavi" : "Llavero", largo: PZ_DE ? "einen gratis Schlüsselanhänger" : PZ_EN ? "a free keychain" : PZ_IT ? "il portachiavi in omaggio" : "el llavero gratis", dativo: "zum gratis Schlüsselanhänger", icono: "llave" },
    // «la caja gratis» y no «la caja de regalo gratis»: el aviso va en una
    // sola linea y con el nombre largo se cortaba con puntos suspensivos
    // justo donde esta la gracia. El pie de la parada ya dice «Caja regalo».
    { tope: 6000, corto: PZ_DE ? "Geschenkbox" : PZ_EN ? "Gift box" : PZ_IT ? "Confezione regalo" : "Caja regalo", largo: PZ_DE ? "eine gratis Geschenkbox" : PZ_EN ? "a free gift box" : PZ_IT ? "la confezione regalo in omaggio" : "la caja gratis", dativo: "zur gratis Geschenkbox", icono: "caja" },
  ];

  /**
   * "35,00€" -> "35€". Los tres importes solo caben en una linea si no
   * arrastran unos centimos que siempre son cero. El formato —simbolo, lado,
   * separadores— sigue siendo el de la tienda, que lo pone `dinero()`.
   */
  function importeCorto(centimos) {
    return dinero(centimos).replace(/[.,]00/, "");
  }

  /**
   * El tanto por ciento de la barra donde cae cada parada.
   *
   * No son tramos iguales: el envio y el llavero se echan a la izquierda
   * para que la caja de regalo —que es la que lleva el nombre mas largo—
   * respire. Con los tres a tercios, su pie rozaba al del llavero.
   *
   * El reparto va aqui y en un solo sitio: `avanceDeLaBarra` lee de esta
   * misma tabla, asi que el relleno y las paradas no se pueden
   * desincronizar por mucho que se muevan los numeros.
   */
  // El del medio, justo en medio de los otros dos: (26 + 100) / 2 = 63. Los
  // tramos no son iguales a proposito —el primero vale 35 € y el ultimo
  // solo 10 €—, pero el ojo lee las tres paradas repartidas y no apretadas
  // al final, que era lo que se veia con los tercios.
  var PARADAS = [26, 63, 100];
  function sitioDeLaParada(i) {
    return PARADAS[i] != null ? PARADAS[i] : ((i + 1) / PREMIOS.length) * 100;
  }

  /**
   * Cuanto de la barra va lleno, de 0 a 1. Dentro de cada tramo avanza
   * segun lo que falta para esa parada, no segun el dinero total: asi la
   * barra se mueve lo mismo entre 0 y 35 € que entre 50 y 60 €, que es lo
   * que el cliente esta mirando.
   */
  function avanceDeLaBarra(total) {
    var previo = 0;
    for (var i = 0; i < PREMIOS.length; i++) {
      var tope = PREMIOS[i].tope;
      if (total < tope) {
        var dentro = Math.max(0, Math.min(1, (total - previo) / (tope - previo)));
        var desde = i === 0 ? 0 : sitioDeLaParada(i - 1);
        var hasta = sitioDeLaParada(i);
        return (desde + (hasta - desde) * dentro) / 100;
      }
      previo = tope;
    }
    return 1;
  }

  var SVG_NS = "http://www.w3.org/2000/svg";
  function dibujo(clase, hijos) {
    var s = document.createElementNS(SVG_NS, "svg");
    s.setAttribute("viewBox", "0 0 24 24");
    s.setAttribute("aria-hidden", "true");
    s.setAttribute("focusable", "false");
    s.setAttribute("class", clase);
    hijos.forEach(function (h) {
      var n = document.createElementNS(SVG_NS, h.t);
      for (var k in h) if (k !== "t") n.setAttribute(k, h[k]);
      s.appendChild(n);
    });
    return s;
  }
  // CADA PREMIO, SU DIBUJO: la furgoneta del envio, la llave del llavero y
  // la caja del envoltorio. Asi se sabe que toca en cada parada sin leer el
  // pie. Dibujados a mano con formas gordas: a 12 px, un icono con detalle
  // se convierte en una mancha.
  var DIBUJOS = {
    camion: [
      { t: "rect", x: "1", y: "6", width: "12.5", height: "9", rx: "1.2", fill: "currentColor" },
      { t: "path", d: "M14.5 8.5h3.2l3.3 3.6V15h-6.5z", fill: "currentColor" },
      { t: "circle", cx: "6", cy: "17.6", r: "2.4", fill: "currentColor" },
      { t: "circle", cx: "17", cy: "17.6", r: "2.4", fill: "currentColor" },
    ],
    llave: [
      { t: "circle", cx: "8.5", cy: "8.5", r: "4.6", fill: "none", stroke: "currentColor",
        "stroke-width": "2.6" },
      { t: "path", d: "M11.9 11.9 20 20", fill: "none", stroke: "currentColor",
        "stroke-width": "2.6", "stroke-linecap": "round" },
      { t: "path", d: "M16.2 16.2l2.4-2.4", fill: "none", stroke: "currentColor",
        "stroke-width": "2.6", "stroke-linecap": "round" },
    ],
    caja: [
      { t: "rect", x: "3", y: "9", width: "18", height: "4", rx: "1", fill: "currentColor" },
      { t: "rect", x: "5", y: "13", width: "14", height: "8", rx: "1", fill: "currentColor" },
      { t: "rect", x: "10.5", y: "4", width: "3", height: "17", fill: "currentColor" },
      { t: "circle", cx: "8", cy: "6", r: "2.4", fill: "currentColor" },
      { t: "circle", cx: "16", cy: "6", r: "2.4", fill: "currentColor" },
    ],
  };
  function iconoDelPremio(premio) {
    return dibujo("pzx-premios__regalo", DIBUJOS[(premio && premio.icono) || "caja"] || DIBUJOS.caja);
  }
  function iconoOk() {
    return dibujo("pzx-premios__ok", [
      { t: "path", d: "M5 12.5l4.5 4.5L19 7", fill: "none", stroke: "currentColor",
        "stroke-width": "3", "stroke-linecap": "round", "stroke-linejoin": "round" },
    ]);
  }

  /**
   * El carrito de la pastilla de comprar. Mismo criterio que los premios:
   * formas gordas y pocas lineas, que a 15 px el detalle se emborrona.
   */
  function iconoCarrito() {
    return dibujo("pzx-barra-total__carro", [
      { t: "path", d: "M2.6 3.4h2.5l2.7 10.9h10", fill: "none", stroke: "currentColor",
        "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" },
      { t: "path", d: "M6.4 6.6h15l-2 5.9H7.9", fill: "none", stroke: "currentColor",
        "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" },
      { t: "circle", cx: "9.2", cy: "19.2", r: "1.9", fill: "currentColor" },
      { t: "circle", cx: "17.4", cy: "19.2", r: "1.9", fill: "currentColor" },
    ]);
  }

  function avisoDePremios() {
    var p = document.createElement("p");
    p.className = "pzx-premios__aviso";
    p.setAttribute("data-pzx-premios-aviso", "");
    // Tres trozos fijos que luego solo cambian de texto: rehacer los nodos
    // en cada tecla costaba el ancla del scroll.
    ["cab", "falta", "mid", "cual"].forEach(function (que) {
      var n = document.createElement(que === "falta" || que === "cual" ? "b" : "span");
      n.setAttribute("data-pzx-premios-" + que, "");
      p.appendChild(n);
    });
    return p;
  }

  function columnaDePremios() {
    var col = document.createElement("div");
    col.className = "pzx-premios";
    col.setAttribute("data-pzx-premios", "");

    var pista = document.createElement("div");
    pista.className = "pzx-premios__pista";
    var lleno = document.createElement("span");
    lleno.className = "pzx-premios__lleno";
    lleno.setAttribute("data-pzx-premios-lleno", "");
    pista.appendChild(lleno);
    PREMIOS.forEach(function (p, i) {
      var hito = document.createElement("span");
      hito.className = "pzx-premios__hito";
      hito.setAttribute("data-pzx-premios-hito", "");
      hito.style.left = sitioDeLaParada(i) + "%";
      hito.appendChild(iconoDelPremio(p));
      hito.appendChild(iconoOk());
      pista.appendChild(hito);
    });
    col.appendChild(pista);

    var pies = document.createElement("div");
    pies.className = "pzx-premios__pies";
    PREMIOS.forEach(function (p, i) {
      var pie = document.createElement("span");
      pie.className = "pzx-premios__pie";
      pie.setAttribute("data-pzx-premios-pie", "");
      // Todos centrados bajo su parada, el ultimo incluido: para eso esta
      // el hueco de la derecha de `.pzx-premios`.
      pie.style.left = sitioDeLaParada(i) + "%";
      var imp = document.createElement("b");
      imp.textContent = importeCorto(p.tope);
      var nom = document.createElement("em");
      nom.textContent = p.corto;
      pie.appendChild(imp);
      pie.appendChild(nom);
      pies.appendChild(pie);
    });
    col.appendChild(pies);
    return col;
  }

  /**
   * EL PREMIO SE CELEBRA Y SE VA AL CARRITO.
   *
   * Pasar de 50 € no se notaba: el circulito de la barra se ponia rojo y
   * ya. Ahora, al cruzar una meta, sale un cartel diciendo QUE se ha
   * ganado y una ficha que salta desde esa parada hasta el icono del
   * carrito, que es donde el cliente espera que acaben las cosas.
   *
   * Solo al CRUZAR. `logradosAntes` empieza en -1 para que el primer
   * pintado —el de cargar la pagina— no festeje nada: entrar con el
   * carrito ya lleno no es haber ganado nada ahora.
   *
   * Y si el movimiento molesta (`prefers-reduced-motion`), queda el cartel
   * quieto: la informacion no depende de la animacion.
   */
  /**
   * Si el movimiento molesta. Se vigila EN VIVO —el cliente puede encender
   * el ajuste del movil con la ficha abierta— en vez de leerlo una vez al
   * cargar y quedarse con esa foto para siempre.
   */
  var mmQuieto = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
  var QUIETO = !!(mmQuieto && mmQuieto.matches);
  if (mmQuieto) {
    var alCambiarMovimiento = function () { QUIETO = mmQuieto.matches; };
    if (mmQuieto.addEventListener) mmQuieto.addEventListener("change", alCambiarMovimiento);
    else if (mmQuieto.addListener) mmQuieto.addListener(alCambiarMovimiento);
  }

  /**
   * EL BOTON DEL CARRITO, SIN EL «0».
   *
   * Ahora se ve siempre (lo fuerza la hoja de esta pagina), y con el pedido
   * vacio enseñaba un «0» rojo que no dice nada. Se vigila el TEXTO del
   * distintivo y se cambia una CLASE DEL PADRE: asi el observador no se
   * dispara a si mismo. Se vigila el `body` y no el boton porque el cajon
   * lo destruye y lo vuelve a crear al llegar sus ajustes.
   */
  /**
   * EL CARRITO FLOTANTE, EN RELEVO CON EL DE LA CABECERA.
   *
   * El boton vive arriba a la derecha, que es donde el cliente ya busca el
   * carrito. Mientras el de la cabecera esta a la vista no pinta nada —dos
   * carritos en la misma esquina— asi que se aparta; en cuanto la cabecera
   * se va hacia arriba, este ocupa su sitio.
   *
   * Y cuando esta apartado, el vuelo de los premios se va al de la
   * cabecera, que es justo el que se esta viendo: `destinoDelCarrito`
   * descarta el flotante porque sin caja no tiene tamaño.
   */
  var cabeceraALaVista = false;
  (function cestaVaciaSinNumero() {
    function marcar() {
      var f = document.querySelector(".cd-flotante");
      if (!f) return;
      var n = f.querySelector("[data-cd-flotante-num]");
      f.classList.toggle("pzx-sin-cuenta", !n || !parseInt(n.textContent || "0", 10));
      f.classList.toggle("pzx-flot-fuera", cabeceraALaVista);
    }

    // El carrito de la cabecera: se vigila si esta en pantalla. Si la
    // cabecera no lo tiene, el flotante se queda siempre.
    (function relevoConLaCabecera() {
      var enlace = document.querySelector("header a[href$='/cart'], a[href$='/cart']");
      if (!enlace || !window.IntersectionObserver) return;
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) { cabeceraALaVista = e.isIntersecting; });
        marcar();
      }).observe(enlace);
    })();
    if (typeof MutationObserver === "function") {
      new MutationObserver(marcar).observe(document.body, {
        childList: true, subtree: true, characterData: true,
      });
    }
    marcar();
  })();
  var cartelPremio = null;
  var cartelTimer = null;

  /**
   * Donde esta el carrito ahora mismo: el boton flotante del cajon si se
   * ve, el del encabezado si esta en pantalla y, si no hay ninguno, la
   * esquina de arriba a la derecha, que es de donde se tira para abrirlo.
   */
  function destinoDelCarrito() {
    var f = document.querySelector(".cd-flotante");
    if (f) {
      var r = f.getBoundingClientRect();
      if (r.width) return { x: r.left + r.width / 2, y: r.top + r.height / 2, nodo: f };
    }
    var a = document.querySelector("a[href$='/cart'], a[href*='/cart?']");
    if (a) {
      var r2 = a.getBoundingClientRect();
      if (r2.width && r2.bottom > 0 && r2.top < window.innerHeight) {
        return { x: r2.left + r2.width / 2, y: r2.top + r2.height / 2, nodo: a };
      }
    }
    return { x: window.innerWidth - 34, y: 46, nodo: null };
  }

  function cartel(texto, icono, fuera) {
    if (!cartelPremio) {
      cartelPremio = document.createElement("div");
      cartelPremio.className = "pzx-premio-aviso";
      cartelPremio.setAttribute("data-pzx-premio-aviso", "");
      // `status` y no `alert`: se lee cuando el lector termine lo suyo, sin
      // cortar lo que el cliente este haciendo.
      cartelPremio.setAttribute("role", "status");
      var hueco = document.createElement("i");
      hueco.setAttribute("data-pzx-premio-icono", "");
      cartelPremio.appendChild(hueco);
      cartelPremio.appendChild(document.createElement("span"));
      document.body.appendChild(cartelPremio);
    }
    var caja = cartelPremio.querySelector("[data-pzx-premio-icono]");
    while (caja.firstChild) caja.removeChild(caja.firstChild);
    caja.appendChild(icono);
    cartelPremio.classList.toggle("pzx-premio-aviso--fuera", !!fuera);
    cartelPremio.querySelector("span").textContent = texto;
    // Justo encima de la barra, que es donde esta mirando.
    var alto = barraTotal ? Math.round(barraTotal.getBoundingClientRect().height) : 0;
    cartelPremio.style.bottom = (alto + 12) + "px";
    var entra = QUIETO
      ? [{ opacity: 0 }, { opacity: 1 }]
      : [{ transform: "translateX(-50%) translateY(14px)", opacity: 0 },
         { transform: "translateX(-50%) translateY(0)", opacity: 1 }];
    cartelPremio.style.transform = "translateX(-50%)";
    try {
      cartelPremio.animate(entra, { duration: 260, easing: "cubic-bezier(.2,.8,.2,1)", fill: "both" });
    } catch (e) { /* navegador sin animaciones: se queda puesto y ya */ }
    clearTimeout(cartelTimer);
    cartelTimer = setTimeout(quitarCartel, 2400);
  }

  function quitarCartel() {
    if (!cartelPremio) return;
    var n = cartelPremio;
    cartelPremio = null;
    try {
      var a = n.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, fill: "forwards" });
      a.onfinish = function () { if (n.parentNode) n.parentNode.removeChild(n); };
    } catch (e) { if (n.parentNode) n.parentNode.removeChild(n); }
  }

  /**
   * EL BOTE. Un muelle de verdad: se aplasta un pelo antes de crecer y
   * vuelve pasandose de largo. El `scale` pelado de antes se leia como un
   * parpadeo. Y se cancela lo que hubiera puesto: dos botes encimados dan
   * un salto raro en vez de un rebote.
   */
  function bote(nodo, fuerte) {
    if (!nodo || QUIETO) return;
    try {
      if (nodo.getAnimations) {
        nodo.getAnimations().forEach(function (a) {
          // Solo los botes de antes; las transiciones de la barra no.
          if (a.effect && a.effect.target === nodo) a.cancel();
        });
      }
      nodo.animate([
        { transform: "scale(1)", offset: 0 },
        { transform: "scale(.88)", offset: .16 },
        { transform: "scale(" + (fuerte ? 1.42 : 1.26) + ")", offset: .46 },
        { transform: "scale(.97)", offset: .74 },
        { transform: "scale(1)", offset: 1 },
      ], { duration: fuerte ? 560 : 460, easing: "cubic-bezier(.33, 1, .68, 1)" });
    } catch (e) { /* da igual */ }
  }

  /** La onda que se abre desde la parada recien ganada. */
  function aroDelPremio(hito) {
    if (!hito || QUIETO) return;
    var r = hito.getBoundingClientRect();
    if (!r.width) return;
    var aro = document.createElement("div");
    aro.className = "pzx-premio-aro";
    aro.setAttribute("aria-hidden", "true");
    aro.style.left = (r.left + r.width / 2) + "px";
    aro.style.top = (r.top + r.height / 2) + "px";
    document.body.appendChild(aro);
    function fin() { if (aro.parentNode) aro.parentNode.removeChild(aro); }
    try {
      var a = aro.animate([
        { transform: "scale(.6)", opacity: .9 },
        { transform: "scale(3.4)", opacity: 0 },
      ], { duration: 620, easing: "cubic-bezier(.2, .7, .3, 1)", fill: "forwards" });
      a.onfinish = fin;
      setTimeout(fin, 900);
    } catch (e) { fin(); }
  }

  /**
   * La ficha del premio saltando entre la parada y el carrito. En arco y no
   * en linea recta: un salto se entiende como «esto se va alli», y una
   * diagonal recta parece que algo se ha descolocado.
   *
   * `vuelve` le da la vuelta al viaje: del carrito a la parada, que es lo
   * que pasa cuando el pedido baja y se pierde un premio. Mismo camino,
   * mismo arco y el tamaño al reves —sale pequeña del carrito y llega
   * entera a la barra— para que se lea como una devolucion y no como otro
   * premio ganado.
   */
  /**
   * DE DONDE SALE LA FICHA.
   *
   * La parada de la barra, si se ve. Y si no —en escritorio no hay barra,
   * al escribir se esconde, y cuando se llega al total del resumen se
   * retira por debajo del borde— hace falta un sitio que SI este en
   * pantalla, porque un vuelo que empieza fuera no se ve empezar.
   *
   * Por orden: la parada, el total del resumen (que es justo lo que hay
   * delante cuando la barra se aparta) y, si tampoco, el centro del borde
   * de abajo. Devuelve SIEMPRE un punto: el vuelo ya no se cancela por
   * falta de origen.
   */
  function origenDelVuelo(hito) {
    var alto = window.innerHeight || 600;
    if (hito) {
      var r = hito.getBoundingClientRect();
      if (r.width > 0 && r.bottom > 8 && r.top < alto - 8) {
        return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      }
    }
    var tot = bResumen && bResumen.querySelector("[data-pzx-total]");
    if (tot) {
      var rt = tot.getBoundingClientRect();
      if (rt.width > 0 && rt.bottom > 8 && rt.top < alto - 8) {
        return { x: rt.left + rt.width / 2, y: rt.top + rt.height / 2 };
      }
    }
    return { x: (window.innerWidth || 360) / 2, y: alto - 80 };
  }

  function saltoDelPremio(hito, premio, vuelve) {
    if (QUIETO) return;
    var destino = destinoDelCarrito();
    var salida = origenDelVuelo(hito);
    var xh = salida.x;
    var yh = salida.y;
    var x = vuelve ? destino.x : xh;
    var y = vuelve ? destino.y : yh;
    var dx = (vuelve ? xh : destino.x) - x;
    var dy = (vuelve ? yh : destino.y) - y;
    var ficha = document.createElement("div");
    ficha.className = "pzx-premio-vuela";
    ficha.setAttribute("aria-hidden", "true");
    ficha.appendChild(iconoDelPremio(premio));
    ficha.style.left = x + "px";
    ficha.style.top = y + "px";
    document.body.appendChild(ficha);

    // ESTELA. Dos copias por detras, mas chicas y casi transparentes, por el
    // MISMO camino y con unos milisegundos de retraso: es lo que convierte
    // un cambio de sitio en movimiento. Son copias del mismo `div`, no una
    // biblioteca: tres animaciones de `transform` las compone la tarjeta
    // grafica sin despeinarse.
    var nodos = [ficha];
    for (var c = 1; c <= 2; c++) {
      var g = ficha.cloneNode(true);
      g.className = "pzx-premio-vuela pzx-premio-vuela--estela";
      g.style.left = x + "px";
      g.style.top = y + "px";
      document.body.insertBefore(g, ficha);     // por detras de la buena
      nodos.push(g);
    }

    // Al llegar, un bote en lo que recibe: el carrito si va, la parada si
    // vuelve.
    var acabado = false;
    function fin() {
      if (acabado) return;
      acabado = true;
      nodos.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      bote(vuelve ? hito : destino.nodo, true);
    }
    var pasos = vuelve
      ? [
          { transform: "translate(0, 0) scale(.22)", opacity: 0 },
          { transform: "translate(0, 0) scale(.55)", opacity: 1, offset: .14 },
          { transform: "translate(" + (dx * .5) + "px, " + (dy * .5 - 70) + "px) scale(.95)",
            opacity: 1, offset: .6 },
          { transform: "translate(" + dx + "px, " + dy + "px) scale(.85)", opacity: 0 },
        ]
      : [
          { transform: "translate(0, 0) scale(.3)", opacity: 0 },
          { transform: "translate(0, 0) scale(1)", opacity: 1, offset: .18 },
          { transform: "translate(" + (dx * .5) + "px, " + (dy * .5 - 70) + "px) scale(1.06)",
            opacity: 1, offset: .62 },
          { transform: "translate(" + dx + "px, " + dy + "px) scale(.22)", opacity: .15 },
        ];
    try {
      nodos.forEach(function (n, i) {
        var vuelo = n.animate(pasos, {
          duration: 950,
          // Sale decidida y entra frenando: el mismo gesto de dejar algo en
          // su sitio, no un desplazamiento a velocidad constante.
          easing: "cubic-bezier(.28, .8, .24, 1)",
          delay: i * 70,                 // la estela va detras
          // `forwards` para que al acabar se quede donde cayo —diminuta y
          // casi transparente— y no vuelva un fotograma a su sitio de
          // salida antes de que la quitemos: ese parpadeo se ve.
          fill: "forwards",
        });
        if (i === 0) vuelo.onfinish = fin;
      });
      // Si el navegador no avisa del final (pestaña dormida), se limpia igual.
      setTimeout(fin, 1700);
    } catch (e) { fin(); }
  }

  function laParada(i) {
    return barraTotal ? barraTotal.querySelectorAll("[data-pzx-premios-hito]")[i] : null;
  }

  function festejarPremio(i) {
    var premio = PREMIOS[i];
    if (!premio) return;
    // «Tienes» y no «conseguido»: los premios son unos masculinos y otros
    // femeninos —el envio, la caja— y asi la frase vale para los tres.
    cartel(PZ_DE ? "Du bekommst " + premio.largo + "!" : PZ_EN ? "You got " + premio.largo + "!" : PZ_IT ? "Hai ottenuto " + premio.largo + "!" : "¡Tienes " + premio.largo + "!", iconoOk(), false);
    var hito = laParada(i);
    bote(hito, true);
    aroDelPremio(hito);
    setTimeout(function () { saltoDelPremio(hito, premio, false); }, 160);
  }

  /**
   * EL CAMINO DE VUELTA. Si el pedido baja y se pierde un premio, la ficha
   * sale del carrito y vuelve a su parada. Es la misma animacion del reves,
   * y a proposito: lo que se entendio al ganarlo se entiende al perderlo,
   * sin tener que aprender nada nuevo.
   */
  function devolverPremio(i) {
    var premio = PREMIOS[i];
    if (!premio) return;
    cartel(PZ_DE ? "Gratis-" + premio.corto + " entfällt" : PZ_EN ? "You lost " + premio.largo : PZ_IT ? "Hai perso " + premio.largo : "Te quedas sin " + premio.largo, iconoDelPremio(premio), true);
    var hito = laParada(i);
    bote(destinoDelCarrito().nodo);
    setTimeout(function () { saltoDelPremio(hito, premio, true); }, 160);
  }

  /**
   * UNA COLA, NO UNA LLUVIA DE RELOJES.
   *
   * Antes, cada premio ganado o perdido programaba su propio reloj y nadie
   * los cancelaba: subir y bajar de los 50 € dos veces seguidas dejaba
   * cuatro carteles encimados y fichas volando en los dos sentidos a la vez.
   *
   * Ahora van de uno en uno, con su respiro. Y lo contrario de lo que ya
   * esperaba se ANULA: marcar y desmarcar el llavero no son dos
   * animaciones, son cero.
   */
  var colaPremios = [];
  var colaReloj = null;

  function encolarPremio(i, vuelve) {
    for (var k = 0; k < colaPremios.length; k++) {
      if (colaPremios[k].i === i && colaPremios[k].vuelve !== vuelve) {
        colaPremios.splice(k, 1);
        return;
      }
    }
    colaPremios.push({ i: i, vuelve: vuelve });
    if (!colaReloj) siguientePremio();
  }

  function siguientePremio() {
    var sig = colaPremios.shift();
    if (!sig) { colaReloj = null; return; }
    if (sig.vuelve) devolverPremio(sig.i);
    else festejarPremio(sig.i);
    colaReloj = setTimeout(function () {
      colaReloj = null;
      siguientePremio();
    }, 1400);
  }

  function vaciarColaPremios() {
    colaPremios.length = 0;
    if (colaReloj) clearTimeout(colaReloj);
    colaReloj = null;
  }

  /**
   * EL PEDIDO SE FUE AL CARRITO: SE EMPIEZA DE CERO SIN DESPEDIDAS.
   *
   * Al reiniciar la ficha, el total vuelve a su minimo y se «pierden» los
   * premios de golpe: tres carteles de «te quedas sin...» seguidos justo
   * cuando el cliente acaba de elegir otra cosa. Quien reinicie llama a
   * esto ANTES de repintar.
   */
  function reiniciarPremios() {
    vaciarColaPremios();
    quitarCartel();
    logradosAntes = -1;        // como el primer pintado: ni festeja ni devuelve
    cuentaDesde = null;        // y el total se escribe, no cuenta hacia atras
  }

  // -1 mientras no se haya pintado nunca: ver `festejarPremio`.
  var logradosAntes = -1;

  /**
   * EL TOTAL, CONTANDO.
   *
   * Cambiar «34,90 €» por «42,80 €» de golpe no se ve; contando en cuatro
   * decimas, si — y es la mitad de la sensacion de que algo acaba de entrar
   * (o de salir) del pedido.
   *
   * Se cuenta en CENTIMOS y se escribe con `dinero()`, que es el formato de
   * la tienda: ni un segundo estilo de numero ni redondeos propios. El
   * numero ya va con cifras de ancho fijo, asi que no baila mientras corre.
   *
   * Y el lector de pantalla no tiene que oir los veinte numeros del camino:
   * se calla mientras cuenta y vuelve a hablar con el final, que es el
   * unico que hay que oir.
   */
  var cuentaAnim = null;
  var cuentaDesde = null;
  function pintarNumeroTotal(nodo, centimos) {
    var meta = Number(centimos) || 0;
    function escribir(c) {
      var t = dinero(Math.round(c));
      if (nodo.textContent !== t) nodo.textContent = t;
    }
    if (QUIETO || cuentaDesde === null || cuentaDesde === meta ||
        !window.requestAnimationFrame) {
      cuentaDesde = meta;
      nodo.setAttribute("aria-live", "polite");
      escribir(meta);
      return;
    }
    var desde = cuentaDesde;
    cuentaDesde = meta;
    if (cuentaAnim) window.cancelAnimationFrame(cuentaAnim);
    nodo.removeAttribute("aria-live");
    var t0 = (window.performance && performance.now) ? performance.now() : 0;
    var DURA = 420;
    (function paso(ahora) {
      var t = Math.min(1, ((ahora || t0) - t0) / DURA);
      // Sale rapido y frena, igual que la barra.
      var e = 1 - Math.pow(1 - t, 3);
      escribir(desde + (meta - desde) * e);
      if (t < 1) { cuentaAnim = window.requestAnimationFrame(paso); return; }
      cuentaAnim = null;
      nodo.setAttribute("aria-live", "polite");
      escribir(meta);
    })(t0);
  }

  /**
   * EL RECORRIDO, PINTADO EN CUALQUIER SITIO.
   *
   * Lo usan dos: la barra pegada de la ficha y el recorrido que se mete en
   * el cajon del carrito. Es a proposito que sea el MISMO codigo y no una
   * copia parecida: dos recorridos que dicen cosas distintas sobre el mismo
   * pedido es peor que no tener el segundo.
   *
   * Aqui solo se pinta. Festejar es cosa del de la ficha.
   */
  function pintarPremiosEn(caja, total) {
    if (!caja) return -1;
    var lleno = caja.querySelector("[data-pzx-premios-lleno]");
    var cab = caja.querySelector("[data-pzx-premios-cab]");
    if (!lleno || !cab) return -1;
    var hitos = caja.querySelectorAll("[data-pzx-premios-hito]");
    var pies = caja.querySelectorAll("[data-pzx-premios-pie]");

    var logrados = 0;
    PREMIOS.forEach(function (p, i) { if (total >= p.tope) logrados = i + 1; });

    var col = caja.querySelector("[data-pzx-premios]");
    var anchoAntes = parseFloat(lleno.style.width) || 0;
    var anchoAhora = avanceDeLaBarra(total) * 100;
    if (col) col.classList.toggle("is-bajando", anchoAhora < anchoAntes);
    lleno.style.width = anchoAhora.toFixed(1) + "%";
    for (var i = 0; i < hitos.length; i++) {
      hitos[i].classList.toggle("is-logrado", i < logrados);
    }
    for (var j = 0; j < pies.length; j++) {
      pies[j].classList.toggle("is-logrado", j < logrados);
    }

    // El aviso, en cuatro trozos fijos que solo cambian de texto.
    var siguiente = PREMIOS[logrados];
    var trozos;
    if (!siguiente) {
      trozos = [PZ_DE ? "Du hast alle drei Geschenke!" : PZ_EN ? "You've unlocked all three gifts!" : PZ_IT ? "Hai sbloccato tutti e tre i regali!" : "¡Ya tienes los tres regalos!", "", "", ""];
    } else {
      var falta = siguiente.tope - total;
      trozos = PZ_DE ? ["Noch ", dinero(falta), " bis ", siguiente.dativo] : PZ_EN ? ["Only ", dinero(falta), " away from ", siguiente.largo] : PZ_IT ? [(falta === 100 ? "Ti manca " : "Ti mancano "), dinero(falta), " per ", siguiente.largo] : [
        (falta === 100 ? "Te falta " : "Te faltan "),
        dinero(falta),
        " para ",
        siguiente.largo,
      ];
    }
    ["cab", "falta", "mid", "cual"].forEach(function (que, k) {
      var n = caja.querySelector("[data-pzx-premios-" + que + "]");
      if (n && n.textContent !== trozos[k]) n.textContent = trozos[k];
    });
    return logrados;
  }

  /**
   * EL MISMO RECORRIDO, DENTRO DEL CARRITO.
   *
   * El cajon lateral trae su propia barra de envio gratis, con otros topes
   * y otra cara: el cliente veia una cosa en la ficha y otra distinta al
   * abrir el carrito, que es justo donde va a decidir si sube el pedido.
   *
   * Lo suyo seria cambiarlo en la app del cajon —esta escrito y listo—,
   * pero publicar esa app pide un permiso que esta cuenta no tiene. Asi que
   * mientras tanto se hace desde aqui: cuando el cajon aparece, se le vacia
   * su barra y se le pone LA NUESTRA, la misma que la de abajo, construida
   * con las mismas funciones. En esta pagina, que es donde el cliente
   * elige; en el resto de la tienda el cajon sigue como estaba.
   *
   * El dinero sale de `/cart.js` y del SUBTOTAL, no del total: el total ya
   * lleva descontados los regalos —el llavero a cero— y al ganarlo el
   * pedido «bajaba» y el premio se perdia solo.
   */
  var cajaPremiosCajon = null;
  var cajonPedido = false;
  /**
   * LO QUE YA HAY EN EL CARRITO.
   *
   * La barra de abajo medía solo lo que se esta configurando AHORA, asi que
   * al anadir al carrito no se movia: el cliente acababa de meter 51 € y el
   * recorrido seguia donde estaba. Los premios se ganan por lo que hay en el
   * CARRITO al pagar, no por lo que hay en pantalla, asi que la barra suma
   * las dos cosas: lo que ya esta dentro y lo que se esta eligiendo.
   *
   * Y no se cuenta dos veces: cuando lo que se esta eligiendo es justo lo
   * que se acaba de meter —misma lista de lineas— solo cuenta el carrito.
   * En cuanto se cambia algo, vuelve a sumar.
   */
  var dineroCarrito = 0;
  var piezasCarrito = 0;
  var firmaEnElCarrito = null;
  var firmaAhora = null;

  function montarPremiosDelCajon() {
    var caja = document.querySelector("[data-cd-envio]");
    if (!caja) { cajaPremiosCajon = null; return false; }
    if (caja === cajaPremiosCajon && caja.querySelector("[data-pzx-premios]")) return true;
    // El cajon se destruye y se rehace al llegar sus ajustes: hay que volver
    // a montarlo cada vez, no una sola.
    while (caja.firstChild) caja.removeChild(caja.firstChild);
    caja.appendChild(avisoDePremios());
    caja.appendChild(columnaDePremios());
    caja.classList.add("pzx-cajon-premios");
    cajaPremiosCajon = caja;
    return true;
  }

  function repintarPremiosDelCajon() {
    montarPremiosDelCajon();
    mirarElCarrito();
  }

  /**
   * Una sola consulta por tanda: al anadir al carrito esto se llama varias
   * veces seguidas y no hace falta preguntarle al carrito cuatro veces.
   */
  function mirarElCarrito() {
    if (cajonPedido) return;
    cajonPedido = true;
    setTimeout(function () {
      cajonPedido = false;
      fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c) return;
          var t = c.items_subtotal_price != null ? c.items_subtotal_price : (c.total_price || 0);
          var n = c.item_count || 0;
          // Ha entrado algo: lo que hay en pantalla es lo que acaba de
          // entrar, asi que a partir de ahora no se suma aparte.
          if (n > piezasCarrito) firmaEnElCarrito = firmaAhora;
          dineroCarrito = t;
          piezasCarrito = n;
          if (cajaPremiosCajon) pintarPremiosEn(cajaPremiosCajon, t);
          // Y la barra de fuera, con la misma cuenta.
          if (typeof window.__pztPintar === "function") window.__pztPintar();
        })
        .catch(function () { /* sin carrito: se queda como estaba */ });
    }, 150);
  }

  /**
   * AL CERRAR EL CARRITO, LA GALERIA VUELVE A LA VIDA.
   *
   * Mientras el cajon esta abierto tapa la pagina y le quita el scroll: el
   * relevo entre las fotos y el editor no se entera de nada, y al cerrarlo
   * el marco se quedaba con la instantanea de antes —quieta, sin enseñar lo
   * que se iba cambiando—. Al cerrarse se vuelve a mirar donde estamos, se
   * rehace la foto del diseño y se recalcula el alto.
   */
  function resincronizarGaleria() {
    try { verEnGaleria(""); } catch (e) { /* sin diseño todavia */ }
    refrescarGaleria();
    altoGaleria();
  }

  (function alCerrarElCarrito() {
    if (typeof MutationObserver !== "function") return;
    var vigilado = null;
    function engancha() {
      var n = document.querySelector(".cd-root");
      if (!n || n === vigilado) return;
      vigilado = n;
      var abiertoAntes = n.classList.contains("is-abierto");
      new MutationObserver(function () {
        var abierto = n.classList.contains("is-abierto");
        if (abierto === abiertoAntes) return;
        abiertoAntes = abierto;
        if (abierto) return;
        // Un respiro: el cajon devuelve el scroll al body al cerrarse.
        setTimeout(resincronizarGaleria, 150);
        mirarElCarrito();
      }).observe(n, { attributes: true, attributeFilter: ["class"] });
    }
    // El cajon nace tarde y se rehace al llegar sus ajustes.
    new MutationObserver(engancha).observe(document.body, { childList: true });
    engancha();
  })();

  (function premiosEnElCajon() {
    if (typeof MutationObserver !== "function") return;
    var pedido = false;
    new MutationObserver(function () {
      if (pedido) return;
      pedido = true;
      (window.requestAnimationFrame || setTimeout)(function () {
        pedido = false;
        // Si el cajon ha vuelto a nacer, se le pone lo nuestro otra vez.
        var caja = document.querySelector("[data-cd-envio]");
        if (caja && !caja.querySelector("[data-pzx-premios]")) repintarPremiosDelCajon();
      });
    }).observe(document.body, { childList: true, subtree: true });
    repintarPremiosDelCajon();
  })();

  function pintarPremios(total) {
    var logrados = pintarPremiosEn(barraTotal, total);
    if (logrados < 0) return;

    // Lo ganado DESDE EL ULTIMO REPINTADO. Pueden ser dos de golpe —un
    // complemento caro cruza dos metas— y entonces se celebran seguidos,
    // no a la vez: dos carteles encima del otro no se leen.
    if (logradosAntes >= 0 && logrados > logradosAntes) {
      for (var g = logradosAntes; g < logrados; g++) encolarPremio(g, false);
    } else if (logradosAntes > 0 && logrados < logradosAntes) {
      // Se pierden de arriba abajo, el ultimo ganado primero: es el orden
      // en que se fueron consiguiendo, al reves.
      for (var q = logradosAntes - 1; q >= logrados; q--) encolarPremio(q, true);
    }
    logradosAntes = logrados;
    // Y el del cajon, con el dinero que hay YA en el carrito.
    repintarPremiosDelCajon();
  }

  /**
   * El hueco de abajo del `body` vale lo que mide la barra. Se repasa en
   * cada repintado porque la barra ya no mide siempre lo mismo —el aviso de
   * los premios aparece y desaparece— y un hueco que se quedo corto deja el
   * ultimo paso debajo de la barra, sin manera de leerlo.
   */
  var huecoPedido = false;
  function ajustarHueco() {
    if (!barraTotal || huecoPedido) return;
    huecoPedido = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      huecoPedido = false;
      var alto = Math.round(barraTotal.getBoundingClientRect().height);
      if (!alto) return;
      var ahora = parseInt(document.body.style.paddingBottom, 10) || 0;
      if (Math.abs(ahora - alto) > 1) document.body.style.paddingBottom = alto + "px";
    });
  }

  /**
   * LA BARRA SE APARTA DONDE YA SE VE EL TOTAL.
   *
   * El ultimo paso ensena el total del pedido con sus lineas. Dos totales a
   * la vez —el pegado abajo y el del resumen— se leen como dos precios
   * distintos, y encima el pegado tapa justo la linea a la que el cliente ha
   * bajado. Asi que en cuanto el total del resumen entra en pantalla la barra
   * se retira, y cuando vuelve a salir de pantalla la barra vuelve.
   *
   * Se mira el total del resumen y no el bloque entero: el bloque empieza
   * muchas lineas antes y la barra se iria demasiado pronto.
   *
   * El hueco de abajo del `body` NO se quita al apartarla, aunque sobre: al
   * acortar la pagina estando al final, el navegador sube el scroll, el total
   * se saldria de pantalla, la barra volveria, el hueco volveria... y la
   * barra se pondria a parpadear. Un hueco al final de la pagina es mejor que
   * eso. Por lo mismo se aparta con `transform` y no con `display`: asi la
   * pagina no cambia de alto y el vigilante no se autodispara.
   */
  function vigilarTotalDelResumen() {
    if (!bResumen || !window.IntersectionObserver) return;
    var fila = bResumen.querySelector(".pzx__total") ||
               bResumen.querySelector("[data-pzx-total]");
    if (!fila || fila.__pztVigilado) return;
    fila.__pztVigilado = true;
    new window.IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        RAIZ.classList.toggle("pzx-total-a-la-vista", e.isIntersecting);
      });
    }).observe(fila);
  }

  function pintarPrecioArriba(total) {
    var nPrecio = RAIZ.querySelector("[data-pz-precio]");
    if (!nPrecio) return;
    var v = varianteActual();
    if (!v) return;

    var extras = total - (Number(v.p) || 0);
    nPrecio.textContent = comoLaTienda(total, v.pm);

    var nAntes = RAIZ.querySelector("[data-pz-antes]");
    var nAhorro = RAIZ.querySelector("[data-pz-ahorro]");
    var comparar = Number(v.c) || 0;
    var hayTachado = comparar > (Number(v.p) || 0);

    if (nAntes) {
      if (hayTachado) {
        nAntes.textContent = comoLaTienda(comparar + extras, v.cm || v.pm);
        nAntes.hidden = false;
      } else {
        nAntes.hidden = true;
      }
    }
    if (nAhorro) {
      // Mismo ahorro en euros, sobre un total mayor: el porcentaje baja.
      var pct = hayTachado
        ? Math.round(((comparar - Number(v.p)) * 100) / (comparar + extras))
        : 0;
      nAhorro.textContent = pct > 0 ? "-" + pct + "%" : "";
      nAhorro.hidden = pct <= 0;
    }
  }

  // El precio del cuadro lo cambia pz-producto.js al tocar las opciones, y lo
  // hace asignando `campoId.value`, que no dispara ningun evento. Asi que se
  // escucha el MISMO disparador que el (un change en las opciones) y se lee
  // despues, cuando aquel ya ha escrito.
  RAIZ.addEventListener("change", function (e) {
    if (e.target.closest && e.target.closest("[data-pz-opcion]")) {
      setTimeout(pintar, 0);
    }
  });
  // La dedicatoria aparece y desaparece segun la variante: el destino depende
  // de que este a la vista.
  // El escuchador vive FUERA de arrancar() (abajo del todo), para que no se
  // acumule uno por cada repintado del editor. Aqui solo se le dice a quien
  // tiene que avisar ahora.
  window.__pztPintar = pintar;

  // ------------------------------------------- el resto, a su debido tiempo
  /**
   * Hasta que no se elige modalidad, lo que va DESPUES del paso de modalidad
   * no se enseña: cambios, dedicatoria, base, complementos, resumen y el
   * boton de comprar.
   *
   * No es decoracion. De esa eleccion cuelga todo lo demas —si hay que subir
   * foto, si se cobra suplemento, que boton de generar sale— y con los doce
   * pasos a la vista de golpe el cliente no sabe por donde empezar. Tampoco
   * tendria sentido dejarle comprar antes de decidirlo.
   */
  var pasosTapados = [];
  (function taparElResto() {
    // En el editor se ve TODO. Si no, el merchant no puede seleccionar ni
    // configurar los pasos que en la tienda estan escondidos hasta elegir
    // modalidad: para el serian bloques invisibles e inalcanzables.
    if (EN_EDITOR) return;
    if (!bModo) return;
    var mio = bModo.closest(".pz-prod__bloque");
    if (!mio) return;
    for (var n = mio.nextElementSibling; n; n = n.nextElementSibling) {
      if (!n.classList || !n.classList.contains("pz-prod__bloque")) continue;
      n.hidden = true;
      pasosTapados.push(n);
    }
  })();

  function destapar() {
    for (var i = 0; i < pasosTapados.length; i++) pasosTapados[i].hidden = false;
    pasosTapados = [];
    // El paso del bloque de la app se queda escondido a proposito: su
    // contenido ya vive dentro del de modalidad.
    var raizWidget = RAIZ.querySelector("[data-pr-customizer]");
    var env = raizWidget && raizWidget.closest(".pz-prod__bloque");
    if (env && RAIZ.querySelector("[data-pzx-subida]") &&
        RAIZ.querySelector("[data-pr-dropzone]") &&
        RAIZ.querySelector("[data-pr-dropzone]").parentNode === RAIZ.querySelector("[data-pzx-subida]")) {
      // En el editor no se esconde: hay que poder seleccionarlo.
      if (!EN_EDITOR) env.hidden = true;
    }
  }

  // ------------------------------------------- dedicatoria: si o no
  /**
   * El Si/No vive aqui, junto al campo donde se escribe, y no en el paso de
   * opciones del producto. Lo que hace es marcar el radio ESCONDIDO de la
   * tercera opcion (se oculta con `ver_op3`, que no deja de pintarlo): la
   * variante cambia por el camino de siempre y los 2,95 € se cobran como
   * siempre, sin una segunda forma de cobrar que mantener.
   *
   * Esa tercera opcion lleva DOS ejes, no uno: dedicatoria si/no y retrato
   * con IA o foto original. Cuatro valores, una variante cada uno. Por eso
   * los 5,99 € de la IA ya no son una linea suelta del carrito que el
   * cliente pudiera borrar dejando el cuadro a medias: van en el precio de
   * la propia pieza.
   */
  (function dedicatoriaSiNo() {
    var caja = nodoDedi();
    if (!caja) return;
    var ops = Array.prototype.slice.call(caja.querySelectorAll("[data-pzx-dedi-op]"));
    var etq = caja.querySelector("[data-pzx-dedi-precio]");

    // Los cuatro valores, tal como los escribe la tienda (traducidos si toca).
    var VALORES = {
      no: caja.dataset.pzxValNo || "",
      si: caja.dataset.pzxValSi || "",
      noIa: caja.dataset.pzxValNoIa || "",
      siIa: caja.dataset.pzxValSiIa || "",
    };

    /**
     * El valor que toca para esta combinacion. Si el producto no tiene las
     * variantes con IA —porque aun no se han creado—, se cae a las de
     * siempre: mejor vender sin cobrar el extra que no dejar comprar.
     */
    function valorPara(conDedi, conIA) {
      if (conIA) {
        var v = conDedi ? VALORES.siIa : VALORES.noIa;
        if (v) return v;
      }
      return conDedi ? VALORES.si : VALORES.no;
    }

    /**
     * Los radios de la opcion que lleva ESTE eje, y no los de toda la ficha.
     *
     * Mirarlos todos valia mientras los valores fuesen unicos, y dejo de
     * valer: la lampara con base llama «LÁMPARA» a un valor de su segunda
     * opcion y otra vez al valor sin IA de la tercera. Como la segunda va
     * antes en el DOM, al volver a ORIGINAL se encontraba aquel —que ya
     * estaba marcado—, el eje no se movia, y la tarjeta se apagaba mientras
     * la variante seguia cobrando los 9,95 € de la IA.
     *
     * El ancla es un valor que no se puede repetir porque lleva sufijo
     * («+ IA», «+ DEDICATORIA»); de su radio se saca el grupo. Si no
     * aparece ninguno se mira la ficha entera, como antes.
     */
    function grupoDelEje() {
      var radios = RAIZ.querySelectorAll('[data-pz-opcion] input[type="radio"]');
      var anclas = [VALORES.siIa, VALORES.noIa, VALORES.si];
      for (var a = 0; a < anclas.length; a++) {
        if (!anclas[a]) continue;
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value !== anclas[a]) continue;
          return radios[i].closest("[data-pz-opcion]") || RAIZ;
        }
      }
      return RAIZ;
    }

    /** El valor de «tipo de cuadro» que hay puesto ahora mismo. */
    function valorActual() {
      var radios = grupoDelEje().querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (!radios[i].checked) continue;
        var v = radios[i].value;
        if (v === VALORES.no || v === VALORES.si || v === VALORES.noIa || v === VALORES.siIa) return v;
      }
      return "";
    }

    /**
     * El radio de la opcion escondida cuyo valor es `valor`.
     *
     * Se recorren y se comparan, en vez de armar un selector de atributo: el
     * valor es texto del merchant y llega traducido —"PAINTING + DEDICATION
     * (€2.95)"— con espacios, signos y parentesis. Montarlo en un selector
     * obliga a escaparlo, y `CSS.escape` es para IDENTIFICADORES, no para el
     * interior de unas comillas: con el, esa cadena no casaba con nada y el
     * boton no hacia nada.
     */
    function radioDe(valor) {
      var radios = grupoDelEje().querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === valor) return radios[i];
      }
      return null;
    }

    function sincronizar() {
      // El estado lo manda la VARIANTE, no este boton: asi coincide aunque se
      // cambie desde otro sitio.
      var actual = valorActual();
      if (actual) estado.conDedi = (actual === VALORES.si || actual === VALORES.siIa);
      for (var i = 0; i < ops.length; i++) {
        var es = (ops[i].dataset.pzxDediOp === "si") === estado.conDedi;
        ops[i].classList.toggle("is-sel", es);
        ops[i].setAttribute("aria-checked", es ? "true" : "false");
      }
      if (etq) {
        var d = suplementoDedicatoria();
        etq.textContent = d > 0 ? " (+" + dinero(d) + ")" : "";
      }
    }

    ops.forEach(function (o) {
      o.addEventListener("click", function () {
        estado.conDedi = o.dataset.pzxDediOp === "si";
        // Al decir que no, el texto se va con el paso. Se borra ANTES de
        // cambiar la variante: el widget reacciona a ese cambio y no debe
        // encontrarse nada escrito.
        if (!estado.conDedi) olvidarDedicatoriaCuadro();
        aplicarTipoCuadro();
        sincronizar();
        setTimeout(pintar, 0);
      });
    });

    // Lo usan los dos pasos: este y el de la modalidad.
    aplicarTipoCuadro = function () {
      var r = radioDe(valorPara(estado.conDedi, estado.modo === "ia"));
      if (!r || r.checked) return;
      r.checked = true;
      // El evento es lo que hace que pz-producto.js recalcule la variante.
      r.dispatchEvent(new Event("change", { bubbles: true }));
    };
    RAIZ.addEventListener("change", function (e) {
      if (e.target.closest && e.target.closest("[data-pz-opcion]")) setTimeout(sincronizar, 0);
    });
    sincronizar();
  })();

  // ------------------------------------------- la foto y el avance, arriba
  // Lo rellena `fotoEnGaleria` mas abajo; hasta entonces, no hace nada.
  var refrescarGaleria = function () {};
  // Si la pagina esta en lo mas alto. Lo mira el mismo repaso que calcula el
  // alto de la galeria —que ya corre en cada scroll— y lo lee `revisar()`
  // para decidir quien ocupa el marco. Se declara aqui arriba porque
  // `revisar()` corre antes de que exista el repaso del scroll.
  var EN_LO_ALTO = { es: true };
  // Lo rellena `tarjetaEnElMarco` mas abajo: el repaso del scroll necesita
  // poder pedirle que suelte o recupere el marco al cruzar lo mas alto.
  var revisarTarjetaDelMarco = null;

  /**
   * Entre subir la foto y tener el diseno pasan hasta 30 segundos. Durante
   * ese rato la galeria enseñaba la foto de catalogo y el cliente no veia por
   * ningun lado lo que acababa de subir.
   *
   * Esto es un ESPEJO de lo que el widget ya pinta en el panel: se vigila su
   * vista previa y su barra de progreso y se repite arriba, en el recuadro
   * pegado. No se le toca nada al widget: si un dia cambia por dentro, lo
   * peor que pasa es que el espejo deje de reflejar, no que se rompa la
   * compra.
   */
  (function fotoEnGaleria() {
    var galeria = RAIZ.querySelector(".pz-prod__galeria");
    if (!galeria || typeof MutationObserver !== "function") return;

    var hueco = RAIZ.querySelector("[data-pzx-editor]");

    function revisar() {
      // QUIEN MANDA EN EL MARCO: el cuadro montado en su base, si la hay;
      // si no, el editor con el diseño; y si no hay ninguno de los dos, las
      // fotos del producto.
      //
      // LA FOTO DEL CLIENTE YA NO SALE AQUI. Se enseñaba en cuanto se subia
      // —y mientras se generaba— pero arriba va lo que se compra, no el
      // material de partida: el cliente veia su propia foto en el marco y
      // parecia que el cuadro iba a ser eso. El sitio de la foto subida es
      // su recuadro del paso, donde se sube y se cambia.
      var caja3d = RAIZ.querySelector("[data-pzx-3d]");
      // EL HUECO ABIERTO BASTA. Se probo a exigir ademas lienzo dentro —para
      // que el marco no se quedase en blanco mientras el visor monta— y el
      // remedio fue peor: el visor cuelga su lienzo a su ritmo y con esa
      // condicion el marco no se lo entregaba nunca; la base no se veia.
      // Lo de quedarse en blanco se ataja por otro lado: si pasados unos
      // segundos no hay escena, el hueco se suelta (ver `vigilarMontaje3D`).
      var tresD = !!(caja3d && !caja3d.hidden);
      // El editor se esconde por CLASE, no por `hidden`: ese atributo lo
      // gobierna el widget y su lienzo tiene que seguir existiendo, porque de
      // el sale la imagen que se monta en la base.
      var editorPuesto = hueco && !hueco.hidden;
      // RED DE SEGURIDAD. Si el editor sigue montado —su lienzo esta ahi—
      // pero alguien le ha bajado la persiana, se le vuelve a abrir. El
      // widget lo hacia al guardar para comprar, y el marco se quedaba con
      // las fotos de catalogo mientras el cliente tenia su diseño hecho: se
      // lee como que se ha perdido. Ya no lo hace, pero un navegador con la
      // version vieja en cache si.
      if (!editorPuesto && hueco && hueco.querySelector("[data-pr-canvas]")) {
        hueco.hidden = false;
        editorPuesto = true;
      }
      var hayNuestro = !!editorPuesto || tresD;

      // ARRIBA DEL TODO MANDA LA GALERIA. Pegado al principio de la pagina
      // el cliente todavia esta mirando el producto, no personalizandolo:
      // ahi se aparta lo nuestro y vuelven las fotos de siempre, con sus
      // flechas y sus miniaturas. En cuanto baja un dedo, el editor vuelve
      // a su sitio tal y como estaba —no se desmonta nada, solo se tapa.
      var pausa = hayNuestro && EN_LO_ALTO.es;
      galeria.classList.toggle("pzx-arriba", pausa);
      galeria.classList.toggle("is-3d", tresD && !pausa);

      // La galeria se apaga mientras enseñamos lo nuestro: un solo recuadro
      // arriba, no dos cosas compitiendo.
      galeria.classList.toggle("is-editando", hayNuestro && !pausa);
      // El tope de alto se reparte distinto con el editor puesto, asi que se
      // recalcula aqui, que es donde cambia el estado.
      if (typeof window.__pztAltoGaleria === "function") window.__pztAltoGaleria();
    }
    // El visor de la base lo enciende y lo apaga otro trozo de este fichero:
    // necesita poder pedir que se repase quien ocupa el marco.
    refrescarGaleria = revisar;

    // Ya no hace falta vigilar la vista previa ni la barra: arriba solo
    // mandan el editor y el visor de la base.
    var obs = new MutationObserver(revisar);
    // El hueco del editor lo marca y desmarca el widget al incrustarse y al
    // cerrarse. Es el MISMO controlador quien decide que se ve arriba: con
    // dos vigilando la misma clase, uno apagaba lo que encendia el otro.
    if (hueco) obs.observe(hueco, { attributes: true, attributeFilter: ["hidden"] });
    revisar();
  })();

  // ------------------------------------------- el cuadro de pie en su base
  /**
   * Al elegir una base, la galeria enseña el cuadro MONTADO en ella.
   *
   * No hay nada que inventar: la pieza real es metacrilato de pie en una base
   * de madera, que es exactamente lo que ya monta el visor 3D de la lampara
   * con peana. Se le pasa `variant: "cuadro-base"` y el visor usa un panel
   * rectangular en vez de una silueta recortada; peana, ranura, cable, tira
   * LED y resplandor son los suyos de siempre.
   *
   * La LUZ solo se enciende si esa base la lleva (ajuste "Base N · lleva
   * luz"). El soporte de metacrilato que hay hoy es transparente y no
   * ilumina: pintarlo encendido seria enseñar algo que no se recibe.
   *
   * La imagen sale del LIENZO del editor, no del servidor: asi se ve lo que
   * el cliente tiene delante en ese momento, sin esperar a guardar.
   */
  var visor3d = null;
  /**
   * QUE MANDE EL ULTIMO, NO EL QUE TERMINE ANTES.
   *
   * Montar el visor son varios pasos que tardan —cargar el fichero del
   * visor, leer el lienzo, cargar la imagen, montar la escena— y cualquiera
   * puede pedir uno nuevo por el camino: pulsar la base, cambiar el grabado,
   * llegar un diseño. Si se pulsa la base dos veces seguidas salen dos
   * montajes a la vez; y si despues se quita la base, el montaje que seguia
   * en marcha terminaba DESPUES de quitarla y volvia a colgar el visor en el
   * hueco. Resultado: la base pegada tapando el diseño, sin forma de
   * quitarla.
   *
   * Con un numero de turno se arregla: cada llamada toma el suyo, y en cada
   * paso que vuelve de algo asincrono se comprueba que sigue siendo el turno
   * vigente. El que llega tarde se calla y, si llego a montar algo, lo
   * suelta. Soltar el visor tambien quema el turno, asi que lo que estuviera
   * en vuelo no puede revivirlo.
   */
  var turno3d = 0;
  // Cuantas veces seguidas se ha pedido montar sin encontrar el lienzo. Se
  // pone a cero en cuanto aparece.
  var esperasSinLienzo = 0;
  function montar3D() {
    var caja = RAIZ.querySelector("[data-pzx-3d]");
    if (!caja) return;
    var mio = ++turno3d;

    function soltar(motivo) {
      // QUEDA ESCRITO QUIEN LO SOLTO. Un visor que se monta y desaparece no
      // dejaba rastro ninguno, y habia que adivinar el porque.
      try { caja.dataset.pzx3dSoltado = String(motivo || "?"); } catch (e) { /* da igual */ }
      turno3d++;          // lo que venga de antes ya no vale
      if (visor3d) {
        try { visor3d.dispose && visor3d.dispose(); } catch (e) { /* ya suelto */ }
        visor3d = null;
      }
      caja.innerHTML = "";
      caja.hidden = true;
      refrescarGaleria();
      // La galeria llevaba la foto CON base: sin visor hay que rehacerla, o
      // arriba se seguiria viendo una peana que ya no se compra.
      verEnGaleria("");
    }

    /**
     * UN TROPIEZO NO TIRA LA ESCENA QUE YA SE ESTA VIENDO.
     *
     * Casi todos los fallos de aqui son pasajeros: el widget rehace su
     * lienzo —pasa justo al elegir la base, que apaga la dedicatoria del
     * marco— y durante ese hueco no hay instantanea que tomar. Soltar
     * entonces cerraba el visor YA MONTADO: el cliente veia aparecer la
     * peana y desaparecer sola un segundo despues.
     *
     * Con base elegida y escena viva, se deja lo que hay y se espera al
     * siguiente repaso. Solo se suelta cuando no hay nada que conservar.
     */
    function fallo(motivo) {
      if (visor3d && estado.base) {
        try { caja.dataset.pzx3dMantenido = String(motivo || "?"); } catch (e) { /* da igual */ }
        if (caja.hidden) caja.hidden = false;
        refrescarGaleria();
        return;
      }
      soltar(motivo);
    }

    if (!estado.base) { soltar("sin-base"); return; }

    // EL LIENZO PUEDE ESTAR REHACIENDOSE. Soltar en cuanto no se encuentra
    // era demasiado seco: al cambiar de variante —por ejemplo al apagar la
    // dedicatoria del cuadro cuando se elige la base— el widget rehace su
    // lienzo, y cualquier repaso que cayera en ese hueco tiraba el visor ya
    // montado. El cliente veia aparecer la base y desaparecer sola.
    //
    // Se le dan tres oportunidades separadas medio segundo. Si pasadas esas
    // sigue sin haber lienzo, entonces si: no hay cuadro que enseñar.
    var lienzo = RAIZ.querySelector("[data-pzx-editor] [data-pr-canvas]");
    if (!lienzo) {
      if (esperasSinLienzo < 3) {
        esperasSinLienzo += 1;
        setTimeout(function () {
          if (mio !== turno3d || !estado.base) return;
          montar3D();
        }, 500);
        return;
      }
      esperasSinLienzo = 0;
      fallo("sin-lienzo");
      return;
    }
    esperasSinLienzo = 0;

    // La pieza, sin la pared del editor. El widget expone esa instantanea en
    // el propio lienzo; si no estuviera (version vieja en cache), se cae al
    // volcado normal, que lleva la escena pegada — feo, pero no roto.
    var imagen;
    try {
      imagen = typeof lienzo.__prSinFondo === "function"
        ? lienzo.__prSinFondo()
        : lienzo.toDataURL("image/png");
    } catch (e) { fallo("lienzo-contaminado"); return; }    // instantanea imposible

    var cfgNodo = RAIZ.querySelector(".pr-customizer__config");
    var url = "";
    try { url = (JSON.parse(cfgNodo.textContent) || {}).lamp3dUrl || ""; } catch (e) {}
    if (!url) { fallo("sin-url"); return; }

    caja.hidden = false;
    refrescarGaleria();
    cargarVisor(url).then(function (PR) {
      if (mio !== turno3d) return;                  // llego tarde: manda otro
      if (!estado.base) { soltar("sin-base-tarde"); return; }
      // SOLTAR EL ANTERIOR ANTES DE MONTAR OTRO. Vaciar la caja a secas deja
      // vivo su contexto WebGL, y el navegador solo aguanta unos pocos: a los
      // pocos refrescos de la dedicatoria el visor dejaria de pintar.
      if (visor3d) {
        try { visor3d.dispose && visor3d.dispose(); } catch (e) { /* ya suelto */ }
        visor3d = null;
      }
      caja.innerHTML = "";
      var im = new Image();
      im.onload = function () {
        if (mio !== turno3d || !estado.base) return;
        // El panel 3D estira la imagen ENTERA sobre el rectangulo, asi que
        // hay que entregarle solo la pieza: con los margenes transparentes
        // dentro, el cuadro saldria diminuto en medio de un panel vacio.
        im = recortarTransparente(im);
        var conLuz = !!(estado.base && estado.base.luz);
        // `mount` devuelve una PROMESA (dentro carga Three.js), no el visor.
        // Tratarla como si fuera el visor dejaba la tira LED encendida
        // siempre: el `setLed` se llamaba sobre la promesa, no existia, y la
        // luz se quedaba en su valor por defecto. Una base que no ilumina se
        // veia iluminada.
        var grabado = dedicatoriaBase();
        Promise.resolve(PR.mount(caja, {
          image: im,
          variant: "cuadro-base",
          dedication: grabado,
        })).then(function (v) {
          // Si por el camino se ha quitado la base o alguien ha pedido otro
          // montaje, este sobra: se tira la escena recien hecha en vez de
          // colgarla. Sin esto, la pieza aparecia despues de quitarla.
          if (mio !== turno3d || !estado.base) {
            try { if (v && v.dispose) v.dispose(); } catch (e) { /* ya suelto */ }
            // EL LIENZO RECIEN COLGADO SE RETIRA. `mount` ya ha metido su
            // canvas en el hueco antes de resolver: si el hueco estaba
            // cerrado, ese canvas se quedaba dentro como un muerto y el
            // hueco aparecia "oculto pero lleno".
            if (caja.hidden) caja.innerHTML = "";
            if (mio === turno3d) soltar("montaje-sobrante");
            return;
          }
          visor3d = v;
          // Ya hay escena: ahora si, el marco pasa al visor.
          refrescarGaleria();
          // El metodo se llama `setPower`, no `setLed`. Con el nombre
          // equivocado no fallaba nada: simplemente no se llamaba a nada y la
          // tira se quedaba encendida, que es el valor por defecto. Una base
          // sin luz se veia iluminada.
          // Queda anotado en el propio hueco si la luz va encendida y si el
          // interruptor llego a responder. Sin esto, un fallo aqui no deja
          // rastro: la tira se queda como estaba y parece que funciona.
          caja.dataset.pzx3dLuz = conLuz ? "1" : "0";
          caja.dataset.pzx3dLuzOk = "no";
          caja.dataset.pzx3dDedi = grabado;
          if (v && typeof v.setPower === "function") {
            try {
              v.setPower(conLuz);
              caja.dataset.pzx3dLuzOk = "si";
            } catch (e) {
              caja.dataset.pzx3dLuzOk = "error: " + ((e && e.message) || e);
            }
          }
          // LA GALERIA, CON LA BASE PUESTA. La foto de arriba sale de este
          // mismo visor, pero solo se tomaba al subir a lo mas alto de la
          // pagina: quien elegia la base estando ya arriba —o subia antes de
          // que el visor acabara de montarse— se quedaba con el cuadro
          // suelto en la galeria. Se vuelve a tomar en cuanto hay escena,
          // dandole un respiro para que pinte el primer fotograma.
          setTimeout(function () {
            if (mio !== turno3d || !estado.base) return;
            // Otro repaso del marco con la escena ya pintada: si el lienzo
            // llego tarde, este es el que se lo entrega.
            refrescarGaleria();
            verEnGaleria("");
          }, 450);
        }, function () { fallo("fallo-mount"); });
      };
      im.onerror = function () { fallo("fallo-imagen"); };
      im.src = imagen;
    }, function () { fallo("fallo-visor"); });
  }

  /**
   * Devuelve la MISMA imagen recortada a su contenido: se busca la caja de
   * los pixeles que no son transparentes y se copia solo eso.
   *
   * Si algo va mal —lienzo contaminado, imagen vacia— se devuelve la de
   * entrada tal cual: mas vale un encuadre flojo que ningun cuadro.
   */
  function recortarTransparente(img) {
    var w = img.naturalWidth || img.width;
    var h = img.naturalHeight || img.height;
    if (!w || !h) return img;
    try {
      var c = document.createElement("canvas");
      c.width = w; c.height = h;
      var x = c.getContext("2d");
      x.drawImage(img, 0, 0);
      var px = x.getImageData(0, 0, w, h).data;
      var x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var yy = 0; yy < h; yy++) {
        for (var xx = 0; xx < w; xx++) {
          if (px[(yy * w + xx) * 4 + 3] > 8) {
            if (xx < x0) x0 = xx;
            if (xx > x1) x1 = xx;
            if (yy < y0) y0 = yy;
            if (yy > y1) y1 = yy;
          }
        }
      }
      if (x1 <= x0 || y1 <= y0) return img;
      var cw = x1 - x0 + 1, ch = y1 - y0 + 1;
      var rec = document.createElement("canvas");
      rec.width = cw; rec.height = ch;
      rec.getContext("2d").drawImage(c, x0, y0, cw, ch, 0, 0, cw, ch);
      // Se devuelve el <canvas>, no una <img>: three.js acepta los dos y el
      // canvas ya esta pintado, sin esperar a que cargue nada.
      return rec;
    } catch (e) {
      return img;
    }
  }

  /**
   * Le dice al lienzo del editor que texto debe pintar en el marco: el de
   * verdad si la dedicatoria va ahi, y NADA si se graba en la base. El
   * pedido no se entera de esto — la property `Dedicatoria` lleva siempre el
   * texto; lo que cambia es donde se fabrica.
   */
  function repintarDedicatoria() {
    // La del paso de arriba va SIEMPRE al marco: se la pasamos al lienzo del
    // editor, que es quien la pinta.
    try {
      window.dispatchEvent(new CustomEvent("dedicatoria:change", { detail: { text: dedicatoriaActual() } }));
    } catch (e) { /* navegador viejo */ }
    // Y como lo que el visor 3D enseña es una INSTANTANEA de ese lienzo, hay
    // que rehacerla: sin eso, el cuadro de pie en su base se queda con la
    // imagen de antes y el texto nuevo no aparece por ningun lado.
    refrescar3DconRetraso();
  }

  /** El texto que va grabado en la madera. Vacio = peana lisa. */
  function dedicatoriaBase() {
    var c = RAIZ.querySelector("[data-pzx-dedibase-campo]");
    return c ? String(c.value || "").trim() : "";
  }

  /**
   * Vuelve a montar el visor con una instantanea nueva.
   *
   * Se espera a que el cliente deje de teclear: cada montaje levanta un
   * contexto WebGL, y hacerlo letra a letra pondria el movil de rodillas.
   */
  var relojRefresco = null;
  function refrescar3DconRetraso() {
    // Sin comprobar que haya visor: puede no haberlo todavia —base elegida
    // antes de tener diseño— y entonces lo que toca es montarlo, no salir.
    if (relojRefresco) clearTimeout(relojRefresco);
    relojRefresco = setTimeout(function () {
      relojRefresco = null;
      if (estado.base) montar3D();
    }, 600);
  }

  function dedicatoriaActual() {
    var c = document.getElementById("dedicatoria-input");
    return c ? String(c.value || "").trim() : "";
  }

  /**
   * DECIR «NO» ES BORRAR, NO SOLO ESCONDER.
   *
   * Apagar la dedicatoria cambiaba la variante y escondia el paso, pero el
   * texto seguia vivo en tres sitios, y al guardar se lee de los tres —ese
   * es el orden que usa el widget—:
   *
   *   1. el textarea del editor  (#popup-dedicatoria)
   *   2. el campo de la ficha    (#dedicatoria-input)
   *   3. la cache del widget     (la que alimenta `dedicatoria:change`)
   *
   * Resultado: el cliente decia que no y la dedicatoria seguia pintada en el
   * lienzo y viajaba al pedido. Aqui se vacian los dos campos y se avisa al
   * lienzo con texto vacio, que es lo que esconde el renglon (el widget
   * pinta la dedicatoria solo si `text.length > 0`).
   */
  function olvidarDedicatoriaCuadro() {
    var campos = [
      document.getElementById("popup-dedicatoria"),
      document.getElementById("dedicatoria-input"),
    ];
    for (var i = 0; i < campos.length; i++) {
      if (campos[i] && campos[i].value) campos[i].value = "";
    }
    try {
      window.dispatchEvent(new CustomEvent("dedicatoria:change", { detail: { text: "" } }));
    } catch (e) { /* navegador viejo */ }
  }

  var promesaVisor = null;
  function cargarVisor(url) {
    if (window.PRLamp3D) return Promise.resolve(window.PRLamp3D);
    if (promesaVisor) return promesaVisor;
    promesaVisor = new Promise(function (ok, mal) {
      var sc = document.createElement("script");
      sc.src = url;
      sc.onload = function () {
        window.PRLamp3D ? ok(window.PRLamp3D) : mal(new Error("sin PRLamp3D"));
      };
      sc.onerror = function () { mal(new Error("no carga lamp-3d.js")); };
      document.head.appendChild(sc);
    });
    return promesaVisor;
  }

  // ------------------------------------------- la galeria encoge al bajar
  /**
   * EL CUADRO DE ARRIBA SE HACE PEQUEÑO SEGUN SE BAJA.
   *
   * Pegado arriba, el cuadro se lleva media pantalla del movil. Eso esta
   * bien en los primeros pasos —es lo que se esta mirando— pero abajo, con
   * la dedicatoria o los complementos a medio rellenar, le quita el sitio a
   * lo que el cliente esta tocando.
   *
   * Asi que el tope de alto tiene DOS MEDIDAS, no un degradado: entero
   * arriba del todo, y pequeño en cuanto se empieza a bajar. Antes encogia
   * poco a poco a lo largo de 520px de scroll, y eso hacia que el contenido
   * de debajo fuese subiendo solo mientras se desplazaba: el dedo iba a una
   * velocidad y la pagina a otra. De un paso el cambio se ve y se entiende.
   *
   * No se toca el DOM ni se mueve nada; solo se escribe un numero en
   * `--pzx-gal-alto`, y el CSS lo reparte entre la foto, el lienzo del
   * editor y el visor 3D.
   *
   * Solo en movil: en escritorio la galeria va al lado del panel y no le
   * quita sitio a nadie.
   */
  var MOVIL = window.matchMedia ? window.matchMedia("(max-width: 1024px)") : null;

  /**
   * LA LAMPARA CON PEANA PIDE UN POCO MAS DE MARCO.
   *
   * Lo que se mira mientras se escribe la dedicatoria es una franja de
   * madera de dos dedos en la parte de abajo de la pieza, con el texto
   * grabado dentro. Con el reparto de siempre —pensado para un cuadro, que
   * llena el marco— esa franja se queda en nada justo cuando es lo unico
   * que importa. Aqui el marco va un punto mas alto; en el resto de fichas
   * no se toca nada.
   *
   * Se pregunta por el MODO que declara el propio personalizador, no por la
   * plantilla: la ficha puede cambiar de nombre y el modo no.
   */
  var ES_LAMPARA_BASE = (function () {
    var n = RAIZ.querySelector(".pr-customizer__config");
    if (!n) return false;
    try { return ((JSON.parse(n.textContent) || {}).mode || "") === "lampara-base"; }
    catch (e) { return false; }
  })();

  /**
   * EL NAVEGADOR NO PUEDE CORREGIR EL SCROLL EN EL CAMBIO.
   *
   * Cuando algo que queda POR ENCIMA de lo que se esta mirando cambia de
   * alto, el navegador mueve el scroll otro tanto para que lo que ves no se
   * te escape: es el "anclaje del scroll". Aqui eso era veneno. Al relevarse
   * las fotos y el editor, lo de arriba encoge unos 150px, el navegador
   * descontaba esos pixeles del scroll, y con el scroll mas arriba volvia a
   * cruzar el punto de cambio hacia atras. Medido en la pagina real: pones
   * la pagina en 119 y se queda saltando 119 -> 67 -> 119, editor y fotos
   * turnandose. De ahi que el editor saliera pegado arriba del todo, que es
   * justo donde no tiene que estar.
   *
   * Se apaga mientras dura el relevo y se vuelve a encender enseguida: lo
   * de abajo pega un salto —que es el cambio directo que se pide— y el
   * scroll se queda exactamente donde el cliente lo dejo.
   */
  var relojAnclaje = null;
  function sinAnclaje() {
    var doc = document.documentElement;
    doc.style.setProperty("overflow-anchor", "none");
    if (relojAnclaje) clearTimeout(relojAnclaje);
    relojAnclaje = setTimeout(function () {
      relojAnclaje = null;
      // Escribiendo, el anclaje se queda apagado toda la sesion: lo pone
      // `tecladoYMarco` al entrar en el campo y lo quita al salir. Sin esta
      // linea, un relevo de galeria justo antes de tocar el campo dejaba
      // programado este borrado y se cargaba el apagado del tecleo.
      if (TECLEANDO.es) return;
      doc.style.removeProperty("overflow-anchor");
    }, 400);
  }

  /**
   * DONDE SE RELEVAN LAS FOTOS Y EL EDITOR.
   *
   * Arriba del todo manda la GALERIA DE FOTOS del producto —con el diseño
   * montado en su base de primera foto, que para eso se guarda la
   * instantanea—. El editor no asoma hasta que se ha bajado de verdad.
   *
   * No es el mismo punto a la ida y a la vuelta, a proposito: baja un buen
   * trozo de pantalla para que entre el editor, y solo vuelven las fotos
   * pegado arriba del todo. Con un unico punto, el propio salto de alto del
   * cambio lo volvia a cruzar.
   */
  var SALIDA = 24;              // px desde arriba para que vuelvan las fotos
  function entradaEditor() {
    // SOLO EN MOVIL hay un trozo de pagina "de arriba" que defender: ahi el
    // marco se queda pegado y el editor taparia las fotos desde el primer
    // dedo de scroll. En escritorio la galeria va al lado del panel, no le
    // quita el sitio a nadie, y el relevo sigue siendo al arrancar la ficha
    // —como estaba—: adelantarlo medio pantallazo solo haria aparecer el
    // editor de golpe con la galeria entera todavia a la vista.
    if (!MOVIL || !MOVIL.matches) return 2;
    // Poco mas de un quinto de pantalla, con suelo para moviles cortos.
    return Math.max(150, Math.round((window.innerHeight || 700) * 0.22));
  }
  function revisarLoAlto() {
    // CON EL TECLADO ABIERTO NO SE RELEVA NADA. El relevo entre las fotos y
    // el editor cambia el alto del recuadro, y con el teclado puesto eso es
    // un salto en la cara mientras se teclea. Safari desplaza la pagina el
    // solo al escribir, asi que esto llegaba a dispararse tecleando.
    //
    // Mira el TECLADO y no el foco: al escribir la dedicatoria de la tarjeta
    // el campo se queda con el foco puesto aunque ya no se escriba, y con la
    // condicion vieja la pagina se quedaba congelada —subias arriba del todo
    // y el marco seguia enseñando la tarjeta en vez del producto—.
    if (TECLEANDO.teclado) return;
    var ancla = RAIZ.getBoundingClientRect().top + (window.pageYOffset || 0);
    var bajado = (window.pageYOffset || 0) - ancla;
    var vuelta = MOVIL && MOVIL.matches ? SALIDA : 2;
    var es = EN_LO_ALTO.es ? bajado < entradaEditor() : bajado <= vuelta;
    if (es === EN_LO_ALTO.es) return;
    EN_LO_ALTO.es = es;
    sinAnclaje();
    // ARRIBA MANDA EL PRODUCTO, HAYA TARJETA O NO. La tarjeta ocupa el marco
    // igual que el editor, asi que arriba del todo se aparta igual que el:
    // ahi se mira lo que se compra —las fotos del producto con el diseño— y
    // no la dedicatoria. Se hace ANTES de la instantanea: con la tarjeta
    // fuera, el editor vuelve a estar puesto y la foto sale del cuadro de
    // verdad. Al bajar un dedo, la tarjeta vuelve a su marco.
    if (revisarTarjetaDelMarco) revisarTarjetaDelMarco();
    // La foto se toma ANTES de apartar lo nuestro: el visor 3D se esconde
    // al entrar en este modo, y de un lienzo escondido no se saca nada.
    // Asi lleva ademas los ultimos retoques —encuadre, giro, dedicatoria—
    // y no el diseño tal y como salio.
    if (es) verEnGaleria("");
    refrescarGaleria();
    // El carrusel del tema mide al redimensionar: si ha estado escondido,
    // vuelve con las medidas viejas y la primera foto sale descuadrada.
    try { window.dispatchEvent(new Event("resize")); } catch (e) { /* da igual */ }
  }

  // Mientras se escribe con el teclado en pantalla, el marco manda sobre
  // el scroll: ver donde cae la dedicatoria es justo lo que se esta
  // haciendo. Lo pone y lo quita `tecladoYMarco`, aqui abajo.
  // `es` = hay un campo con el foco. `teclado` = ADEMAS el teclado en
  // pantalla esta abierto de verdad (la ventana visible ha encogido). Son
  // cosas distintas: en escritorio se escribe sin que encoja nada, y en el
  // movil el foco se queda puesto despues de escribir aunque el teclado ya
  // se haya cerrado. Lo que molesta —tapar media pantalla— es el teclado.
  var TECLEANDO = { es: false, campo: null, teclado: false };

  /** ¿Esta el teclado en pantalla tapando media ficha? */
  function tecladoAbierto() {
    var vv = window.visualViewport;
    if (!vv) return false;
    return vv.height < (window.innerHeight || vv.height) - 120;
  }

  /** Lo apunta en la raiz para que lo pueda mirar el CSS. */
  function marcarTeclado(abierto) {
    if (TECLEANDO.teclado === abierto) return;
    TECLEANDO.teclado = abierto;
    RAIZ.classList.toggle("pzx-teclado", abierto);
    // Al cerrarse, la pagina vuelve a mandar: se repasa quien ocupa el marco.
    if (!abierto) revisarLoAlto();
  }

  /**
   * LA PAGINA SE QUEDA DONDE ESTA.
   *
   * Al enfocar un campo, el navegador desplaza la pagina para enseñarlo, y
   * en el movil ademas vuelve a hacerlo cuando el teclado termina de subir.
   * Aqui ese desplazamiento sobra: el campo se queda PEGADO encima del
   * teclado, o sea que ya esta a la vista. Lo unico que conseguia era dejar
   * el paso de la tarjeta medio fuera de pantalla cada vez que se volvia a
   * abrir el teclado.
   *
   * Se anota donde estaba la pagina y se la devuelve ahi: en el acto, en el
   * fotograma siguiente, a los 90 ms y a los 300 —lo que tarda el teclado en
   * subir—. Y se acabo: mas repasos que esos se notan peor que el salto que
   * arreglan. Solo se escribe el scroll si se ha movido de verdad; escribir
   * el mismo valor que ya hay despierta a Safari para nada.
   */
  function altoGaleria() {
    revisarLoAlto();
    if (!MOVIL || !MOVIL.matches) {
      RAIZ.style.removeProperty("--pzx-gal-alto");
      return;
    }
    var galeria = RAIZ.querySelector(".pz-prod__galeria");
    if (!galeria) return;
    if (TECLEANDO.es) {
      // CON EL TECLADO ABIERTO, EL CUADRO SE QUEDA CON TODO LO QUE SOBRE.
      //
      // Antes se le daba un 46% de lo que se ve, que con el teclado abierto
      // son cuatro dedos de cuadro: se escribia la dedicatoria sin poder ver
      // donde cae, que es justo lo que se queria evitar.
      //
      // Una resta y nada mas: debajo del marco tiene que caber el campo con
      // su titulo y su linea de ayuda —150px de sobra para los tres— y el
      // resto es del cuadro. Un solo numero, sin medir nada del DOM: medir
      // aqui obligaba a recalcular la maqueta en cada aviso del teclado, y
      // eso es parte de lo que hacia que el area diera saltos.
      var visible = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      // Hay que dejar hueco de verdad debajo del marco: el campo se escribe
      // donde vive, con su titulo y su contador, y los tres caen ahi. Con
      // 150 px se quedaban a medias.
      // En la lampara con peana se recorta la reserva: debajo del marco solo
      // cae el campo con su titulo y su contador, y 220px dejaban el
      // grabado —que es lo que se esta mirando— mas pequeño de lo que hace
      // falta para leerlo.
      var reserva = ES_LAMPARA_BASE ? 185 : 220;
      // PERO SOLO CON EL TECLADO ABIERTO DE VERDAD. Al tocar el campo
      // todavia no hay teclado: la ventana visible mide lo mismo que la
      // pagina entera y la resta daba 702px de marco. El cliente veia media
      // pantalla de pared vacia con el cuadro perdido al fondo nada mas
      // tocar la dedicatoria, antes de que se abriera nada. Si no hay
      // teclado, no se toca el reparto: sigue el de siempre, mas abajo.
      if (visible < window.innerHeight - 120) {
        // Con tope ademas de suelo: esto es para APARTAR sitio al campo, no
        // para agrandar el cuadro mas de lo que mide con la pagina quieta.
        RAIZ.style.setProperty(
          "--pzx-gal-alto",
          Math.max(190, Math.min(Math.round(visible - reserva), Math.round(window.innerHeight * (ES_LAMPARA_BASE ? 0.5 : 0.42)))) + "px"
        );
        return;
      }
    }
    // Con el editor o el visor puestos se parte de mas alto, porque ahi
    // dentro hay herramientas; aun asi encoge lo suyo.
    var editando = galeria.classList.contains("is-editando");
    // Abajo se queda en un tercio de pantalla largo: lo justo para seguir
    // viendo lo que se compra mientras se rellena lo de abajo. Con 45vh
    // —que fue el primer intento— seguia comiendose media pantalla.
    var arriba = editando ? 42 : 52;
    var abajo = editando ? (ES_LAMPARA_BASE ? 34 : 28) : 26;
    // UN SOLO PUNTO DE CAMBIO para el tamaño y para quien ocupa el marco:
    // arriba, las fotos a su medida; al bajar, el marco pequeño con el
    // editor. Dos puntos distintos daban dos saltos seguidos.
    var alto = EN_LO_ALTO.es ? arriba : abajo;
    // Con el editor puesto, 50px mas por abajo. En vh se quedaba justo: el
    // lienzo y la barra de tipos de cuadro se reparten el alto, y al cuadro
    // le faltaba un dedo para respirar. Van en pixeles a proposito, para
    // que sean los mismos en un movil pequeño que en una pantalla larga.
    var extra = editando ? 100 : 0;
    RAIZ.style.setProperty(
      "--pzx-gal-alto",
      extra ? "calc(" + alto.toFixed(1) + "vh + " + extra + "px)" : alto.toFixed(1) + "vh"
    );
  }
  window.__pztAltoGaleria = altoGaleria;
  altoGaleria();

  // ------------------------------------------- el marco, con el teclado abierto
  /**
   * ESCRIBIENDO LA DEDICATORIA SE SIGUE VIENDO EL CUADRO.
   *
   * Al abrirse el teclado del movil la pantalla util se queda en la mitad,
   * y entre el marco —que ocupa medio movil— y el teclado, el campo se iba
   * al fondo: el cliente escribia a ciegas, sin ver donde le cae la
   * dedicatoria, que es lo unico que importa en ese momento.
   *
   * Asi que mientras hay un campo con el foco el marco encoge a un tercio
   * de lo que QUEDA visible y se queda pegado arriba, y debajo queda sitio
   * de sobra para el campo, que se escribe donde vive. Al salir del campo
   * todo vuelve a su medida.
   */
  (function tecladoYMarco() {
    if (!MOVIL) return;
    var vv = window.visualViewport || null;
    var MARGEN = 8;

    function esCampo(n) {
      return !!(n && n.matches && n.matches("input[type='text'], input:not([type]), textarea"));
    }

    /**
     * NINGUN CAMPO SE PEGA AL TECLADO.
     *
     * Los hubo: el campo se iba fijo al borde de lo que quedaba visible,
     * con su titulo y su contador, y eso arreglaba los saltos de Safari.
     * Pero se escribe MIRANDO la vista previa, y ver el campo saltar al
     * suelo de la pantalla —encima del boton de WhatsApp y de los avisos de
     * premio— descoloca mas de lo que arregla. Primero se saco a los tres
     * de la tarjeta y despues a la dedicatoria del cuadro; no quedaba
     * ninguno al que le sentara bien.
     *
     * Asi que cada campo se escribe donde esta. Tampoco se sujeta la
     * pagina: si el navegador tiene que desplazar para enseñar el campo que
     * toca, que lo haga —sin pegarlo, es la unica manera de que se vea—; lo
     * unico que se hace es un empujon al final, `asomarCampo`, si el
     * teclado lo ha dejado debajo.
     */

    /**
     * EL MARCO, DENTRO DE LO QUE SE VE.
     *
     * En el iPhone el teclado no encoge la pagina: la tapa. La ventana de
     * maquetacion sigue midiendo lo mismo y Safari desplaza el contenido
     * hacia arriba, asi que un elemento pegado con `top: 0` se queda arriba
     * de todo, fuera de la mitad que el cliente esta viendo. La ventana
     * visible dice cuanto se ha desplazado, y ese es el `top` que le toca.
     */
    function pegarMarco() {
      var marco = RAIZ.querySelector(".pz-prod__marco");
      if (!marco) return;
      if (TECLEANDO.es && vv) {
        marco.style.setProperty("top", Math.max(0, Math.round(vv.offsetTop)) + "px", "important");
      } else {
        marco.style.removeProperty("top");
      }
    }

    /**
     * EL BLOQUE ENTERO DEL CAMPO: titulo, campo y contador.
     *
     * Lo que hay que dejar a la vista no es el recuadro de escribir, sino
     * los tres juntos: con el campo visible pero su titulo detras del
     * marco, el cliente no sabe cual de los pasos esta rellenando, y el
     * contador —«0/50»— es la mitad de la informacion cuando el texto tiene
     * tope. Lo usa `asomarCampo` para medir.
     */
    function envoltorio(campo) {
      return campo.closest(
        "#dedicatoria-input-wrapper, .cp-fields label, .pzx__campo, .pzx__dedibase"
      ) || campo.parentElement;
    }

    /**
     * EL CAMPO, A LA VISTA AL SUBIR EL TECLADO.
     *
     * Como ninguno se pega al borde, el teclado puede dejarlo debajo.
     * Safari suele desplazar el solo, pero no cuando el campo ya estaba
     * enfocado antes de que el teclado terminara de subir. Un solo empujon,
     * el justo para dejarlo a la vista con sitio para su contador, y nada
     * mas: ni reintentos ni sujeciones. Si ya se ve, no se toca.
     */
    function asomarCampo() {
      var campo = TECLEANDO.campo;
      if (!campo) return;
      var visible = (vv && vv.height) || window.innerHeight;
      // Se mide el BLOQUE entero —titulo, campo y contador—, no el campo
      // suelto: con el campo a la vista pero su titulo detras del marco, el
      // cliente no sabe cual de los tres esta rellenando.
      var r = (envoltorio(campo) || campo).getBoundingClientRect();
      var abajo = visible - 16;
      // El marco esta pegado arriba y tapa lo que pase por debajo: el techo
      // no es el borde de la pantalla, es donde acaba el marco. Sin esto, un
      // campo "dentro de la ventana" podia estar escondido detras de la
      // vista previa y el cliente escribia a ciegas.
      var marco = RAIZ.querySelector(".pz-prod__marco");
      var techo = 12;
      if (marco) {
        var rm = marco.getBoundingClientRect();
        if (rm.height > 4) techo = Math.max(techo, Math.round(rm.bottom) + 8);
      }
      if (r.top >= techo && r.bottom <= abajo) return;
      var y = (window.pageYOffset || 0) +
              (r.top < techo ? (r.top - techo) : (r.bottom - abajo));
      window.scrollTo(0, Math.max(0, Math.round(y)));
    }

    function entrar(e) {
      if (!esCampo(e.target) || !RAIZ.contains(e.target)) return;
      if (!MOVIL.matches) return;
      TECLEANDO.es = true;
      TECLEANDO.campo = e.target;
      RAIZ.classList.add("pzx-tecleando");
      marcarTeclado(tecladoAbierto());
      // Ni el navegador corrige el scroll mientras se escribe: cada tecla
      // repinta el resumen de abajo y el ancla se pierde al rehacerse.
      document.documentElement.style.setProperty("overflow-anchor", "none");
      altoGaleria();
      pegarMarco();
      // Con el teclado ya abierto (relevo entre campos) no hay cambio de
      // ventana que avise: se repasa una vez, pasado el repintado.
      setTimeout(asomarCampo, 350);
    }

    function salir(e) {
      if (!TECLEANDO.es) return;
      if (e && e.target !== TECLEANDO.campo) return;
      TECLEANDO.es = false;
      TECLEANDO.campo = null;
      RAIZ.classList.remove("pzx-tecleando");
      marcarTeclado(false);
      document.documentElement.style.removeProperty("overflow-anchor");
      pegarMarco();
      altoGaleria();
    }

    document.addEventListener("focusin", entrar, true);
    document.addEventListener("focusout", salir, true);

    if (vv) {
      // El teclado no avisa de otra forma: lo que cambia es el alto de la
      // ventana visible. Se recoloca el recuadro de arriba, y el reparto de
      // alto solo si el cambio es de verdad el teclado y no el temblor de la
      // barra de sugerencias de Safari, cuarenta pixeles arriba y abajo.
      var ultimoAlto = 0;
      vv.addEventListener("resize", function () {
        marcarTeclado(tecladoAbierto());
        if (!TECLEANDO.es) return;
        pegarMarco();
        var ahora = Math.round(vv.height);
        if (Math.abs(ahora - ultimoAlto) < 80) return;
        ultimoAlto = ahora;
        altoGaleria();
        // El teclado acaba de subir o de bajar: si el campo que se esta
        // escribiendo es de los que se quedan en su sitio, hay que
        // asegurarse de que no se lo ha comido.
        asomarCampo();
      });
      vv.addEventListener("scroll", function () {
        if (!TECLEANDO.es) return;
        pegarMarco();
      });
    }
  })();

  // ------------------------------------------- guardar al comprar
  /**
   * El editor incrustado ya no tiene boton de Guardar: dentro de la galeria
   * solo se ve el lienzo. El diseno se compone AL AÑADIR AL CARRITO.
   *
   * COMO. Se pulsa por dentro el Guardar del widget —que sigue existiendo,
   * solo esta escondido por CSS— y se espera a su evento de fin,
   * `portrait:confirmed`, que es el que avisa de que la imagen compuesta ya
   * esta alojada y las properties del pedido escritas. Hasta entonces no se
   * deja seguir: comprar antes añadiria una linea sin imagen.
   *
   * Se engancha en `pointerdown` y no en `click` porque el snippet del
   * carrito escucha el click en el documento, en fase de captura, y se
   * registro antes que este fichero: ahi no hay forma de adelantarse. En
   * pointerdown si, porque ocurre antes.
   */
  (function guardarAlComprar() {
    // A nivel de documento, asi que solo una vez aunque la seccion se
    // repinte: si no, en el editor se acumularia un escuchador por cambio de
    // ajuste y el Guardar se dispararia varias veces.
    if (window.__pztGuardarAlComprar) return;
    window.__pztGuardarAlComprar = true;
    var ATC = "[data-pz-comprar]";
    var guardando = false;
    var CAMPO_MONTAJE = "properties[_Montaje con base]";
    var firmaMontaje = "";

    /**
     * LA MINIATURA DEL CARRITO, CON SU BASE.
     *
     * Lo que se compone al guardar es el cuadro a solas —marco y diseño—,
     * que es lo que hay que fabricar. Pero si el cliente ha elegido base, en
     * el carrito tiene que reconocer lo que compra: la pieza de pie sobre su
     * peana, igual que la ha estado viendo arriba.
     *
     * Asi que se guarda una SEGUNDA imagen, la del visor 3D, y se mete LA
     * PRIMERA del formulario. El cajon del carrito elige la miniatura
     * puntuando los nombres de las properties —«montaje», «vista previa»,
     * «final» y «personalizada» valen lo mismo— y a igual nota se queda con
     * la primera que encuentra. El widget escribe varias que empatan, asi
     * que no basta con adelantar a una: hay que ir delante de todas.
     *
     * La de produccion no se toca: «Imagen personalizada» sigue siendo el
     * cuadro a solas. Esta otra lleva `_` delante, asi que no se le enseña a
     * nadie como texto ni viaja visible al pedido.
     */
    function proxyBase() {
      var n = RAIZ.querySelector(".pr-customizer__config");
      try { return (JSON.parse(n.textContent) || {}).proxyBase || ""; } catch (e) { return ""; }
    }

    function campoImagenWidget() {
      return RAIZ.querySelector('[name="properties[Imagen personalizada]"]');
    }

    function firmaActual() {
      var img = campoImagenWidget();
      return [
        estado.base ? estado.base.variantId : "",
        dedicatoriaBase(),
        dedicatoriaActual(),
        img ? String(img.value || "") : "",
      ].join("|");
    }

    function campoMontaje() {
      return RAIZ.querySelector('[name="' + CAMPO_MONTAJE + '"]');
    }

    /** ¿Hay que rehacer la miniatura con base antes de comprar? */
    function montajePendiente() {
      if (!estado.base || !visor3d) return !!campoMontaje();   // sobra la vieja
      return firmaActual() !== firmaMontaje || !campoMontaje();
    }

    function guardarMontaje() {
      var viejo = campoMontaje();
      if (!estado.base || !visor3d) {
        // Sin base no hay nada que enseñar de mas: fuera, o el carrito
        // seguiria pintando una peana que el cliente ya no lleva.
        if (viejo && viejo.parentNode) viejo.parentNode.removeChild(viejo);
        firmaMontaje = "";
        return Promise.resolve();
      }
      var firma = firmaActual();
      if (viejo && firma === firmaMontaje) return Promise.resolve();

      var dataUrl;
      try {
        // El visor pinta con `preserveDrawingBuffer`, asi que el lienzo se
        // puede leer sin forzar nada; aun asi se repinta antes, por si el
        // ultimo fotograma quedo a medias.
        if (typeof visor3d.render === "function") visor3d.render();
        dataUrl = visor3d.canvas.toDataURL("image/png");
      } catch (e) {
        return Promise.resolve();          // mejor sin miniatura que sin compra
      }
      var base = proxyBase();
      if (!base || !dataUrl) return Promise.resolve();

      return fetch(base + "/compose", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dataUrl: dataUrl }),
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.url) return;
          var campo = campoMontaje();
          if (!campo) {
            var f = RAIZ.querySelector('form[action*="/cart/add"]');
            if (!f) return;
            campo = document.createElement("input");
            campo.type = "hidden";
            campo.name = CAMPO_MONTAJE;
            // La PRIMERA del formulario: el orden del carrito es el del
            // formulario, y a igual puntuacion gana la primera.
            f.insertBefore(campo, f.firstChild);
          }
          campo.value = d.url;
          firmaMontaje = firma;
        })
        .catch(function () { /* el carrito enseñara el montaje plano */ });
    }

    function editorAbierto() {
      var hueco = RAIZ.querySelector("[data-pzx-editor]");
      return !!(hueco && !hueco.hidden && hueco.querySelector("[data-pr-confirm]"));
    }

    /** ¿Ya hay una imagen compuesta escrita en el formulario? */
    function hayDisenoGuardado() {
      var n = RAIZ.querySelector('[name="properties[Imagen personalizada]"]');
      return !!(n && String(n.value || "").trim());
    }

    /** Pulsa el Guardar escondido y espera a que termine de componer. */
    function guardar() {
      return new Promise(function (resolve, reject) {
        var btn = RAIZ.querySelector("[data-pzx-editor] [data-pr-confirm]");
        // Estos dos mensajes NO son solo de consola: el aviso de abajo los
        // enseña entre parentesis («No pudimos guardar tu diseño (…)»).
        if (!btn) { reject(new Error(PZ_DE ? "Editor nicht verfügbar" : PZ_EN ? "editor not available" : PZ_IT ? "editor non disponibile" : "sin editor")); return; }
        var fin = null;
        var reloj = setTimeout(function () {
          window.removeEventListener("portrait:confirmed", fin);
          reject(new Error(PZ_DE ? "Zeitüberschreitung" : PZ_EN ? "timed out" : PZ_IT ? "tempo scaduto" : "tardo demasiado"));
        }, 45000);
        fin = function (ev) {
          // El aviso que damos nosotros para enseñar el diseño en la galeria
          // lleva marca: no significa que la imagen definitiva este alojada,
          // asi que no vale como fin del guardado.
          if (ev && ev.detail && ev.detail.pzxSoloVer) return;
          clearTimeout(reloj);
          window.removeEventListener("portrait:confirmed", fin);
          // Un respiro: las properties se escriben justo despues del evento.
          setTimeout(resolve, 250);
        };
        window.addEventListener("portrait:confirmed", fin);
        btn.click();
      });
    }

    document.addEventListener("pointerdown", function (e) {
      var btn = e.target.closest && e.target.closest(ATC);
      if (!btn || guardando) return;
      // Sin editor abierto no hay nada que componer: o ya se guardo antes, o
      // no hay diseno y de eso ya avisa el snippet del carrito.
      var faltaDiseno = editorAbierto() && !hayDisenoGuardado();
      // La miniatura con base se rehace tambien cuando el diseño ya estaba
      // guardado: el cliente pudo cambiar de base despues.
      var faltaMontaje = montajePendiente();
      if (!faltaDiseno && !faltaMontaje) return;

      // Se corta ESTE clic —el boton se deshabilita antes de que llegue— y
      // se vuelve a pulsar solo cuando la imagen esta lista.
      guardando = true;
      btn.disabled = true;
      var textoPrevio = btn.textContent;
      btn.textContent = (PZ_DE ? "Dein Design wird gespeichert …" : PZ_EN ? "Saving your design…" : PZ_IT ? "Salvataggio del design…" : "Guardando tu diseño…");

      (faltaDiseno ? guardar() : Promise.resolve()).then(guardarMontaje).then(function () {
        btn.disabled = false;
        btn.textContent = textoPrevio;
        guardando = false;
        // Ahora si: se repite la pulsacion y sigue el camino de siempre.
        btn.click();
      }, function (err) {
        btn.disabled = false;
        btn.textContent = textoPrevio;
        guardando = false;
        // Que no se quede una compra a medias sin explicacion.
        var aviso = RAIZ.querySelector("[data-pzx-aviso-guardado]");
        if (aviso) {
          aviso.textContent = PZ_EN
            ? "We couldn't save your design (" + ((err && err.message) || "error") + "). Please try again."
            : PZ_IT
            ? "Non è stato possibile salvare il tuo design (" + ((err && err.message) || "errore") + "). Riprova."
            : PZ_DE
            ? "Dein Design konnte nicht gespeichert werden (" + ((err && err.message) || "Fehler") + "). Bitte versuch es erneut."
            : "No pudimos guardar tu diseño (" +
            ((err && err.message) || "error") + "). Inténtalo de nuevo.";
          aviso.hidden = false;
        }
      });
    }, true);
  })();

  /**
   * Acaba de aterrizar un diseño NUEVO en el lienzo del editor.
   *
   * Lo avisa el widget (`portrait:editor-ready`) cada vez que termina de
   * montar uno, sea el retrato con IA o la foto original. Hay que rehacer lo
   * que se ve arriba: quien ocupa el marco de la galeria y, si hay base
   * puesta, la instantanea del cuadro que se apoya en ella. Sin esto, el
   * cliente generaba el segundo diseño y seguia viendo el primero.
   *
   * La instantanea no se toma al vuelo: el widget coloca el diseño en su
   * sitio en el repintado siguiente, asi que se deja el respiro de siempre.
   */
  var disenoEnGaleria = "";
  // Si el cliente ya ha tenido un diseno delante: lo mira
  // `fotoNuevaReinicia` para saber si la foto que entra es una SUSTITUCION.
  var huboDiseno = false;

  /**
   * EL DISEÑO, TAMBIEN EN LA GALERIA DE FOTOS.
   *
   * Arriba del todo manda la galeria del tema, y ahi el cliente tiene que
   * poder VER lo que ha generado, no solo las fotos de muestra. El tema ya
   * sabe meter el diseño como primera foto —con su miniatura y todo— y lo
   * hace al oir `portrait:confirmed`; aqui se le avisa en cuanto el diseño
   * aterriza en el editor, sin esperar a la compra.
   *
   * El aviso va MARCADO (`pzxSoloVer`) porque ese mismo evento es el que
   * espera el guardado al comprar para saber que la imagen definitiva esta
   * alojada: sin la marca, un diseño que llegara justo durante la compra le
   * haria creer que ya estaba guardada.
   */
  /**
   * El diseño TAL Y COMO HA QUEDADO: lo que se ve en el editor —marco,
   * encuadre, dedicatoria y pared— sin las guias de edicion. El widget lo
   * expone en su propio lienzo. La URL del diseño a secas no vale: es el
   * dibujo suelto, sin marco ni encuadre, y el cliente veia en la galeria
   * algo que no se parecia a su cuadro.
   */
  /**
   * ¿El fondo del lienzo es decorado o es el producto?
   *
   * En el cuadro es una pared: lo que se compra es el marco, y el resto
   * sobra. En la lampara es la pieza encendida sobre su peana: quitarlo deja
   * un dibujo suelto. El modo lo dice la propia configuracion del widget.
   *
   * Si algún producto nuevo vuelve a tener la escena por producto —paneles,
   * skate—, basta con añadir su modo a la lista.
   */
  /**
   * LA ESCENA, CARGADA DE ANTEMANO.
   *
   * La instantanea se pide de golpe, al subir del todo, y tiene que devolver
   * la imagen en el momento: no hay donde esperar a que baje un PNG. Se
   * precarga al arrancar y se guarda; si no hay escena o no llega, queda en
   * `false` y la recomposicion se aparta sola.
   */
  var escenaImg = null;
  /**
   * LA ULTIMA VEZ QUE SE PUDO REHACER EL MONTAJE.
   *
   * Solo se puede rehacer mientras el editor esta montado, porque de ahi
   * salen el lienzo y las medidas. Al guardar, el editor se cierra y se
   * lleva el lienzo con el — y justo entonces es cuando el cliente sube
   * arriba a ver como ha quedado. Se guarda la ultima buena para tener algo
   * que enseñar, que es ademas lo que acaba de estar mirando.
   */
  var ultimaConEscena = "";
  (function precargarEscena() {
    var n = RAIZ.querySelector(".pr-customizer__config");
    var url = "";
    try { url = (JSON.parse(n.textContent) || {}).sceneBackgroundUrl || ""; } catch (e) { url = ""; }
    if (!url) { escenaImg = false; return; }
    var im = new Image();
    // Sin esto el lienzo queda "contaminado" y toDataURL revienta: la escena
    // vive en el CDN de Shopify, que es otro dominio.
    im.crossOrigin = "anonymous";
    im.onload = function () { escenaImg = im; };
    im.onerror = function () { escenaImg = false; };
    im.src = url;
  })();

  /**
   * LA PIEZA, OTRA VEZ SOBRE SU ESCENA.
   *
   * Se rehace en un lienzo aparte lo mismo que compone el navegador en
   * pantalla: la escena encajada `cover` y centrada sobre el recuadro, y
   * encima el lienzo del editor en el sitio y el tamaño exactos que ocupa.
   * Las medidas se leen de la pagina, no se adivinan, asi que sale igual
   * aunque el recuadro cambie de alto al bajar o al abrirse el teclado.
   */
  /**
   * EL LIENZO DEL VISOR 3D, SI ESTA PUESTO.
   *
   * El widget monta el visor DENTRO del mismo recuadro que el lienzo plano
   * (`.pr-modal__canvas-wrap`) y esconde el de Fabric. No se puede pedir por
   * clase —no la tiene— asi que se descartan los conocidos y se queda con el
   * que tenga contexto WebGL.
   *
   * Pedirle el contexto no molesta: devuelve el que ya existe. Y sobre un
   * lienzo 2D devuelve null, que es justo lo que se quiere.
   */
  function lienzo3dDeLaLampara() {
    var wrap = RAIZ.querySelector("[data-pzx-editor] .pr-modal__canvas-wrap");
    if (!wrap) return null;
    var cs = wrap.querySelectorAll("canvas");
    for (var i = 0; i < cs.length; i++) {
      var c = cs[i];
      if (c.hasAttribute("data-pr-canvas")) continue;
      if (c.classList && c.classList.contains("upper-canvas")) continue;
      if (!c.width || !c.height) continue;
      try {
        if (c.getContext("webgl2") || c.getContext("webgl")) return c;
      } catch (e) { /* un 2d ya cogido: no es el nuestro */ }
    }
    return null;
  }

  /**
   * ¿MANDA EL VISOR 3D?
   *
   * Dos señales, porque de una sola no me fio: el lienzo WebGL dentro del
   * recuadro, y —si ese no se deja encontrar— que el widget haya escondido
   * el contenedor del lienzo plano, que es justo lo que hace al montar el
   * visor.
   *
   * Importa acertar: con visor puesto, lo que el widget guarda YA es la
   * pieza en 3D sobre su escena, y encuadrada en cuadrado para la galeria.
   * Si el tema se pone a recomponer encima, la cambia por una peor —la
   * figura plana, como una pegatina—. Ante la duda, el tema se aparta.
   */
  function tresDPuesto() {
    var wrap = RAIZ.querySelector("[data-pzx-editor] .pr-modal__canvas-wrap");
    if (!wrap) return false;
    if (lienzo3dDeLaLampara()) return true;
    var plano = wrap.querySelector("[data-pr-canvas]");
    var cont = plano && plano.parentNode;
    return !!(cont && cont.style && cont.style.display === "none");
  }

  function instantaneaConEscena(lienzo) {
    if (!escenaImg || !escenaImg.width) return "";
    var wrap = lienzo.closest ? lienzo.closest(".pr-modal__canvas-wrap") : null;
    if (!wrap) return "";
    var rw = wrap.getBoundingClientRect();
    var rc = lienzo.getBoundingClientRect();
    if (!rw.width || !rw.height || !rc.width || !rc.height) return "";
    var ANCHO = 1200;
    var k = ANCHO / rw.width;
    var out = document.createElement("canvas");
    out.width = Math.max(1, Math.round(rw.width * k));
    out.height = Math.max(1, Math.round(rw.height * k));
    var ctx = out.getContext("2d");
    if (!ctx) return "";
    var ri = escenaImg.width / escenaImg.height;
    var rr = out.width / out.height;
    var dw, dh;
    if (ri > rr) { dh = out.height; dw = Math.round(dh * ri); }
    else { dw = out.width; dh = Math.round(dw / ri); }
    try {
      ctx.drawImage(escenaImg, Math.round((out.width - dw) / 2), Math.round((out.height - dh) / 2), dw, dh);
      ctx.drawImage(lienzo, Math.round((rc.left - rw.left) * k), Math.round((rc.top - rw.top) * k),
                    Math.round(rc.width * k), Math.round(rc.height * k));
      return out.toDataURL("image/png");
    } catch (e) {
      return "";   // lienzo contaminado o escena que no deja leerse
    }
  }

  /**
   * DONDE LA ESCENA ES PARTE DE LO QUE SE COMPRA.
   *
   * En el cuadro, la pared ya viene dentro de la imagen que se guarda y no
   * hay nada que reponer. En estas piezas no: el visor 3D las enseña
   * colgadas o apoyadas en su habitacion, y el fichero que se guarda es la
   * pieza sola sobre transparencia. Si el tema no vuelve a juntarlas, arriba
   * del todo —justo cuando el cliente sube a ver como ha quedado— aparece el
   * dibujo flotando en blanco.
   *
   * El PORTALLAVES entra aqui desde el 29-10-2026: monta el mismo visor, con
   * su fondo de escena, y se veia igual de desnudo que la lampara antes del
   * arreglo.
   *
   * El RELOJ entra el 31-10-2026, por lo mismo: monta el visor en modo
   * «reloj», la pared se la pone el bloque como fondo de escena, y el
   * fichero que se guarda es la esfera sola sobre transparencia. Sin estar
   * en esta lista, subir arriba del todo cambiaba el reloj colgado por la
   * foto recortada flotando en blanco.
   */
  var MODOS_ESCENA = ["lampara", "lampara-base", "portallaves", "reloj"];
  function escenaEsElProducto() {
    var n = RAIZ.querySelector(".pr-customizer__config");
    if (!n) return false;
    try {
      var m = (JSON.parse(n.textContent) || {}).mode || "";
      return MODOS_ESCENA.indexOf(String(m)) !== -1;
    } catch (e) { return false; }
  }

  /**
   * UNA FOTO EN BLANCO NO ES UNA FOTO.
   *
   * Mientras la tarjeta ocupa el marco, el visor 3D se queda tapado detras
   * y le llegan los `resize` de la tarjeta: se remide escondido y su lienzo
   * se vacia. Al subir arriba del todo se le pedia la foto justo cuando se
   * acababa de destapar, antes de su siguiente fotograma, y la galeria
   * cambiaba el diseño del cliente por un recuadro blanco.
   *
   * Asi que antes de dar una foto por buena se mira que tenga algo pintado.
   * Si esta vacia se responde como si no hubiera foto, y la galeria se
   * queda con la ultima buena —la que se tomo antes de tapar el editor—.
   */
  function lienzoVacio(c) {
    try {
      var m = document.createElement("canvas");
      m.width = 32; m.height = 32;
      var x = m.getContext("2d");
      if (!x) return false;
      x.drawImage(c, 0, 0, 32, 32);
      // Vacio es TODO DEL MISMO COLOR, sea transparente o blanco: un
      // fotograma de verdad lleva la escena detras y nunca es liso.
      var d = x.getImageData(0, 0, 32, 32).data, n = 0;
      for (var i = 4; i < d.length; i += 4) {
        if (Math.abs(d[i] - d[0]) + Math.abs(d[i + 1] - d[1]) +
            Math.abs(d[i + 2] - d[2]) + Math.abs(d[i + 3] - d[3]) > 24) n++;
      }
      // Menos de un 1 % distinto: vacio (o a medio pintar, que es igual).
      return n < 10;
    } catch (e) { return false; }   // no se deja leer: no se descarta por eso
  }

  function instantaneaDiseno() {
    // CON BASE PUESTA manda el visor: lo que se compra es el cuadro de pie
    // sobre su peana, no el marco suelto, y es lo que se ha estado viendo
    // arriba mientras se personalizaba.
    if (estado.base && visor3d && visor3d.canvas) {
      try {
        if (typeof visor3d.render === "function") visor3d.render();
        var conBase = lienzoVacio(visor3d.canvas) ? "" : visor3d.canvas.toDataURL("image/png");
        if (conBase && conBase.length > 1000) return conBase;
      } catch (e) { /* visor a medio montar: se cae al lienzo del editor */ }
    }
    var lienzo = RAIZ.querySelector("[data-pzx-editor] [data-pr-canvas]");
    if (!lienzo) return "";
    try {
      // CENTRADA. El lienzo tiene mas pared debajo de la moldura que encima
      // —ahi se apoya la peana— y el volcado entero salia en la galeria con
      // el cuadro pegado arriba. `__prVistaCentrada` recorta lo que sobra.
      // Si el widget que haya en cache es viejo y no la trae, se cae a la de
      // siempre: encuadre flojo, pero cuadro al fin y al cabo.
      // EN LA LAMPARA, LA ESCENA NO ESTA DENTRO DEL LIENZO.
      //
      // El editor la pinta por CSS —`--pr-bg-pared`, cover y centrada, sobre
      // `.pr-modal__canvas-wrap`— y deja el lienzo TRANSPARENTE a proposito,
      // porque de ahi sale la silueta que se extruye. Asi que cualquier
      // volcado del lienzo sale con la pieza flotando: ni peana, ni mesa, ni
      // habitacion. Aqui se vuelve a juntar lo que el cliente esta viendo.
      if (escenaEsElProducto()) {
        // CON EL VISOR 3D PUESTO, LA FOTO SALE DE EL.
        //
        // El visor ya lleva la escena dentro —el bloque le pasa el fondo— y
        // es lo que el cliente esta viendo de verdad: la pieza con grosor,
        // su brillo y su sombra. Pegar el lienzo plano sobre la escena daba
        // el fondo bien pero la figura como una pegatina.
        //
        // Se puede leer tal cual porque el visor conserva el buffer de
        // dibujo (`preserveDrawingBuffer`): el ultimo fotograma sigue ahi.
        var tresD = lienzo3dDeLaLampara();
        if (tresD) {
          try {
            var d3 = lienzoVacio(tresD) ? "" : tresD.toDataURL("image/png");
            if (d3 && d3.length > 1000) {
              ultimaConEscena = d3;
              return d3;
            }
          } catch (e3) { /* contexto perdido: se cae al montaje plano */ }
        }
        // Hay visor pero no se ha podido leer (contexto perdido, por
        // ejemplo): no se inventa un montaje plano, que seria peor que
        // dejar lo que ya hubiera.
        if (tresDPuesto()) return "";
        // Sin visor —WebGL apagado, movil antiguo— se rehace a mano, que es
        // el mismo respaldo que usa el widget.
        var conEscena = instantaneaConEscena(lienzo);
        if (conEscena) {
          ultimaConEscena = conEscena;
          return conEscena;
        }
      }
      if (typeof lienzo.__prVistaCentrada === "function") return lienzo.__prVistaCentrada();
      return typeof lienzo.__prVista === "function"
        ? lienzo.__prVista()
        : lienzo.toDataURL("image/png");
    } catch (e) { return ""; }   // lienzo contaminado: mejor nada que roto
  }

  function verEnGaleria(url, manda) {
    var tira = RAIZ.querySelector(".pz-prod__tira");
    // `manda` entra aunque la ficha tenga apagado el espejo del editor: es
    // justo como se apaga el montaje con la pared de la escena y se deja
    // solo el de la vista previa, que lleva la pieza limpia.
    if (!tira || (tira.dataset.pzDiseno !== "1" && !manda)) return;
    // LO QUE SE GUARDA NO SIRVE PARA ENSEÑARLO.
    //
    // En la lampara, el montaje que viaja al pedido es la pieza sobre
    // TRANSPARENCIA: la escena la pone el editor por CSS y nunca entra en el
    // fichero. Asi que al guardar, con el editor ya cerrado, la galeria se
    // quedaba con el dibujo flotando en blanco — y es justo el momento en
    // que el cliente sube arriba a ver como ha quedado. Antes de caer en esa
    // imagen se prefiere la ultima recomposicion con escena, que es lo que
    // ha estado viendo mientras lo colocaba.
    // `manda` lo pone quien trae un montaje MEJOR que la instantanea del
    // editor: hoy, la vista previa del tema, que compone la pieza limpia
    // —sin la pared de la escena— y con el aro del color elegido.
    var foto = manda ? url
      : (instantaneaDiseno() ||
         (escenaEsElProducto() ? ultimaConEscena : "") ||
         url);
    if (!foto || disenoEnGaleria === foto) return;
    disenoEnGaleria = foto;
    try {
      window.dispatchEvent(new CustomEvent("portrait:confirmed", {
        detail: { image: foto, pzxSoloVer: true },
      }));
    } catch (e) { /* navegador viejo: se queda sin la foto en la galeria */ }
  }

  /**
   * LA FOTO BUENA SE TOMA AL PULSAR GUARDAR, NO DESPUES.
   *
   * El montaje con escena solo se puede rehacer mientras el editor esta
   * montado: de ahi salen el lienzo y las medidas. Al guardar, el editor se
   * cierra y vacia su hueco, asi que para cuando hay que reponer la imagen
   * ya no queda de donde sacarla. Se toma aqui, en el mismo gesto, y en fase
   * de CAPTURA para llegar antes que el widget.
   */
  function guardarInstantaneaConEscena() {
    if (!escenaEsElProducto()) return;
    // `instantaneaDiseno` ya prefiere el visor 3D y cae al montaje plano si
    // no lo hay; de paso deja la copia puesta.
    instantaneaDiseno();
  }
  ["pointerdown", "click"].forEach(function (evento) {
    document.addEventListener(evento, function (e) {
      var btn = e.target && e.target.closest && e.target.closest("[data-pr-confirm]");
      if (btn) guardarInstantaneaConEscena();
    }, true);
  });

  /**
   * AL GUARDAR, LA GALERIA SE QUEDABA CON LA PIEZA FLOTANDO.
   *
   * El guardado no pasa por `verEnGaleria`: es el propio widget el que
   * anuncia `portrait:confirmed` con la URL de lo que acaba de almacenar, y
   * la galeria lo pinta tal cual. En la lampara eso es la pieza sobre
   * transparencia —la escena vive en el CSS del editor y nunca entra en el
   * fichero—, asi que justo cuando el cliente sube a ver como ha quedado se
   * encontraba el dibujo flotando en blanco.
   *
   * Aqui se escucha ese anuncio y se repone el montaje: el que se rehace
   * ahora si el editor sigue montado, y si no el ultimo bueno, que es lo que
   * el cliente ha estado viendo mientras lo colocaba.
   *
   * No se muerde la cola: lo que anuncia el tema va marcado `pzxSoloVer` y
   * se ignora aqui. Y solo donde la escena ES el producto; en el cuadro la
   * imagen guardada ya trae la pared y no hay nada que reponer.
   */
  window.addEventListener("portrait:confirmed", function (e) {
    if (e && e.detail && e.detail.pzxSoloVer) return;
    if (!escenaEsElProducto()) return;
    // CON VISOR 3D NO SE TOCA NADA. Lo que el widget acaba de guardar es su
    // propio render: la pieza en 3D sobre la escena, y ademas encuadrada en
    // cuadrado para que la galeria no la recorte. Reponer aqui seria
    // cambiarla por una peor.
    if (tresDPuesto()) return;
    // Un respiro para que el widget termine de poner la suya: si se repone
    // antes, la pisa el al acabar.
    setTimeout(function () {
      var foto = instantaneaDiseno() || ultimaConEscena;
      if (!foto || disenoEnGaleria === foto) return;
      disenoEnGaleria = foto;
      try {
        window.dispatchEvent(new CustomEvent("portrait:confirmed", {
          detail: { image: foto, pzxSoloVer: true },
        }));
      } catch (err) { /* navegador viejo */ }
    }, 450);
  });

  function disenoNuevo(url, manda) {
    // Desde aqui, una foto nueva ya es una foto DISTINTA: ver
    // `fotoNuevaReinicia`.
    huboDiseno = true;
    refrescarGaleria();
    if (estado.base) refrescar3DconRetraso();
    // Un respiro: el widget coloca el diseño en su sitio en el repintado
    // siguiente, y sin el la instantanea sale a medio montar.
    setTimeout(function () { verEnGaleria(url, manda); }, 350);
  }
  window.__pztDisenoNuevo = disenoNuevo;

  // ------------------------------------------- dedicatoria en vivo
  /**
   * El lienzo del editor repinta la dedicatoria letra a letra, pero escucha
   * `dedicatoria:change` y ese evento no lo emite nadie en el tema: el campo
   * de la ficha solo dispara un `input` suyo. Aqui se traduce uno en otro.
   *
   * Asi hay UN solo campo —el del paso de dedicatoria— y lo que se escribe
   * se ve aparecer arriba, en el cuadro, que es justo lo que se pedia.
   */
  (function dedicatoriaEnVivo() {
    var campo = document.getElementById("dedicatoria-input");
    if (!campo) return;
    campo.addEventListener("input", function () {
      // Esta es la del MARCO: al lienzo del editor, y de ahi a la
      // instantanea que enseña el visor. La de la madera es otro campo, el
      // del paso de la base, y no pasa por aqui.
      repintarDedicatoria();
      pintar();
    });
  })();

  /**
   * AL RECARGAR, TODO VUELVE A «NO» MENOS LA FOTO.
   *
   * De una visita a la siguiente lo unico que se guarda es la foto subida:
   * es lo que cuesta de verdad volver a hacer en un movil. Los extras, no.
   * Y hay un motivo tecnico ademas del deseado: el navegador RESTAURA por
   * su cuenta el estado de los formularios al recargar —radios, casillas y
   * lo escrito—, asi que sin esto el cliente se encontraba la tarjeta en
   * «Si» o el llavero marcado mientras nuestro resumen decia que no habia
   * nada. Dos verdades distintas sobre el mismo pedido.
   *
   * Aqui se pulsa el «No» de cada paso —pasando por su propio codigo, que
   * es quien sabe apagar lo suyo— y se vacia lo escrito.
   */
  function reiniciarPasos(opciones) {
    // `salvoModalidad`: se usa al subir una foto distinta. El paso de
    // modalidad es justo el que el cliente esta usando en ese momento —el
    // recuadro de subir vive dentro—, asi que apagarlo le quitaria el suelo
    // de debajo de los pies.
    var salvoModalidad = !!(opciones && opciones.salvoModalidad);
    // Ni carteles ni fichas volando hacia atras por un reinicio: ver
    // `reiniciarPremios`.
    reiniciarPremios();
    function pulsa(sel) {
      // TODOS los que casen, no el primero: hay dos pasos de «si o no» del
      // mismo tipo (caja de regalo y base de metacrilato) y al recargar
      // tenian que volver los dos al «no».
      Array.prototype.forEach.call(RAIZ.querySelectorAll(sel), function (n) {
        if (n && !n.classList.contains("is-sel")) n.click();
      });
    }
    // EL TIPO DE CUADRO, DE VUELTA AL BASICO. Esto es lo primero: tras
    // recargar, la variante la trae la URL, y se quedaba en «+ IA (5,99 €)»
    // con la ficha entera en blanco —el precio decia 45,94 y los pasos
    // decian que no habia nada elegido—. Los botones no bastan: el «No» ya
    // viene marcado en el HTML, asi que pulsarlo no dispara nada.
    estado.conDedi = false;
    if (!salvoModalidad) estado.modo = null;
    aplicarTipoCuadro();
    pulsa('[data-pzx-cambios-op="no"]');
    pulsa('[data-pzx-dedi-op="no"]');
    pulsa('[data-pzx-base-op="ninguna"]');
    pulsa('[data-pzx-dedibase-op="no"]');
    pulsa('[data-pzx-comp="llavero"] [data-pzx-ud=""]');
    pulsa('[data-pzx-caja-op="no"]');
    // La casilla del rediseño del widget: esta tapada, pero el navegador
    // restaura formularios al recargar y una casilla marcada que no se ve
    // es un cargo que el cliente no puede quitar. Se avisa con `change`
    // para que el widget se entere, que es quien lleva la cuenta.
    var chkRedis = RAIZ.querySelector("[data-pr-redesign]");
    if (chkRedis && chkRedis.checked) {
      chkRedis.checked = false;
      try { chkRedis.dispatchEvent(new Event("change", { bubbles: true })); } catch (e) { /* navegador viejo */ }
    }

    // Las casillas sueltas (caja, taza, usb) por si quedaron marcadas.
    Array.prototype.slice.call(RAIZ.querySelectorAll("[data-pzx-check]")).forEach(function (c) {
      if (c.checked) {
        c.checked = false;
        try { c.dispatchEvent(new Event("change", { bubbles: true })); } catch (e) { /* navegador viejo */ }
      }
    });
    // El paso de la tarjeta vive en su propio modulo: manda su radio, y hay
    // que avisarle con un `change` para que cierre lo suyo.
    var tarjNo = document.getElementById("cp-no");
    if (tarjNo && !tarjNo.checked) {
      tarjNo.checked = true;
      try { tarjNo.dispatchEvent(new Event("change", { bubbles: true })); } catch (e) { /* idem */ }
    }
    // Y lo escrito: dedicatorias, grabado y textos de la tarjeta.
    Array.prototype.slice.call(
      document.querySelectorAll("[data-pz-producto] input[type='text'], [data-pz-producto] textarea, .cp-fields [data-prop]")
    ).forEach(function (campo) {
      if (!campo.value) return;
      campo.value = "";
      try { campo.dispatchEvent(new Event("input", { bubbles: true })); } catch (e) { /* idem */ }
    });
    pintar();
  }
  // Una sola vez por carga: en el editor del tema la seccion se repinta con
  // cada ajuste y no hay que borrarle nada al merchant cada vez.
  if (!window.__pztReiniciado) {
    window.__pztReiniciado = true;
    reiniciarPasos();
  }

  pintar();

  // ------------------------------------------- el "NO", sin tachon
  /**
   * LAS OPCIONES DE "NO" PIERDEN EL ICONO Y GANAN LETRA.
   *
   * Cada paso con dos opciones traia el "no" con un circulo rojo tachado del
   * tamaño de media tarjeta y la palabra debajo en letra chica. El dibujo
   * pesaba mas que la respuesta, y al lado del "si" —que enseña el producto
   * de verdad— parecia un error en vez de una eleccion.
   *
   * SE MARCAN POR EL TEXTO, no por el icono: el icono es una imagen que el
   * merchant elige en el bloque y puede cambiar cualquier dia, mientras que
   * la palabra es la que define la opcion. Se mira en mayusculas y sin
   * espacios, asi que vale "No", "NO" o "no".
   *
   * Solo donde HAY icono: una opcion de "no" que ya fuera solo texto no
   * tiene nada que quitarle.
   */
  (function noSinTachon() {
    if (RAIZ.__pztNoGrande) return;
    RAIZ.__pztNoGrande = true;

    function esNo(t) {
      var s = String(t || "").trim().toUpperCase().replace(/[.\s]+$/, "");
      return s === "NO" || s === "NEIN";
    }

    function marcar() {
      var tarjetas = RAIZ.querySelectorAll(".pzx__tarjeta, .cp-tarjeta");
      Array.prototype.forEach.call(tarjetas, function (t) {
        var tit = t.querySelector(".pzx__tarjeta-tit, .cp-tarjeta-tit");
        var img = t.querySelector("img");
        var toca = !!(tit && img && esNo(tit.textContent));
        // Grande el texto de la que se queda sin dibujo: la de "no" porque
        // se lo acabamos de quitar, y la de "si" cuando nunca lo tuvo.
        var sola = !!(tit && (toca || !img));
        // Solo se escribe si cambia: este repaso lo despierta un observador
        // del propio DOM, y tocar la clase por tocarla lo volveria a llamar.
        if (t.classList.contains("pzx-no-grande") !== toca) {
          t.classList.toggle("pzx-no-grande", toca);
        }
        if (t.classList.contains("pzx-letra-grande") !== sola) {
          t.classList.toggle("pzx-letra-grande", sola);
        }
      });
    }

    var pedido = false;
    function pedir() {
      if (pedido) return;
      pedido = true;
      (window.requestAnimationFrame || setTimeout)(function () {
        pedido = false;
        marcar();
      }, 16);
    }

    marcar();
    if (typeof MutationObserver === "function") {
      // Los pasos aparecen y desaparecen segun lo elegido, y el bloque de
      // tarjetas pinta sus opciones por su cuenta: hay que repasar cuando
      // el DOM cambie, no una sola vez al cargar.
      new MutationObserver(pedir).observe(RAIZ, { childList: true, subtree: true });
    }
  })();

  // ------------------------------------------- los campos, encadenados
  /**
   * DE UN CAMPO AL SIGUIENTE SIN SOLTAR EL TECLADO.
   *
   * La tarjeta se rellena en tres campos seguidos —encabezado, dedicatoria y
   * remitente— y entre uno y otro habia que bajar el teclado, buscar el
   * campo siguiente, tocarlo y esperar a que el teclado volviera a subir.
   * Tres veces. Ahora la tecla de la esquina del teclado lleva al campo
   * siguiente, y en el ultimo cierra el teclado.
   *
   * EL FOCO SE PASA EN EL MISMO GESTO. `focus()` se llama dentro del propio
   * `keydown`: asi el teclado no llega a bajar y no hay ni parpadeo. Fuera
   * del gesto —en un `setTimeout`, por ejemplo— iOS lo trata como foco
   * automatico, baja el teclado y vuelve a subirlo.
   *
   * Y LA TECLA LO DICE ANTES. `enterkeyhint` le pone nombre: «Siguiente» en
   * los dos primeros y «Listo» en el ultimo, para que se sepa a donde lleva
   * sin tener que probarla.
   */
  (function campoTrasCampo() {
    var ORDEN = ["Encabezado", "Dedicatoria tarjeta", "Remitente"];
    function campos() {
      return ORDEN.map(function (prop) {
        return document.querySelector('.cp-fields [data-prop="' + prop + '"]');
      });
    }
    function etiquetar() {
      var cs = campos();
      cs.forEach(function (c, i) {
        if (!c) return;
        var hayMas = false;
        for (var j = i + 1; j < cs.length; j++) if (cs[j]) hayMas = true;
        var pista = hayMas ? "next" : "done";
        if (c.getAttribute("enterkeyhint") !== pista) c.setAttribute("enterkeyhint", pista);
      });
    }
    etiquetar();
    // El bloque de la tarjeta repinta sus campos al cambiar de diseño.
    if (typeof MutationObserver === "function") {
      var caja = document.querySelector(".cp-fields");
      if (caja) new MutationObserver(etiquetar).observe(caja, { childList: true, subtree: true });
    }

    // El cursor al final de lo que ya hubiera escrito, no al principio.
    function alFinalDelTexto(campo) {
      try {
        var n = (campo.value || "").length;
        if (campo.setSelectionRange) campo.setSelectionRange(n, n);
      } catch (err) { /* campo que no admite seleccion: da igual */ }
    }

    /**
     * PASAR AL CAMPO SIGUIENTE SIN MOVER LA PAGINA.
     *
     * Al dar el foco, el navegador desplaza la pagina para enseñar el campo
     * —y como el siguiente esta mas abajo, cada relevo era un saltito hacia
     * abajo—. Aqui ese desplazamiento sobra: el campo que recibe el foco se
     * queda PEGADO encima del teclado, o sea que ya esta a la vista antes de
     * que el navegador mueva nada.
     *
     * Se le pide que no desplace (`preventScroll`) y, para los navegadores
     * que no hacen caso, se anota donde estaba la pagina y se devuelve ahi
     * mismo si se ha movido: en el mismo fotograma, sin esperas ni reintentos
     * —un scroll que se corrige dos o tres veces se ve peor que el salto—.
     */
    /**
     * AL CAMPO SIGUIENTE, Y QUE EL NAVEGADOR HAGA LO SUYO.
     *
     * Estos tres campos se quedan en su paso —no se pegan encima del
     * teclado—, asi que SI hace falta que la pagina se mueva para enseñar
     * el que toca. Antes se le pedia justo lo contrario (`preventScroll` y
     * devolver el scroll), que es lo que tenia sentido cuando el campo
     * acababa fijo al borde de la pantalla.
     */
    function irAlCampo(siguiente) {
      siguiente.focus();
      alFinalDelTexto(siguiente);
    }

    /**
     * SE ACABO DE ESCRIBIR: A VER COMO HA QUEDADO.
     *
     * Al terminar el ultimo campo se cierra el teclado y se lleva la pagina
     * al paso de la tarjeta, que es lo que se acaba de escribir: arriba
     * queda la vista previa —pegada— y debajo el paso entero para repasarlo.
     * Nada de esto compra: al carrito se va por su boton.
     *
     * Se espera a que el teclado baje del todo; con el teclado a medio
     * cerrar, la pagina mide otra cosa y el sitio sale mal.
     */
    function terminar(campo) {
      campo.blur();
      var paso = campo.closest("#gcards") || campo.closest(".pzx");
      if (!paso) return;
      setTimeout(function () {
        var marco = RAIZ.querySelector(".pz-prod__marco");
        var alto = marco ? Math.round(marco.getBoundingClientRect().height) : 0;
        var y = Math.round(paso.getBoundingClientRect().top + (window.pageYOffset || 0) - alto - 10);
        y = Math.max(0, y);
        try {
          window.scrollTo({ top: y, behavior: "smooth" });
        } catch (e) {
          window.scrollTo(0, y);
        }
      }, 420);
    }

    /**
     * NINGUNA TECLA COMPRA.
     *
     * Los campos de la ficha viven DENTRO del formulario de comprar, y en
     * un formulario el intro de un campo de una linea equivale a pulsar el
     * boton de comprar: el teclado del movil lo manda al dar al visto bueno
     * y el pedido se iba al carrito sin que nadie lo hubiera pedido. Para
     * eso esta el boton del carrito, y hasta entonces el cliente tiene que
     * poder seguir repasando lo que lleva.
     *
     * Se corta el intro de TODOS los campos de una linea de la ficha y de
     * la tarjeta, no solo de los tres encadenados: el que se escapaba era
     * justo uno de los otros. Las areas de varias lineas no hacen falta —el
     * intro ahi parte la linea, nunca envia—.
     */
    function campoDeUnaLinea(n) {
      if (!n || n.tagName !== "INPUT") return false;
      var t = (n.getAttribute("type") || "text").toLowerCase();
      return t === "text" || t === "search" || t === "email" || t === "tel" ||
             t === "url" || t === "number" || t === "password";
    }

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" || e.isComposing || e.shiftKey) return;
      var campo = e.target;
      if (!campo || !campo.closest) return;
      if (campoDeUnaLinea(campo) &&
          (RAIZ.contains(campo) || campo.closest("#gcards"))) {
        e.preventDefault();
      }
      if (!campo.closest(".cp-fields")) return;
      var i = ORDEN.indexOf(campo.getAttribute("data-prop"));
      if (i < 0) return;
      // EN EL ORDENADOR, EL INTRO SIGUE PARTIENDO LA LINEA. La dedicatoria
      // es un area de varias lineas y la tarjeta las respeta al imprimir
      // (`white-space: pre-wrap`). Quitar ahi el intro seria quitar algo que
      // ya se usaba. El relevo es cosa del teclado en pantalla, que es donde
      // el cliente pidio no tener que ir buscando el campo siguiente.
      if (campo.tagName === "TEXTAREA" && !(MOVIL && MOVIL.matches)) return;
      e.preventDefault();
      var cs = campos();
      var siguiente = null;
      for (var j = i + 1; j < cs.length && !siguiente; j++) if (cs[j]) siguiente = cs[j];
      if (!siguiente) { terminar(campo); return; }   // el ultimo: se cierra y se enseña
      irAlCampo(siguiente);
    }, true);

    /**
     * EL «VISTO BUENO» DEL TECLADO NO MANDA NINGUNA TECLA.
     *
     * En el movil, encima del teclado hay una barra del propio navegador con
     * sus flechas y un boton de visto bueno —«Listo»— que CIERRA el teclado
     * sin mandar `Enter`: el relevo de arriba no se entera y el cliente se
     * queda fuera de los campos a medio rellenar la tarjeta.
     *
     * Asi que tambien se mira cuando un campo pierde el foco SIN que nadie
     * haya tocado la pagina: eso solo pasa cuando el teclado se cierra solo.
     * Si el cliente toca otra cosa —otro paso, una tarjeta, el fondo— hay un
     * `pointerdown` por medio y entonces no se le toca el foco: se ha ido a
     * otro sitio a proposito.
     *
     * Solo se adelanta a los campos que esten VACIOS. Una vez puestos los
     * tres, el visto bueno cierra el teclado y punto: nadie quiere pelearse
     * con una ficha que no le deja salir.
     *
     * El foco se pone DENTRO del propio `focusout`, sin esperar: fuera del
     * gesto, iOS no vuelve a abrir el teclado.
     */
    var ultimoToque = { t: 0, nodo: null };
    document.addEventListener("pointerdown", function (e) {
      ultimoToque = { t: Date.now(), nodo: e.target };
    }, true);

    document.addEventListener("focusout", function (e) {
      var campo = e.target;
      if (!campo || !campo.closest || !campo.closest(".cp-fields")) return;
      if (!(MOVIL && MOVIL.matches)) return;
      var i = ORDEN.indexOf(campo.getAttribute("data-prop"));
      if (i < 0) return;
      // El foco se va a otro sitio por su cuenta (el relevo de la tecla, por
      // ejemplo): ya esta resuelto.
      if (e.relatedTarget) return;
      // Ha habido un dedo en la pagina: se ha ido a proposito.
      if (Date.now() - ultimoToque.t < 500 && ultimoToque.nodo !== campo &&
          !(campo.contains && campo.contains(ultimoToque.nodo))) return;
      if (!String(campo.value || "").trim()) return;   // vacio: no se insiste
      var cs = campos();
      var siguiente = null;
      for (var j = i + 1; j < cs.length && !siguiente; j++) {
        if (cs[j] && !String(cs[j].value || "").trim()) siguiente = cs[j];
      }
      if (!siguiente) { terminar(campo); return; }
      irAlCampo(siguiente);
    }, true);
  })();

  // ------------------------------------------- la letra de la dedicatoria
  /**
   * LA DEDICATORIA DEL CUADRO, CON LA LETRA DE LA FICHA.
   *
   * La dedicatoria se pinta en el lienzo del widget, que no sabe nada del
   * tema. Asi que la ficha le deja dicho —en dos propiedades del CSS— con
   * que letra tiene que escribirla, y el widget las lee al montar el texto.
   *
   * Se copia la de los TITULOS DE LOS PASOS, tal y como la calcula el
   * navegador: si manana el tema cambia de tipografia, esto la sigue sin
   * tocar nada. Y se deja puesta cuanto antes, porque el widget la lee una
   * sola vez, al crear el texto.
   */
  (function letraDeLaDedicatoria() {
    var muestra = RAIZ.querySelector(".pzx__tit") ||
                  RAIZ.querySelector(".pz-prod__opcion-nombre") ||
                  RAIZ.querySelector(".pzx__tarjeta-tit");
    if (!muestra) return;
    var cs = getComputedStyle(muestra);
    var familia = (cs.fontFamily || "").trim();
    if (!familia) return;
    var raiz = document.documentElement;
    raiz.style.setProperty("--pr-dedi-font", familia);
    raiz.style.setProperty("--pr-dedi-peso", (cs.fontWeight || "700").trim());
  })();

  // ------------------------------------------- empezar de cero
  /**
   * LA FICHA, COMO RECIEN ABIERTA.
   *
   * Lo usa la papelera del recuadro de subir. Tres cosas: el diseño que se
   * ensena arriba se olvida —tanto el del marco como la foto que el tema
   * metio en la galeria—, los pasos vuelven a «no» y los premios se callan
   * (si no, el total cae de golpe y saldrian tres carteles de despedida
   * justo cuando el cliente esta empezando otro regalo).
   *
   * El paso de modalidad se queda en pie: dentro vive el recuadro de subir,
   * y apagarlo seria quitarle el suelo de debajo de los pies a quien
   * justamente va a subir otra foto.
   */
  function olvidarElDisenoDeLaGaleria() {
    Array.prototype.forEach.call(RAIZ.querySelectorAll("[data-pz-generada]"), function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    disenoEnGaleria = "";
    var tira = RAIZ.querySelector(".pz-prod__tira");
    if (tira) {
      try { tira.scrollTo({ left: 0, behavior: "auto" }); }
      catch (e) { tira.scrollLeft = 0; }
    }
  }

  function empezarDeCero() {
    huboDiseno = false;
    olvidarElDisenoDeLaGaleria();
    reiniciarPasos({ salvoModalidad: true });
    pintar();
    refrescarGaleria();
    altoGaleria();
  }
  window.__pztEmpezarDeCero = empezarDeCero;

  // ------------------------------------------- foto nueva, pedido nuevo
  /**
   * UNA FOTO DISTINTA EMPIEZA DE CERO.
   *
   * Cambiar la foto es cambiar de regalo: lo que se eligio para la anterior
   * —dedicatoria, base, llavero, caja, tarjeta— ya no tiene por que valer, y
   * arrastrarlo en silencio acaba en un pedido que el cliente no recuerda
   * haber pedido. Asi que al subir una foto distinta se vuelve a empezar.
   *
   * SOLO SI YA HABIA DISENO. La primera foto no borra nada: no hay nada que
   * borrar, y el cliente acaba de elegir la modalidad para poder subirla.
   * Por lo mismo, el reinicio respeta ese paso.
   *
   * Se mira el campo de fichero del widget (`[data-pr-file]`) y no cualquier
   * campo de fichero de la ficha: las fotos de los llaveros tambien son
   * campos de fichero y no cambian el regalo.
   */
  (function fotoNuevaReinicia() {
    document.addEventListener("change", function (e) {
      var n = e.target;
      if (!n || !n.matches || !n.matches("[data-pr-file]")) return;
      if (!RAIZ.contains(n)) return;
      if (!n.files || !n.files.length) return;
      if (!huboDiseno) return;
      reiniciarPasos({ salvoModalidad: true });
      pintar();
    }, true);
  })();

  // ------------------------------------------- el enchufe, con la base
  /**
   * EL ENCHUFE, DONDE SE ELIGE LA BASE.
   *
   * El adaptador de corriente vivia en el paso de complementos, tres pasos
   * mas abajo: el cliente decide ahi si quiere la base con luz y se entera
   * del enchufe mucho despues, cuando ya esta pensando en otra cosa. Se
   * mueve justo debajo de la dedicatoria de la base, con la pregunta encima.
   *
   * SE MUEVE EL MISMO NODO, no se copia —igual que la vista previa de la
   * tarjeta—: viene con su casilla, su precio y su variante ya enganchados,
   * y asi no hay dos casillas que un dia dejarian de decir lo mismo.
   *
   * Quien lo enseña y lo esconde sigue siendo `revisarUsb`, que solo lo saca
   * con una base CON LUZ: un enchufe para un soporte que no se ilumina no
   * tiene a donde ir.
   */
  (function enchufeConLaBase() {
    if (!bBase) return;
    var fila = RAIZ.querySelector('[data-pzx-solo-con-luz="1"]');
    var cajaDedi = bBase.querySelector("[data-pzx-dedibase]");
    if (!fila || !cajaDedi || !cajaDedi.parentNode) return;
    if (fila.closest("[data-pzx-enchufe]")) return;        // ya esta mudada

    var hueco = document.createElement("div");
    hueco.className = "pzx__dedibase";
    hueco.setAttribute("data-pzx-enchufe", "");
    var tit = document.createElement("span");
    tit.className = "pzx__etq";
    // La misma pregunta que el bloque del enchufe de las plantillas, y a juego
    // con la tarjeta de debajo («Alimentatore USB», «USB-Netzteil», «USB wall adapter»).
    tit.textContent = (PZ_DE ? "Brauchst du ein USB-Netzteil?" : PZ_EN ? "Do you need a USB wall adapter?" : PZ_IT ? "Ti serve un alimentatore USB?" : "¿Necesita enchufe USB?");
    hueco.appendChild(tit);
    cajaDedi.parentNode.insertBefore(hueco, cajaDedi.nextSibling);

    /**
     * LAS DOS TARJETAS, COMO EN TODOS LOS DEMAS PASOS.
     *
     * La fila con casilla venia del paso de complementos y aqui desentonaba:
     * el resto de la ficha se elige con dos tarjetas, el «NO» y la cosa.
     * Se construyen sobre la fila que ya existe, que se queda escondida y
     * SIGUE SIENDO LA QUE MANDA: su casilla es la que guarda el estado, la
     * que lleva la variante y la que dispara el cobro. Las tarjetas solo la
     * pulsan. Asi no hay dos sitios donde mirar si el cliente quiere
     * enchufe.
     */
    var chk = fila.querySelector("[data-pzx-check]");
    var imgFila = fila.querySelector("img");
    var tarjetas = document.createElement("div");
    tarjetas.className = "pzx__tarjetas";

    function tarjetaEnchufe(valor, titulo, img, precio) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "pzx__tarjeta";
      b.setAttribute("role", "radio");
      b.setAttribute("data-pzx-enchufe-op", valor);
      if (img) b.appendChild(img);
      var t = document.createElement("span");
      t.className = "pzx__tarjeta-tit";
      t.textContent = titulo;
      b.appendChild(t);
      if (precio) {
        var pr = document.createElement("span");
        pr.className = "pzx__tarjeta-precio";
        pr.textContent = precio;
        b.appendChild(pr);
      }
      b.addEventListener("click", function () {
        if (!chk) return;
        var quiere = valor === "si";
        if (chk.checked !== quiere) {
          chk.checked = quiere;
          // El mismo aviso que daria el dedo sobre la casilla: de ahi
          // cuelgan el estado, el espejo del carrito y el repintado.
          chk.dispatchEvent(new Event("change", { bubbles: true }));
        }
        pintarEnchufe();
      });
      return b;
    }

    // Los dos rotulos son solo lo que se lee en la tarjeta: el cobro y lo que
    // va al pedido salen de la casilla de la fila, que no se toca.
    var elNo = tarjetaEnchufe("no", (PZ_DE ? "NEIN" : "NO"), null, "");
    var elSi = tarjetaEnchufe(
      "si",
      ((PZ_DE || PZ_EN || PZ_IT) && /^\s*enchufe usb\s*$/i.test(fila.dataset.pzxNombre || "Enchufe USB"))
        ? (PZ_DE ? "USB-Netzteil" : PZ_EN ? "USB wall adapter" : "Alimentatore USB")
        : (fila.dataset.pzxNombre || "Enchufe USB"),
      imgFila ? imgFila.cloneNode(true) : null,
      fila.dataset.pzxPrecio ? "+" + dinero(centimos(fila.dataset.pzxPrecio)) : ""
    );
    tarjetas.appendChild(elNo);
    tarjetas.appendChild(elSi);

    function pintarEnchufe() {
      var si = !!(chk && chk.checked);
      elSi.classList.toggle("is-sel", si);
      elSi.setAttribute("aria-checked", si ? "true" : "false");
      elNo.classList.toggle("is-sel", !si);
      elNo.setAttribute("aria-checked", si ? "false" : "true");
    }
    if (chk) chk.addEventListener("change", pintarEnchufe);
    pintarEnchufe();

    // La fila original se queda viva pero escondida: es la que guarda el
    // estado y la que mira `revisarUsb`.
    fila.style.display = "none";
    hueco.appendChild(tarjetas);
    hueco.appendChild(fila);

    // La pregunta acompaña a la casilla: `revisarUsb` enseña y esconde la
    // fila segun la base, y un titulo suelto sin sus tarjetas no dice nada.
    // Se apaga con `display` y no con `hidden`: la clase trae su propio
    // `display: grid` y le ganaria al atributo.
    function acompasar() {
      hueco.style.display = fila.hidden ? "none" : "";
      // Al quitar la base, `revisarUsb` desmarca la casilla sin avisar a
      // nadie: las tarjetas tienen que enterarse igual.
      pintarEnchufe();
    }
    acompasar();
    if (typeof MutationObserver === "function") {
      new MutationObserver(acompasar).observe(fila, {
        attributes: true, attributeFilter: ["hidden"],
      });
    }
  })();

  // ------------------------------------------- la tarjeta, en el marco
  /**
   * AL ELEGIR TARJETA, LA TARJETA MANDA ARRIBA.
   *
   * La vista previa de la tarjeta vivia al final de su paso, a dos pantallas
   * de donde el cliente escribe: se tecleaba la dedicatoria sin ver como
   * queda. Ahora sube al recuadro de arriba, que es donde se mira.
   *
   * SE MUEVE EL NODO, NO SE COPIA. Es lo importante de todo esto: la vista
   * previa ya la pinta el bloque de la tarjeta —tipografia por diseño, color
   * del papel, texto que encoge si no cabe— y con una copia habria dos
   * cosas que mantener iguales y un dia dejarian de serlo. Moviendola, sigue
   * siendo la misma y la pinta quien la pintaba.
   *
   * Y EL CUADRO NO SE PIERDE. El editor no se desmonta, se tapa: encuadre,
   * giro, zoom y dedicatoria se quedan como estaban, igual que cuando se
   * sube arriba del todo y vuelven las fotos del producto. Al soltar la
   * tarjeta, la vista previa vuelve a su sitio exacto del paso.
   */
  (function tarjetaEnElMarco() {
    var galeria = RAIZ.querySelector(".pz-prod__galeria");
    var marco = RAIZ.querySelector(".pz-prod__marco");
    // `arrancar()` vuelve a correr —editor del tema, vuelta atras del
    // navegador—: sin esto se colgarian dos huecos del mismo marco.
    if (marco && marco.querySelector(".pzx-tarjeta")) return;
    var previa = document.querySelector("#cp-detalle .cp-preview") ||
                 document.querySelector(".cp-preview");
    if (!galeria || !marco || !previa) return;

    // De donde sale, para devolverla al mismo hueco y no al final del paso.
    var deDonde = { padre: previa.parentNode, siguiente: previa.nextSibling };
    var hueco = document.createElement("div");
    hueco.className = "pzx-tarjeta";
    hueco.setAttribute("data-pzx-tarjeta", "");
    hueco.hidden = true;
    marco.appendChild(hueco);

    var puesta = false;
    /**
     * ARRIBA VA LO QUE SE ESTA TOCANDO.
     *
     * Con la tarjeta puesta, el cliente sigue queriendo cambiar cosas del
     * cuadro —el tamaño, las personas, la base—, y al tocar esos pasos se
     * quedaba mirando la tarjeta sin ver lo que acababa de cambiar.
     *
     * Asi que el marco lo ocupa aquello en lo que se esta trabajando: se
     * mira DONDE cae lo que el cliente toca. Dentro del bloque de la
     * tarjeta, manda la tarjeta; en cualquier otro paso de la ficha, vuelve
     * el personalizador del cuadro. La tarjeta no se deselecciona por esto
     * —se sigue comprando igual—, solo deja de ocupar el marco.
     */
    var mirando = "tarjeta";
    function dondeCae(nodo) {
      if (!nodo || !nodo.closest) return null;
      // Tocar la propia vista previa no es "cambiar de tema".
      if (nodo.closest("[data-pzx-tarjeta]")) return null;
      if (nodo.closest("#gcards")) return "tarjeta";
      return RAIZ.contains(nodo) ? "cuadro" : null;
    }

    function hayTarjeta() {
      var si = document.getElementById("cp-yes");
      var detalle = document.getElementById("cp-detalle");
      return !!(si && si.checked && detalle && !detalle.hidden);
    }

    function revisarTarjeta() {
      // `EN_LO_ALTO` manda sobre todo lo demas: ver el producto arriba del
      // todo no deselecciona la tarjeta —se sigue comprando igual—, solo le
      // quita el marco mientras se esta ahi.
      var toca = hayTarjeta() && mirando === "tarjeta" && !EN_LO_ALTO.es;
      if (toca === puesta) return;
      puesta = toca;
      if (toca) {
        // La foto del diseño se toma ANTES de tapar el editor: asi la
        // galeria del producto sigue enseñando el cuadro que se compra.
        verEnGaleria("");
        hueco.appendChild(previa);
        hueco.hidden = false;
        galeria.classList.add("pzx-contarjeta");
      } else {
        galeria.classList.remove("pzx-contarjeta");
        hueco.hidden = true;
        deDonde.padre.insertBefore(previa, deDonde.siguiente);
      }
      if (typeof window.__pztAltoGaleria === "function") window.__pztAltoGaleria();
      // La tarjeta mide su texto contra el ancho de la vista previa, y
      // acaba de cambiar de sitio y de ancho; su bloque reencaja al
      // redimensionar, asi que se le avisa por ahi. Al volver, el lienzo
      // del editor tambien necesita el aviso para medirse otra vez.
      try { window.dispatchEvent(new Event("resize")); } catch (e) { /* da igual */ }
      setTimeout(function () {
        try { window.dispatchEvent(new Event("resize")); } catch (e) { /* da igual */ }
      }, 120);
    }

    function atento(e) {
      var donde = dondeCae(e.target);
      if (!donde) return;
      mirando = donde;
      // Un respiro: el bloque de la tarjeta enseña y esconde su detalle en
      // el mismo clic, y hay que mirarlo ya cambiado.
      setTimeout(revisarTarjeta, 60);
    }
    document.addEventListener("click", atento, true);
    document.addEventListener("change", atento, true);
    document.addEventListener("focusin", atento, true);
    if (typeof MutationObserver === "function") {
      var detalle = document.getElementById("cp-detalle");
      if (detalle) {
        new MutationObserver(revisarTarjeta).observe(detalle, {
          attributes: true, attributeFilter: ["hidden"],
        });
      }
    }
    revisarTarjetaDelMarco = revisarTarjeta;
    revisarTarjeta();
  })();

    /**
     * LA LUZ SE ENCIENDE DENTRO DE LA LAMPARA, NO EN UNA BARRA DEBAJO.
     *
     * El personalizador pinta el interruptor como un boton de texto
     * —«Apagar luz»— en una barra bajo el visor. Ahi se lee como un paso mas
     * de la ficha, cuando lo que es de verdad es algo que se le hace a la
     * lampara que se esta mirando. Se MUEVE ese mismo boton a la esquina de
     * abajo a la izquierda del area editable —enfrente de la lupa, que el
     * visor pone a la derecha— y el texto se cambia por una linterna que se
     * enciende y se apaga con el.
     *
     * Se mueve el suyo y no se pinta uno nuevo a proposito: ese boton ya
     * lleva enganchado el `setPower` del visor 3D. Con uno propio habria dos
     * interruptores, y dos interruptores se contradicen.
     *
     * VA AQUI, EN EL CUERPO DE `arrancar()`, y no junto al grabado de la
     * madera: aquello vive dentro de `if (bBase)` y la lampara SIN base no
     * tiene ese bloque, asi que alli la linterna no habria existido nunca.
     */
    function iconoLinterna(encendida) {
      return '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" ' +
        'stroke="currentColor" stroke-width="1.8" stroke-linecap="round" ' +
        'stroke-linejoin="round" aria-hidden="true" focusable="false">' +
        // El cristal arriba y el mango debajo: una linterna de mano apuntando
        // hacia donde esta la luz de la lampara.
        '<path d="M9.6 5h4.8l-.8 3.4h-3.2z"></path>' +
        '<rect x="10" y="8.4" width="4" height="10.6" rx="1.1"></rect>' +
        '<path d="M10 11.6h4"></path>' +
        // El haz SOLO encendida: es lo que distingue los dos estados de un
        // vistazo, y el color del fondo lo remata.
        (encendida
          ? '<path d="M12 1.4v1.4"></path>' +
            '<path d="M7.9 2.4l1 1.2"></path>' +
            '<path d="M16.1 2.4l-1 1.2"></path>'
          : "") +
        "</svg>";
    }

    /**
     * Se repinta entero en cada clic porque el widget le reescribe el texto
     * —«Encender luz»/«Apagar luz»— y eso se lleva por delante el dibujo. El
     * estado no hay que preguntarselo al visor: lo canta el propio boton en
     * `aria-pressed`.
     */
    function pintarLuz(btn) {
      var encendida = btn.getAttribute("aria-pressed") !== "false";
      btn.innerHTML = iconoLinterna(encendida);
      btn.title = encendida
        ? (PZ_DE ? "Licht ausschalten" : PZ_EN ? "Turn off the light" : PZ_IT ? "Spegni la luce" : "Apagar luz")
        : (PZ_DE ? "Licht einschalten" : PZ_EN ? "Turn on the light" : PZ_IT ? "Accendi la luce" : "Encender luz");
      btn.setAttribute("aria-label", btn.title);
      btn.style.background = encendida ? "rgba(255,198,105,0.96)" : "rgba(255,255,255,0.92)";
      btn.style.color = encendida ? "#3b2600" : "#111827";
    }

    /**
     * Se tapa con `style.display` y NO con el atributo `hidden`: el boton
     * lleva estilos en linea, y un `display` en linea le gana al
     * `display:none` que el navegador le pone a lo escondido.
     */
    function verLuz(btn, verse) {
      btn.style.display = verse ? "flex" : "none";
    }

    /**
     * SOLO SI HAY LUZ QUE ENCENDER.
     *
     * La barra nace tapada y el widget la destapa cuando el visor 3D termina
     * de montar. Quien no se enciende —el reloj, el portallaves— no la
     * destapa nunca, y si el navegador se cae al montaje plano tampoco. Asi
     * que lo que manda es el `hidden` de la barra y no el modo de la ficha.
     *
     * Al llevarnos el boton, la barra se queda vacia: se apaga por estilo y
     * NO con `hidden`, que es justo la señal que hay que seguir leyendo.
     */
    function colocarLuz() {
      var btn = document.querySelector("[data-pr-power]");
      var area = document.querySelector(".pr-modal__canvas-wrap");
      if (!btn || !area) return;                 // todavia no hay editor
      var barra = document.querySelector("[data-pr-power-bar]");

      if (btn.parentNode !== area) {
        area.appendChild(btn);
        if (barra) barra.style.display = "none";
        btn.className = "pzx-luz";
        btn.style.cssText = [
          "position:absolute", "left:10px", "bottom:10px", "z-index:5",
          "width:38px", "height:38px", "padding:0", "border:0",
          "border-radius:999px", "align-items:center", "justify-content:center",
          "cursor:pointer", "box-shadow:0 2px 8px rgba(0,0,0,0.18)",
        ].join(";");
        // Este oyente se registra DESPUES del suyo, asi que repinta cuando el
        // widget ya ha cambiado el estado.
        btn.addEventListener("click", function () { pintarLuz(btn); });
        // Que aparezca en cuanto el visor monte, sin esperar a que algo mas
        // mueva el DOM.
        if (barra && typeof MutationObserver === "function") {
          new MutationObserver(function () { verLuz(btn, !barra.hidden); })
            .observe(barra, { attributes: true, attributeFilter: ["hidden"] });
        }
      }
      verLuz(btn, !(barra && barra.hidden));
      pintarLuz(btn);
    }

    /**
     * EL EDITOR LLEGA TARDE, Y VUELVE A LLEGAR: no existe hasta que hay
     * diseño y se rehace al cambiar de variante, asi que hay que repasarlo
     * cada vez que cambia. El temporizador evita repetirlo por cada
     * mutacion de una misma tanda.
     */
    var relojLuz = null;
    function repasarLuz() {
      if (relojLuz) return;                     // ya hay uno en camino
      relojLuz = setTimeout(function () { relojLuz = null; colocarLuz(); }, 200);
    }

    if (typeof MutationObserver === "function") {
      var huecoLuz = RAIZ.querySelector("[data-pzx-editor]");
      // El editor incrustado en la galeria.
      if (huecoLuz) new MutationObserver(repasarLuz).observe(huecoLuz, { childList: true, subtree: true });
      // Y el que se abre en ventana, que cuelga del final de la pagina.
      new MutationObserver(repasarLuz).observe(document.body, { childList: true });
    }
    // Un repaso de salida, por si el editor ya estaba puesto: los vigilantes
    // solo avisan de lo que CAMBIA.
    repasarLuz();


    /**
     * UN PASO QUE NO ENSEÑA NADA NO LLEVA NUMERO.
     *
     * Varios pasos se esconden SOLOS segun el producto o la variante: «Sube
     * tu foto» en los modelos lisos, la dedicatoria en las fichas que no la
     * venden. El numero, en cambio, lo pinta el envoltorio del bloque, fuera
     * del bloque, asi que se quedaba el circulito flotando entre dos pasos.
     *
     * La regla es generica a proposito —un envoltorio sin NADA visible dentro
     * no lleva numero— porque cada bloque se esconde a su manera y listarlos
     * uno a uno envejece mal.
     *
     * VA EN SU PROPIO BLOQUE, no dentro de la vista previa: alli solo corria
     * en las fichas que tienen ese paso puesto, y el numero huerfano sale
     * igual en las que no.
     */
    (function numerosHuerfanos() {
      /**
     * UN PASO QUE NO ENSEÑA NADA NO LLEVA NUMERO.
     *
     * El numero lo pinta el envoltorio del bloque, fuera del bloque mismo.
     * Varios pasos se esconden SOLOS segun el producto o la variante: «Sube
     * tu foto» en los modelos lisos, la dedicatoria en las fichas que no la
     * venden. Cuando lo hacen se quedaba el circulito con el numero
     * flotando entre dos pasos. La regla es generica a proposito —un
     * envoltorio sin NADA visible dentro no lleva numero— porque cada
     * bloque se esconde a su manera y listarlos uno a uno envejece mal.
     */
    function repasarNumerosHuerfanos() {
      var envoltorios = RAIZ.querySelectorAll(".pz-prod__bloque--num");
      for (var i = 0; i < envoltorios.length; i++) {
        var env = envoltorios[i];
        // SE MIDE CON EL ENVOLTORIO DESTAPADO, SIEMPRE.
        //
        // Mirar si los hijos se ven mientras el envoltorio esta escondido es
        // morderse la cola: escondido, ningun hijo mide, asi que no volvia a
        // destaparse nunca. Eso dejo sin pasos —llavero, caja, tarjeta,
        // resumen— a las fichas que los enseñan DESPUES de elegir modo. Se
        // destapa, se mide y se vuelve a decidir; el navegador no llega a
        // pintar nada por el medio.
        env.style.display = "";
        var algo = false;
        for (var j = 0; j < env.children.length; j++) {
          var h = env.children[j];
          if (h.classList && h.classList.contains("pz-prod__paso-num")) continue;
          if (h.getClientRects().length) { algo = true; break; }
        }
        // Se toca `display`, no `hidden`: `hidden` lo manejan los propios
        // bloques y pisarselo seria pelearse con ellos.
        if (!algo) env.style.display = "none";
      }
    }

      var reloj = null;
      function pronto() {
        if (reloj) clearTimeout(reloj);
        reloj = setTimeout(function () { reloj = null; repasarNumerosHuerfanos(); }, 180);
      }
      ["change", "click", "input"].forEach(function (ev) {
        RAIZ.addEventListener(ev, pronto, true);
      });
      if (typeof MutationObserver === "function") {
        new MutationObserver(pronto).observe(RAIZ, { childList: true, subtree: true, attributes: true, attributeFilter: ["hidden", "style"] });
      }
      repasarNumerosHuerfanos();
    })();

    /**
     * VISTA PREVIA: EL PRODUCTO YA MONTADO, CON LA FOTO DEL CLIENTE.
     *
     * El disco de Spotify y el cuadro de letra no pasan por el
     * personalizador —su bloque de app esta apagado—: el cliente sube su
     * foto, ve una miniatura de 72 px y compra sin haber visto nunca como
     * va a quedar la pieza. Aqui se compone de verdad.
     *
     * Se pinta sobre la PLANTILLA que declara el bloque: la pieza sobre la
     * mesa. La foto se encaja en una ventana dada en tanto por ciento, asi
     * que cambiar de arte o de encuadre es mover un numero en el editor de
     * temas, no tocar esto.
     *
     * HAY UNA PLANTILLA POR COLOR. El marco cuadrado se vende en blanco y
     * en negro, y la misma foto no queda igual sobre uno que sobre otro: el
     * bloque lleva cuatro huecos que dicen «este valor de variante usa esta
     * plantilla». Al cambiar de color se repinta con la suya.
     *
     * Dos ordenes, porque la plantilla puede venir de dos maneras: con el
     * hueco TRANSPARENTE (la buena: la foto debajo y los brillos del
     * material encima) o opaca (la foto encima, recortada a la ventana).
     *
     * Lo compuesto entra en la galeria por `disenoNuevo()`, el mismo camino
     * que usa el diseño de las lamparas, asi que arriba del todo el cliente
     * ve SU pieza y no la de muestra.
     */
    /**
     * EL MARCO DEL EDITOR, DEL COLOR ELEGIDO.
     *
     * El personalizador lee su configuracion una sola vez, al nacer: su
     * mockup no se puede cambiar desde fuera. Pero la imagen del marco se
     * carga con `new Image()` y un `src`, y eso pasa por el setter de
     * HTMLImageElement. Aqui se cambia SOLO esa URL —la que el bloque de app
     * declara en su propia configuracion— por la del color elegido. El resto
     * de imagenes de la pagina pasan de largo.
     *
     * Sin mockups por color configurados no se toca nada.
     */
    /**
     * EL DISEÑO, REDONDO ANTES DE ENTRAR AL EDITOR.
     *
     * El personalizador recorta el diseño a un RECTANGULO y lo pinta encima
     * del marco: en el atrapasol se veia el canto recto de la foto cruzando
     * el cristal, y si la generacion venia con fondo, el fondo en cuadrado.
     * Cambiar ese recorte pide tocar la app; lo que SI se puede cambiar es lo
     * que entra. El diseño se baja con `fetch`, asi que aqui se intercepta la
     * descarga, se mete en un lienzo cuadrado, se recorta en circulo y se le
     * devuelve ya redondo. Con la ventana puesta en la caja del cristal, el
     * circulo cae clavado sobre el vidrio.
     *
     * Solo se toca lo que el propio widget ha dicho que es un diseño: las
     * URL que vienen en su consulta de estado. Las demas descargas pasan de
     * largo.
     */
    /**
     * QUE COLOR HA ELEGIDO EL CLIENTE, EN CUALQUIER IDIOMA.
     *
     * Los ajustes de la seccion guardan los colores en español («Rojo»,
     * «Azul»…), pero en /en, /it y /de las pastillas llegan traducidas
     * («Red», «Rosso», «Rot»…). Comparar los dos textos no casaba nunca y
     * la pieza salia SIEMPRE del primer color, pasara lo que pasara.
     *
     * Asi que, si el nombre no casa, se va por el PUESTO: el color elegido
     * ocupa el mismo lugar en su grupo de opciones en todos los idiomas,
     * porque traducir no reordena. Devuelve 1..4, o 0 si no hay manera.
     */
    function puestoDelColor(caja) {
      if (!caja) return 0;
      var valores = [];
      for (var k = 1; k <= 4; k++) {
        valores.push(String(caja.getAttribute("data-valor-" + k) || "").trim().toLowerCase());
      }
      var radios = RAIZ.querySelectorAll(".pz-prod__pastilla input");
      // 1 · por el nombre (es lo que vale en español, y es exacto).
      for (var i = 0; i < radios.length; i++) {
        if (!radios[i].checked) continue;
        var v = String(radios[i].value || "").trim().toLowerCase();
        for (var j = 0; j < valores.length; j++) if (valores[j] && valores[j] === v) return j + 1;
      }
      // 2 · por el puesto dentro de su grupo de opciones.
      var cuantos = 0;
      for (var n = 0; n < valores.length; n++) if (valores[n]) cuantos++;
      if (!cuantos) return 0;
      var grupos = {}, orden = [];
      for (var q = 0; q < radios.length; q++) {
        var nom = radios[q].name || "";
        if (!grupos[nom]) { grupos[nom] = []; orden.push(nom); }
        grupos[nom].push(radios[q]);
      }
      // Solo si UN grupo tiene exactamente tantas opciones como colores
      // configurados: con dos candidatos no se puede saber cual es y se
      // prefiere no acertar por casualidad.
      var cual = null, cuantosCandidatos = 0;
      for (var o = 0; o < orden.length; o++) {
        if (grupos[orden[o]].length === cuantos) { cual = orden[o]; cuantosCandidatos++; }
      }
      if (cuantosCandidatos !== 1 || !cual) return 0;
      var g = grupos[cual];
      for (var z = 0; z < g.length; z++) if (g[z].checked) return z + 1;
      return 0;
    }

    /**
     * EL DISEÑO, MAS PEQUEÑO EN LA MEDIDA PEQUEÑA.
     *
     * Los portallaves (y cualquier pieza con dos medidas) se imprimen sobre
     * dos tableros distintos, y en la ficha las dos se veian IGUAL de
     * grandes: nada decia que una es mas pequeña que la otra. Aqui, cuando
     * el cliente elige la medida pequeña, el diseño entra al editor
     * reducido al porcentaje que diga el ajuste.
     *
     * COMO. No se puede tocar el editor —es una app y no se puede
     * desplegar—, asi que se cambia LO QUE LE LLEGA: el diseño se vuelve a
     * dibujar centrado y mas pequeño dentro de un lienzo del mismo tamaño,
     * con el resto transparente. El editor encaja ese lienzo en su ventana
     * igual que antes, y la figura se ve mas pequeña.
     *
     * EL HILO DEL CANTO. El editor recorta los margenes transparentes antes
     * de colocar la imagen; si no se hiciera nada, se comeria justo el aire
     * que acabamos de poner y la reduccion no se notaria. Por eso se marca
     * el borde del lienzo con una linea casi invisible (alfa 0,06, por
     * encima del umbral 8/255 con el que recorta): el lienzo entero cuenta
     * como contenido y el aire se respeta.
     */
    /**
     * LA FOTO DE LA PIEZA EN CADA COLOR, TAMBIEN FUERA DEL ESPAÑOL.
     *
     * Las pastillas con foto se montan en Liquid emparejando el TEXTO del
     * valor con los ajustes del bloque («Rojo» con «Rojo»). En /en, /it y /de
     * ese texto llega traducido —«Red», «Rosso», «Rot»— y no casa con nada:
     * los colores salian sin foto, como cuadrados de color pelados.
     *
     * Aqui se rellenan por PUESTO, que no cambia al traducir, usando las
     * mismas plantillas de color que ya tiene el bloque de la vista previa
     * (data-marco-1..4). Solo se tocan las pastillas que esten SIN foto: si
     * Liquid ya puso la suya, no se pisa.
     */
    (function fotosDeLosColores() {
      if (!RAIZ || EN_EDITOR) return;
      var caja = RAIZ.querySelector("[data-pzx-previa]");
      if (!caja) return;

      var fotos = [];
      for (var k = 1; k <= 4; k++) {
        var v = String(caja.getAttribute("data-valor-" + k) || "").trim().toLowerCase();
        var u = caja.getAttribute("data-marco-" + k) || "";
        if (v && u) fotos.push({ valor: v, url: u.split("?")[0] + "?width=240" });
      }
      if (!fotos.length) return;

      function elGrupo() {
        var radios = RAIZ.querySelectorAll(".pz-prod__pastilla input");
        var grupos = {}, orden = [];
        for (var i = 0; i < radios.length; i++) {
          var n = radios[i].name || "";
          if (!grupos[n]) { grupos[n] = []; orden.push(n); }
          grupos[n].push(radios[i]);
        }
        // 1 · por el nombre del valor (es lo que vale en español).
        for (var o = 0; o < orden.length; o++) {
          var g = grupos[orden[o]];
          for (var j = 0; j < g.length; j++) {
            var val = String(g[j].value || "").trim().toLowerCase();
            for (var f = 0; f < fotos.length; f++) if (fotos[f].valor === val) return g;
          }
        }
        // 2 · por el tamaño del grupo, si solo hay uno que cuadre.
        var cual = null, cuantos = 0;
        for (var o2 = 0; o2 < orden.length; o2++) {
          if (grupos[orden[o2]].length === fotos.length) { cual = grupos[orden[o2]]; cuantos++; }
        }
        return cuantos === 1 ? cual : null;
      }

      function poner() {
        var g = elGrupo();
        if (!g) return;
        for (var i = 0; i < g.length && i < fotos.length; i++) {
          var etiqueta = g[i].closest ? g[i].closest(".pz-prod__pastilla") : null;
          if (!etiqueta || etiqueta.querySelector("img")) continue;   // ya tiene la suya
          var hueco = etiqueta.querySelector("span");
          if (!hueco) continue;
          var im = document.createElement("img");
          im.className = "pz-prod__pastilla-img";
          im.alt = "";
          im.draggable = false;
          im.loading = "lazy";
          im.src = fotos[i].url;
          hueco.insertBefore(im, hueco.firstChild);
          etiqueta.classList.add("pz-prod__pastilla--img");
        }
      }
      poner();
    })();

    (function disenoPorMedida() {
      if (!RAIZ || EN_EDITOR) return;
      var VALOR = String(RAIZ.getAttribute("data-escala-valor") || "").trim().toLowerCase();
      var PCT = parseFloat(RAIZ.getAttribute("data-escala-pct"));
      if (!VALOR || !(PCT > 0) || PCT >= 100) return;

      function limpia(u) { return String(u || "").split("?")[0]; }
      function esDiseno(u) {
        if (!u || /\/cdn\//.test(u)) return false;
        if (/\/i\/[A-Za-z0-9_-]{6,}\.(webp|png|jpe?g)$/i.test(u)) return true;
        return /\/(uploads|originals|generated|composed|thumb)\/[^/]+\.(webp|png|jpe?g)$/i.test(u);
      }
      /** ¿Esta elegida la medida pequeña ahora mismo? */
      function toca() {
        var radios = RAIZ.querySelectorAll(".pz-prod__pastilla input");
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked && String(radios[i].value || "").trim().toLowerCase() === VALOR) return true;
        }
        return false;
      }

      var srcDeSerie = (function () {
        try {
          var d = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, "src");
          return d && d.set ? d.set : null;
        } catch (e) { return null; }
      })();

      function encoger(blob) {
        return new Promise(function (listo, falla) {
          var url = URL.createObjectURL(blob);
          var im = new Image();
          var soltar = function () { try { URL.revokeObjectURL(url); } catch (e) {} };
          im.onload = function () {
            try {
              var W = im.naturalWidth || 1, H = im.naturalHeight || 1;
              var c = document.createElement("canvas");
              c.width = W; c.height = H;
              var x = c.getContext("2d");
              var k = PCT / 100;
              var dw = W * k, dh = H * k;
              x.drawImage(im, (W - dw) / 2, (H - dh) / 2, dw, dh);
              // El hilo del canto, para que no se coma el aire.
              x.strokeStyle = "rgba(255,255,255,0.06)";
              x.lineWidth = 3;
              x.strokeRect(1.5, 1.5, W - 3, H - 3);
              c.toBlob(function (b) {
                soltar();
                if (b) listo(b); else falla(new Error("sin blob"));
              }, "image/png");
            } catch (e) { soltar(); falla(e); }
          };
          im.onerror = function () { soltar(); falla(new Error("no carga")); };
          if (srcDeSerie) srcDeSerie.call(im, url); else im.src = url;
        });
      }

      // POR LA RESPUESTA, que es por donde pasan TODAS las descargas, venga
      // la peticion de donde venga y haya las capas que haya en medio.
      if (typeof Response === "function" && Response.prototype && !Response.prototype.blob.__pzMedida) {
        var deSerie = Response.prototype.blob;
        var mio = function () {
          var u = "";
          try { u = limpia(this.url || ""); } catch (e) {}
          var p = deSerie.call(this);
          if (!esDiseno(u) || !toca()) return p;
          return p.then(function (b) {
            return encoger(b).catch(function () { return b; });
          });
        };
        mio.__pzMedida = 1;
        try { Response.prototype.blob = mio; } catch (e) { /* navegador que no deja */ }
      }
    })();

    (function disenoRedondo() {
      var caja = RAIZ.querySelector("[data-pzx-previa]");
      if (!caja || caja.getAttribute("data-redondo") !== "1") return;
      if (typeof window.fetch !== "function" || window.fetch.__pzRedondo) return;
      var PCT = parseFloat(caja.getAttribute("data-redondo-pct")) || 96;
      // Geometria de la pieza, en % del ANCHO del mockup: hasta donde llega
      // el aro por fuera y donde empieza el cristal.
      var AROEXT = parseFloat(caja.getAttribute("data-aro-ext")) || 40;
      var AROINT = parseFloat(caja.getAttribute("data-aro-int")) || 32.3;
      var LADO = 1400;
      var disenos = {};
      function limpia(u) { return String(u || "").split("?")[0]; }

      /**
       * LOS MARGENES QUE TRAE DE SOBRA.
       *
       * El diseño llega con la figura flotando en un lienzo mucho mayor
       * (la mitad del PNG suele ser transparente). Si se escalara el lienzo
       * entero, la figura quedaria pequeña dentro del cristal. Aqui se
       * busca la caja de lo que de verdad se ve; si no hay transparencia
       * —una foto con su fondo— la caja es el lienzo entero.
       */
      function margenes(im, w, h) {
        var entera = { x: 0, y: 0, w: w, h: h };
        try {
          var T = 220;
          var c = document.createElement("canvas");
          c.width = T; c.height = T;
          var g = c.getContext("2d", { willReadFrequently: true });
          g.clearRect(0, 0, T, T);
          g.drawImage(im, 0, 0, T, T);
          var d = g.getImageData(0, 0, T, T).data;
          var x0 = T, x1 = -1, y0 = T, y1 = -1;
          for (var y = 0; y < T; y++) for (var px = 0; px < T; px++) {
            if (d[(y * T + px) * 4 + 3] <= 8) continue;
            if (px < x0) x0 = px; if (px > x1) x1 = px;
            if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
          if (x1 < 0 || x1 - x0 < T * 0.1 || y1 - y0 < T * 0.1) return entera;
          return { x: x0 / T * w, y: y0 / T * h,
                   w: (x1 - x0 + 1) / T * w, h: (y1 - y0 + 1) / T * h };
        } catch (e) { return entera; }
      }

      /**
       * EL ARO DEL COLOR, PARA PINTARLO ENCIMA.
       *
       * En el editor el diseño se pinta SIEMPRE por encima del marco: es lo
       * que quiere un cuadro —la cabeza asomando— y lo que aqui dejaba el
       * retrato montado sobre el aro de vidrio. No se puede cambiar ese
       * orden sin tocar la app... pero si se puede meter el aro DENTRO de la
       * imagen del diseño, encima de el. Entonces no hay forma de que el
       * diseño pise el aro: viaja debajo.
       */
      var aroCache = {};
      /**
       * EL ARO SE BAJA Y SE CARGA DESDE UN BLOB.
       *
       * Con `<img crossOrigin>` basta con que el navegador tenga guardada de
       * antes una copia de esa misma URL pedida SIN permiso para que la
       * imagen cargue pero CONTAMINE el lienzo: a partir de ahi no se deja
       * exportar, el recorte falla y el diseño entra en crudo —en cuadrado y
       * tapando la pieza—. Pasando por `fetch` y un blob del propio
       * navegador eso no puede ocurrir.
       */
      function pedirAro(url) {
        return new Promise(function (ok) {
          if (!url) return ok(null);
          if (aroCache[url] !== undefined) return ok(aroCache[url]);
          var deAqui = (typeof deSerie === "function" ? deSerie : fetch);
          deAqui(url, { mode: "cors", credentials: "omit" })
            .then(function (res) { if (!res.ok) throw new Error("HTTP " + res.status); return res.blob(); })
            .then(function (b) {
              var objUrl = URL.createObjectURL(b);
              var im = new Image();
              im.onload = function () { aroCache[url] = im; ok(im); };
              im.onerror = function () { aroCache[url] = null; ok(null); };
              im.src = objUrl;
            })
            .catch(function () { aroCache[url] = null; ok(null); });
        });
      }
      function aroDelColor() {
        var p = puestoDelColor(caja);
        return (p && caja.getAttribute("data-marco-" + p)) || caja.getAttribute("data-marco-1") || "";
      }

      /**
       * Deja en el DOM que ha pasado con el recorte.
       *
       * Y, MIENTRAS SE AFINA, tambien a la vista: en la linea de ayuda de la
       * vista previa. Es temporal —se quita cuando el recorte este dado por
       * bueno— pero evita tener que adivinar que paso en una pantalla que no
       * es la mia. Se enciende con el ajuste «ver_rastro» del bloque.
       */
      function rastro(txt) {
        try { caja.setAttribute("data-pz-redondo-estado", String(txt).slice(0, 80)); } catch (e) {}
        if (caja.getAttribute("data-ver-rastro") !== "1") return;
        try {
          var linea = caja.querySelector(".pzx__ayuda");
          if (!linea) return;
          var marca = linea.querySelector("[data-pz-rastro]");
          if (!marca) {
            marca = document.createElement("span");
            marca.setAttribute("data-pz-rastro", "");
            marca.style.cssText = "display:block;opacity:.65;font-size:11px";
            linea.appendChild(marca);
          }
          marca.textContent = "· " + txt;
        } catch (e) {}
      }

      /**
       * EL `src` DE SIEMPRE.
       *
       * Mas abajo se envuelve el `src` de las imagenes para colarles el
       * recorte. Aqui dentro se pinta, asi que hay que poder poner una URL
       * SIN que vuelva a pasar por ese envoltorio: si no, se llamaria a si
       * mismo y no cargaria nunca.
       */
      var srcDeSerie = (function () {
        try {
          var d = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, "src");
          return d && d.set ? d.set : null;
        } catch (e) { return null; }
      })();
      function ponerSrc(im, v) {
        if (srcDeSerie) { try { srcDeSerie.call(im, v); return; } catch (e) {} }
        im.src = v;
      }

      /**
       * EL DIBUJO, a partir de una imagen YA CARGADA.
       *
       * Vive aparte porque lo usan los dos caminos: el del fichero
       * descargado y el de respaldo, que lee la imagen tal cual.
       */
      function componerDesde(im, listo, falla, alAcabar) {
        (function () {
            var volverSinAro = function () {
              aroCache[aroDelColor()] = null;
              pintar(null);
            };
            var pintar = function (aro) {
              try {
                var S = LADO, Rp = S / 2;
                /**
                 * EL CRISTAL, Y LO QUE SE LE DEJA DE MARGEN AL ARO.
                 *
                 * El disco se calcula a partir de la pieza (aro por fuera,
                 * cristal por dentro), pero el personalizador no coloca el
                 * diseño igual en todas sus composiciones: en la imagen que
                 * pone en la GALERIA —la que ve el cliente— lo pinta un
                 * pelin mas grande y nueve pixeles mas arriba, asi que el
                 * borde del dibujo llegaba a tocar el aro por arriba
                 * mientras por abajo sobraba cristal.
                 *
                 * Por eso hay dos mandos: «holgura» encoge el disco un poco
                 * respecto al cristal, y «bajar» lo baja. Se afinan desde el
                 * bloque, midiendo; no hay que tocar codigo.
                 */
                var HOLG = parseFloat(caja.getAttribute("data-redondo-holgura")) || 0;
                var BAJAR = parseFloat(caja.getAttribute("data-redondo-bajar")) || 0;
                var Rg = Rp * (AROINT / AROEXT) * (1 - HOLG / 100);
                var CY = Rp + (S * BAJAR) / 100;
                var c = document.createElement("canvas");
                c.width = S; c.height = S;
                var x = c.getContext("2d");
                x.save();
                x.beginPath(); x.arc(Rp, CY, Rg, 0, Math.PI * 2); x.clip();
                // LA IMAGEN LLENA EL CRISTAL, como en el producto de verdad.
                // Primero se le quitan los margenes transparentes —el diseño
                // llega con aire de sobra alrededor de la figura— y lo que se
                // escala es la figura, no el lienzo que la trae.
                var w = im.naturalWidth || 1, h = im.naturalHeight || 1;
                var corte = margenes(im, w, h);
                var sw = corte.w, sh = corte.h;
                var lado = Rg * 2;
                var k = Math.max(lado / sw, lado / sh) * (PCT / 100);
                var dw = sw * k, dh = sh * k;
                var dx = Rp - dw / 2;
                // Si sobra alto, se recorta POCO por arriba y el resto por
                // abajo: asi las caras no pierden la frente.
                var dy = dh > lado ? (CY - Rg) - (dh - lado) * 0.04 : CY - dh / 2;
                x.drawImage(im, corte.x, corte.y, sw, sh, dx, dy, dw, dh);
                x.restore();

                if (aro && aro.naturalWidth) {
                  // El aro del mockup, a la misma escala y centrado: su
                  // circulo exterior cae justo en el borde del cuadrado.
                  var W0 = aro.naturalWidth, H0 = aro.naturalHeight;
                  var k2 = Rp / ((AROEXT / 100) * W0);
                  x.save();
                  if (typeof Path2D === "function") {
                    var anillo = new Path2D();
                    anillo.arc(Rp, Rp, Rp, 0, Math.PI * 2);
                    anillo.arc(Rp, Rp, Rg, 0, Math.PI * 2);
                    x.clip(anillo, "evenodd");
                  } else {
                    x.beginPath(); x.arc(Rp, Rp, Rp, 0, Math.PI * 2); x.clip();
                  }
                  x.drawImage(aro, Rp - (W0 / 2) * k2, Rp - (H0 / 2) * k2, W0 * k2, H0 * k2);
                  x.restore();
                } else {
                  // SIN ARO: el hilo invisible del canto. Es lo que impide
                  // que el editor recorte la imagen a la caja de la figura y
                  // descuadre el encaje: marca el circulo entero aunque no
                  // se vea nada pintado en el.
                  x.strokeStyle = "rgba(255,255,255,0.06)";
                  x.lineWidth = 3;
                  x.beginPath(); x.arc(Rp, Rp, Rp - 1.5, 0, Math.PI * 2); x.stroke();
                }
                c.toBlob(function (b) {
                  if (b) {
                    alAcabar();
                    rastro("hecho" + (aro ? "+aro" : " SIN ARO"));
                    listo(b);
                    return;
                  }
                  // El lienzo no se deja exportar (casi siempre, el aro de
                  // otro dominio lo ha contaminado). Se rehace sin el: el
                  // recorte redondo es lo que no se puede perder.
                  if (aro) { rastro("sin blob, repito sin aro"); aroCache[aroDelColor()] = null; volverSinAro(); }
                  else { alAcabar(); rastro("sin blob"); falla(new Error("sin blob")); }
                }, "image/png");
              } catch (e) {
                if (aro) { rastro("contaminado, repito sin aro"); aroCache[aroDelColor()] = null; volverSinAro(); }
                else { alAcabar(); rastro("fallo: " + (e && e.message)); falla(e); }
              }
            };
            /**
             * EL ARO ES DE LA PIEZA, NO DEL DISEÑO.
             *
             * Lo normal es que el aro de color lo ponga el mockup de la
             * pieza: asi el diseño viaja limpio —solo el dibujo— y es lo
             * que acaba llegando al taller. Solo se pinta aqui dentro si el
             * mockup no trae aro, que se enciende en el bloque.
             */
            if (caja.getAttribute("data-aro-en-diseno") === "1") {
              pedirAro(aroDelColor()).then(pintar);
            } else {
              pintar(null);
            }
        })();
      }

      function enRedondo(blob) {
        rastro("empezando");
        return new Promise(function (listo, falla) {
          var url = URL.createObjectURL(blob);
          var im = new Image();
          var soltar = function () { try { URL.revokeObjectURL(url); } catch (e) {} };
          im.onload = function () { componerDesde(im, function (b) { soltar(); listo(b); }, function (e) { soltar(); falla(e); }, soltar); };
          im.onerror = function () { soltar(); rastro("el diseño no carga"); falla(new Error("no carga")); };
          ponerSrc(im, url);
        });
      }

      /**
       * RESPALDO: SI LA DESCARGA NO SE DEJA, SE LEE LA IMAGEN.
       *
       * El recorte se hacia siempre sobre el fichero descargado. Cuando esa
       * descarga se bloquea —CORS, una app de terceros de por medio, la red
       * del movil— no habia recorte, y entonces el diseño entraba EN CRUDO:
       * cuadrado y tapando la pieza. Ese era el fallo que se veia en unas
       * pantallas si y en otras no.
       *
       * Aqui se vuelve a intentar por el camino que no falla nunca: una
       * <img> normal y corriente, que es como el navegador pinta cualquier
       * foto. El dibujo es exactamente el mismo.
       */
      function desdeImagen(u) {
        return new Promise(function (ok, mal) {
          var im = new Image();
          try { im.crossOrigin = "anonymous"; } catch (e) {}
          im.onload = function () {
            componerDesde(im, function (b) {
              var fr = new FileReader();
              fr.onload = function () { ok(String(fr.result)); };
              fr.onerror = function () { mal(new Error("no se dejo leer")); };
              fr.readAsDataURL(b);
            }, mal, function () {});
          };
          im.onerror = function () { mal(new Error("la imagen no carga")); };
          ponerSrc(im, u);
        });
      }

      var hechos = {};          // url limpia -> dataURL redonda
      var enMarcha = {};
      function preparar(u) {
        var k = limpia(u);
        if (!k || hechos[k] || enMarcha[k]) return;
        enMarcha[k] = 1;
        deSerie(u, { mode: "cors", credentials: "omit" })
          .then(function (res) { if (!res.ok) throw new Error("HTTP " + res.status); return res.blob(); })
          .then(function (b) {
            return new Promise(function (ok, mal) {
              var fr = new FileReader();
              fr.onload = function () { ok(String(fr.result)); };
              fr.onerror = function () { mal(new Error("no se dejo leer")); };
              fr.readAsDataURL(b);
            });
          })
          .catch(function () {
            // La descarga no se dejo: se recorta leyendo la imagen.
            rastro("descarga bloqueada, voy por la imagen");
            return desdeImagen(u);
          })
          .then(function (dataUrl) { if (dataUrl) hechos[k] = dataUrl; })
          .catch(function () { rastro("ni descarga ni imagen"); })
          .then(function () { delete enMarcha[k]; avisar(k); });
      }
      /**
       * DE QUE SERVIDOR VIENEN LOS DISEÑOS.
       *
       * Reconocer el diseño por la FORMA de su direccion siempre se queda
       * corto: el servidor tiene varias maneras de nombrar sus ficheros y la
       * que no este en la lista entra sin recortar —cuadrada, tapando la
       * pieza—. Asi que ademas se aprende de donde vienen: la primera URL
       * que el propio widget nos enseña (al subir la foto, al generar, o la
       * que ya estaba en el formulario) da el servidor, y a partir de ahi
       * vale CUALQUIER imagen suya, se llame como se llame.
       */
      var servidor = "";
      function apuntarServidor(u) {
        if (servidor) return;
        try {
          var h = new URL(String(u), location.href).host;
          if (h && h !== location.host && !/cdn\.shopify\.com$/i.test(h)) servidor = h;
        } catch (e) { /* URL rara: se sigue con la forma */ }
      }
      function esDelServidor(u) {
        if (!servidor) return false;
        try {
          if (new URL(String(u), location.href).host !== servidor) return false;
        } catch (e) { return false; }
        return /\.(webp|png|jpe?g)$/i.test(limpia(u));
      }

      function esDisenoPorForma(u) {
        if (/\/cdn\//.test(u)) return false;            // las del tema, nunca
        if (esDelServidor(u)) return true;               // cualquier imagen suya
        // La corta, que es la que sirve hoy: .../i/<id>.webp
        if (/\/i\/[A-Za-z0-9_-]{6,}\.(webp|png|jpe?g)$/i.test(u)) return true;
        // Y LA LARGA. El servidor de la app tiene dos formas de nombrar sus
        // imagenes y la segunda —la de siempre, la que llevan los pedidos
        // antiguos— no se reconocia: ese diseño entraba sin recortar.
        if (/\/(uploads|originals|generated|composed|thumb)\/[^/]+\.(webp|png|jpe?g)$/i.test(u)) return true;
        return false;
      }

      // Quien espera un recorte que todavia se esta haciendo.
      var colas = {};
      function esperando(k, luego) {
        if (hechos[k]) { luego(hechos[k]); return; }
        (colas[k] = colas[k] || []).push(luego);
        /**
         * CUANTO SE ESPERA AL RECORTE.
         *
         * Si se agota, la imagen entra EN CRUDO —cuadrada, tapando la
         * pieza—, asi que el plazo tiene que dar de sobra: en un movil
         * flojo, con la foto pesada y la red del 4G, seis segundos se
         * quedaban cortos. Mientras se espera no se ve un hueco en blanco:
         * el editor ya esta pintado con la pieza, solo falta el dibujo.
         */
        setTimeout(function () {
          var l = colas[k] || [];
          var i = l.indexOf(luego);
          if (i >= 0) { l.splice(i, 1); rastro("se agoto la espera del recorte"); luego(hechos[k] || null); }
        }, 25000);
      }
      function avisar(k) {
        var l = colas[k] || [];
        colas[k] = [];
        l.forEach(function (f) { try { f(hechos[k] || null); } catch (e) {} });
      }

      function apuntar(u) {
        var k = limpia(u);
        if (!k) return;
        apuntarServidor(u);
        disenos[k] = 1;
        preparar(u);
      }

      // Y TAMBIEN POR EL `src`. Los dos caminos de respaldo del editor no
      // pasan por `fetch`: montan un <img> y le ponen la URL. Si el recorte
      // ya esta hecho, se les da ese en su lugar.
      /**
       * EL ARO, POR ENCIMA DEL MONTAJE. SIEMPRE.
       *
       * Lo que el cliente mira arriba NO es el lienzo del editor: es la
       * imagen ya montada que el personalizador deja en la galeria (un
       * `data:` con la pieza y el diseño encima). Ahi el dibujo es la capa
       * de arriba, asi que si por lo que sea entra sin recortar —o el editor
       * lo coloca mas grande de la cuenta— tapa el aro de color.
       *
       * Esto repinta el aro ENCIMA de ese montaje. No depende del recorte,
       * ni de reconocer la direccion del diseño, ni de que el editor coloque
       * bien: coge la imagen que sea, mide donde esta la pieza y le vuelve a
       * poner su aro. Si el recorte ya habia ido bien, repintar no cambia
       * nada (queda igual), asi que no estorba.
       *
       * COMO SE MIDE. La pieza es un circulo sobre margen vacio: su caja
       * (lo que no es transparente ni blanco) da centro y radio. Del mockup
       * se sabe que el aro llega al 39,96 % del ancho y el cristal empieza en
       * el 32,27 %, asi que con el radio medido salen los dos circulos del
       * anillo. Nada de numeros a ojo.
       */
      /**
       * La cache se guarda por FIRMA, no por la imagen entera: un montaje son
       * dos megas de texto y usarlo de clave los duplica en memoria, que en
       * un movil justo se nota.
       */
      var aroPintado = {};
      function firma(u) { return String(u).length + ":" + String(u).slice(-48); }
      function aroEncima(dataUrl) {
        var f = firma(dataUrl);
        if (aroPintado[f]) return Promise.resolve(aroPintado[f]);
        rastro("aro encima: empiezo");
        return new Promise(function (listo, falla) {
          var im = new Image();
          im.onload = function () {
            try {
              var W = im.naturalWidth, H = im.naturalHeight;
              // Solo montajes de la pieza: cuadrados o casi. La miniatura de
              // la foto que sube el cliente es apaisada y aqui no entra.
              if (!W || !H || Math.abs(W / H - 1) > 0.08) { rastro("aro encima: no es la pieza " + W + "x" + H); falla(new Error("no es la pieza")); return; }
              var c = document.createElement("canvas");
              c.width = W; c.height = H;
              var x = c.getContext("2d", { willReadFrequently: true });
              x.drawImage(im, 0, 0);
              var d = x.getImageData(0, 0, W, H).data;
              var x0 = W, x1 = -1, y0 = H, y1 = -1;
              for (var iy = 0; iy < H; iy++) {
                for (var ix = 0; ix < W; ix++) {
                  var i = (iy * W + ix) * 4;
                  if (d[i + 3] < 20) continue;                                   // vacio
                  if (d[i] > 240 && d[i + 1] > 240 && d[i + 2] > 240) continue;   // blanco de fondo
                  if (ix < x0) x0 = ix; if (ix > x1) x1 = ix;
                  if (iy < y0) y0 = iy; if (iy > y1) y1 = iy;
                }
              }
              if (x1 < 0) { rastro("aro encima: imagen vacia"); falla(new Error("imagen vacia")); return; }
              var cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
              var R = Math.min((x1 - x0), (y1 - y0)) / 2;        // radio exterior de la pieza
              if (!(R > 20)) { rastro("aro encima: pieza diminuta"); falla(new Error("pieza diminuta")); return; }
              var AEXT = parseFloat(caja.getAttribute("data-aro-ext")) || 40;
              var AINT = parseFloat(caja.getAttribute("data-aro-int")) || 32.3;
              var Rg = R * (AINT / AEXT);                        // donde empieza el cristal
              pedirAro(aroDelColor()).then(function (aro) {
                try {
                  if (!aro || !aro.naturalWidth) { rastro("aro encima: sin aro"); falla(new Error("sin aro")); return; }
                  var W0 = aro.naturalWidth, H0 = aro.naturalHeight;
                  // El aro del mockup, a la escala de la pieza medida.
                  var k = R / ((AEXT / 100) * W0);
                  x.save();
                  if (typeof Path2D === "function") {
                    var anillo = new Path2D();
                    anillo.arc(cx, cy, R, 0, Math.PI * 2);
                    anillo.arc(cx, cy, Rg, 0, Math.PI * 2);
                    x.clip(anillo, "evenodd");
                  } else {
                    x.beginPath(); x.arc(cx, cy, R, 0, Math.PI * 2); x.clip();
                  }
                  x.drawImage(aro, cx - (W0 / 2) * k, cy - (H0 / 2) * k, W0 * k, H0 * k);
                  x.restore();
                  var fuera = c.toDataURL("image/png");
                  aroPintado[f] = fuera;
                  aroPintado[firma(fuera)] = fuera;   // repintar lo repintado no hace nada
                  rastro("aro repintado encima");
                  listo(fuera);
                } catch (e) { rastro("aro encima: fallo al pintar " + (e && e.message)); falla(e); }
              }, function (e) { rastro("aro encima: el aro no carga"); falla(e); });
            } catch (e) { rastro("aro encima: fallo " + (e && e.message)); falla(e); }
          };
          im.onerror = function () { rastro("aro encima: el montaje no carga"); falla(new Error("no carga")); };
          ponerSrc(im, dataUrl);
        });
      }

      /**
       * Y QUE NO SE LO LLEVEN POR DELANTE.
       *
       * En la ficha corren varias apps de terceros y alguna REHACE el `src`
       * de las imagenes: vuelve a dejar el de fabrica y se lleva este
       * enganche con el. Cuando eso pasa, el diseño entra tal cual —cuadrado,
       * tapando el aro— y pasaba en unos navegadores si y en otros no, que es
       * justo lo que se veia.
       *
       * Asi que el enganche se puede volver a poner y se vigila: si alguien
       * lo quita, se reinstala. Se mira seguido los primeros segundos (que es
       * cuando cargan las apps) y despues de vez en cuando.
       */
      function instalarSrc() {
        var desc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, "src");
        if (!desc || !desc.set || !desc.get || desc.set.__pzRedondoImg) return;
        var puesto = function (v) {
          var val = v;
          try {
            var k = limpia(v);
            // LA VISTA PREVIA DEL TEMA PIDE EL DISEÑO CRUDO. Ella ya pone el
            // aro —su plantilla lo trae— asi que si le diéramos el recorte
            // con el aro dentro saldrian dos, uno sobre otro.
            var crudo = this && this.dataset && this.dataset.pzCrudo === "1";
            // EL MONTAJE QUE VA A LA GALERIA. Llega como `data:` —lo exporta
            // el propio editor— y es LO QUE MIRA EL CLIENTE. Se le repinta
            // el aro por encima antes de enseñarlo.
            if (!crudo && caja.getAttribute("data-aro-en-diseno") !== "1" &&
                /^data:image\//.test(String(v)) && aroPintado[firma(v)] !== v) {
              var yoImg = this;
              aroEncima(v).then(function (conAro) {
                try { desc.set.call(yoImg, conAro); } catch (e) {}
              }).catch(function () {
                try { desc.set.call(yoImg, v); } catch (e) {}   // no se pudo: la de siempre
              });
              return;
            }
            if (crudo) { /* tal cual */ }
            else if (hechos[k]) { val = hechos[k]; rastro("img: con recorte"); }
            else if (esDisenoPorForma(k) || disenos[k]) {
              /**
               * NI UNA SOLA EN CRUDO.
               *
               * Antes, si el recorte todavia no estaba hecho, se dejaba
               * pasar la imagen tal cual: el editor se la quedaba y el
               * diseño entraba CUADRADO, tapando la pieza. Ahora la imagen
               * se queda esperando —no se le asigna nada— y se le entrega
               * el recorte en cuanto esta. Si en seis segundos no hubiera
               * recorte, se le da la original, que es mejor que un hueco
               * en blanco para siempre.
               */
              rastro("img: esperando al recorte");
              var yo = this;
              esperando(k, function (dataUrl) { desc.set.call(yo, dataUrl || v); });
              preparar(v);
              return;
            }
          } catch (e) { /* ante la duda, la de siempre */ }
          desc.set.call(this, val);
        };
        puesto.__pzRedondoImg = 1;
        try {
          Object.defineProperty(HTMLImageElement.prototype, "src", {
            configurable: true, enumerable: desc.enumerable,
            get: function () { return desc.get.call(this); },
            set: puesto,
          });
        } catch (e) { /* navegador que no deja redefinir */ }
      }
      instalarSrc();

      var deSerie = window.fetch;
      function fetch_desdeDato(dataUrl) {
        var coma = dataUrl.indexOf(",");
        var bytes = atob(dataUrl.slice(coma + 1));
        var buf = new Uint8Array(bytes.length);
        for (var i = 0; i < bytes.length; i++) buf[i] = bytes.charCodeAt(i);
        return Promise.resolve(new Response(new Blob([buf], { type: "image/png" }),
          { status: 200, headers: { "Content-Type": "image/png" } }));
      }

      var parcheado = function (entrada, opciones) {
        var u = typeof entrada === "string" ? entrada : (entrada && entrada.url) || "";

        /**
         * EL EDITOR PIDE SU DISEÑO SIEMPRE DE LA MISMA MANERA.
         *
         * Reconocerlo por la direccion se queda corto una y otra vez: el
         * servidor lo nombra de varias formas y a veces viaja por el propio
         * dominio de la tienda. Pero la PETICION tiene firma propia: el
         * editor la hace con `cache: "force-cache"`, `mode: "cors"` y sin
         * credenciales, y en toda la ficha no la usa nadie mas (el fondo de
         * la escena se pide igual, pero ese SI es del tema y lleva /cdn/).
         *
         * Asi que, si llega una imagen pedida asi y no es del tema, es el
         * diseño: se apunta y a partir de ahi `Response.blob` la recorta,
         * se llame como se llame y venga del servidor que venga.
         */
        try {
          var op = opciones || (entrada && typeof entrada === "object" ? entrada : null);
          if (op && op.cache === "force-cache" && !/\/cdn\//.test(limpia(u)) &&
              /\.(webp|png|jpe?g)$/i.test(limpia(u))) {
            apuntar(u);
          }
        } catch (e) { /* peticion rara: se sigue con lo de siempre */ }

        var p = deSerie.apply(this, arguments);
        // DE DONDE SALEN LAS URLS DE LOS DISEÑOS. La consulta de estado es
        // la de siempre, pero no la unica: al subir la foto ya viene una, y
        // cuando la pieza esta en cache el servidor contesta con la URL en
        // la propia respuesta y no se llega a consultar ningun estado.
        if (/\/generate\/status|\/upload|\/original|\/generate/.test(u)) {
          return p.then(function (res) {
            try {
              res.clone().json().then(function (j) {
                if (!j) return;
                if (j.generatedUrl) apuntar(j.generatedUrl);
                if (j.originalUrl) apuntar(j.originalUrl);
                if (j.url) apuntarServidor(j.url);
              }).catch(function () {});
            } catch (e) { /* respuesta rara: se sigue igual */ }
            return res;
          });
        }
        // AL VOLVER NO HAY CONSULTA DE ESTADO. Si el cliente recarga y el
        // widget reabre el editor con el diseño que ya tenia, no se pregunta
        // por el estado y la lista de arriba sale vacia. Por eso tambien se
        // reconoce por la forma de la URL del servidor de imagenes
        // (.../i/<id>.webp), que no la tiene ninguna otra imagen de la ficha.
        var esDiseno = !!disenos[limpia(u)] ||
          (!/\/cdn\//.test(u) && /\/i\/[A-Za-z0-9_-]{6,}\.(webp|png|jpe?g)$/i.test(limpia(u)));
        if (!esDiseno) return p;
        if (hechos[limpia(u)]) {
          p.catch(function () {});                 // no dejar la promesa suelta
          rastro("fetch: con recorte guardado");
          return fetch_desdeDato(hechos[limpia(u)]);
        }
        // Y si no esta hecho, no se toca: el recorte lo hace `Response.blob`,
        // que es el punto por el que pasan TODAS las descargas, venga la
        // peticion de donde venga.
        return p;
      };
      parcheado.__pzRedondo = 1;
      window.fetch = parcheado;

      /**
       * Y POR SI ALGUIEN SE PONE DELANTE.
       *
       * En la ficha corren varias apps de terceros y alguna envuelve
       * `window.fetch` por su cuenta. Si una se instala DESPUES y se queda
       * con el `fetch` de serie, la descarga del diseño deja de pasar por
       * aqui y entra en crudo —cuadrado, tapando la pieza—: el fallo que se
       * veia en unas pantallas si y en otras no.
       *
       * Asi que, ademas, se intercepta donde NADIE puede saltarselo: en el
       * momento en que la respuesta se convierte en fichero (`Response.blob`).
       * Da igual quien haya hecho la peticion ni cuantas capas haya en medio.
       */
      function instalarBlob() {
        if (typeof Response !== "function" || !Response.prototype || Response.prototype.blob.__pzRedondo) return;
        var blobDeSerie = Response.prototype.blob;
        var mio = function () {
          var u = "";
          try { u = limpia(this.url || ""); } catch (e) {}
          var esNuestro = !!u && (disenos[u] || esDisenoPorForma(u));
          var p = blobDeSerie.call(this);
          if (!esNuestro) return p;
          return p.then(function (b) {
            return enRedondo(b).then(function (recortado) {
              rastro("respuesta: recortada");
              return recortado;
            }).catch(function () {
              // Ultimo intento antes de rendirse: leer la imagen tal cual.
              // Devolver `b` aqui es devolver el diseño CUADRADO, que es
              // justo lo que no puede pasar.
              rastro("no se dejo recortar, voy por la imagen");
              return desdeImagen(u)
                .then(function (dataUrl) { return fetch_desdeDato(dataUrl).then(function (r) { return r.blob(); }); })
                .catch(function () { rastro("respuesta: sin recorte"); return b; });
            });
          });
        };
        mio.__pzRedondo = 1;
        try { Response.prototype.blob = mio; } catch (e) { /* navegador que no deja */ }
      }
      instalarBlob();

      /**
       * LA VIGILANCIA. Repasa los dos enganches y los vuelve a poner si
       * faltan. Cuesta nada —dos comprobaciones— y es lo que impide que una
       * app de terceros deje al cliente con el diseño en crudo.
       */
      (function vigilarEnganches() {
        var repasos = 0;
        function repasar() {
          try { instalarSrc(); instalarBlob(); } catch (e) {}
          repasos += 1;
          // Los primeros 15 s, seguido (es cuando cargan las apps); luego,
          // cada 5 s mientras la pestaña siga abierta.
          setTimeout(repasar, repasos < 30 ? 500 : 5000);
        }
        setTimeout(repasar, 300);
        // Y en los momentos que importan, sin esperar al reloj.
        ["portrait:open-editor", "portrait:editor-ready", "portrait:confirmed"].forEach(function (ev) {
          window.addEventListener(ev, function () { try { instalarSrc(); instalarBlob(); } catch (e) {} });
        });
      })();


      // AL VOLVER A LA FICHA, LA URL YA ESTA EN EL FORMULARIO. El widget
      // escribe el diseño en las properties al guardar; si el cliente
      // recarga, ahi sigue, y con eso se puede preparar el recorte antes de
      // que el editor lo pida.
      function mirarFormulario() {
        var campos = RAIZ.querySelectorAll('input[name^="properties["]');
        for (var i = 0; i < campos.length; i++) {
          var v = campos[i].value || "";
          if (/^https?:/.test(v) && /\/i\/[A-Za-z0-9_-]{6,}\.(webp|png|jpe?g)$/i.test(limpia(v))) apuntar(v);
        }
      }
      mirarFormulario();
      window.addEventListener("portrait:confirmed", function () { setTimeout(mirarFormulario, 300); });
    })();

    (function marcoPorColor() {
      var caja = RAIZ.querySelector("[data-pzx-previa]");
      if (!caja) return;
      var mapa = {};
      for (var i = 1; i <= 4; i++) {
        var v = (caja.getAttribute("data-valor-" + i) || "").trim().toLowerCase();
        var u = caja.getAttribute("data-marco-" + i) || "";
        if (v && u) mapa[v] = u;
      }
      var hayMapa = false;
      for (var k in mapa) { if (Object.prototype.hasOwnProperty.call(mapa, k)) hayMapa = true; }
      if (!hayMapa) return;

      /**
       * SE COMPARA POR EL NOMBRE DEL FICHERO, no por la URL entera.
       *
       * El mismo fichero llega escrito de dos maneras —el bloque de app lo
       * da como //la-tienda.com/cdn/shop/files/… y los ajustes de la seccion
       * como https://cdn.shopify.com/s/files/1/…— y comparando las URLs no
       * casaban nunca: el marco no cambiaba de color.
       */
      function nombreDe(u) {
        return String(u || "").split("?")[0].split("/").pop().toLowerCase();
      }

      var nodoCfg = RAIZ.querySelector(".pr-customizer__config");
      if (!nodoCfg) return;
      var marcosApp = [];
      try {
        var c = JSON.parse(nodoCfg.textContent) || {};
        [c.frameUrl, c.squareFrameUrl].forEach(function (u) {
          if (u) marcosApp.push(nombreDe(u));
        });
      } catch (e) { return; }
      if (!marcosApp.length) return;

      // SOLO SI EL MARCO DEL BLOQUE ES UNO DE ESTOS. Cuando la pieza lleva
      // el aro pintado dentro del propio diseño, el marco del bloque ya no
      // es de ningun color —es solo el cristal— y cambiarlo por el de un
      // color volveria a pintar DOS aros, uno encima de otro.
      var esDeColor = false;
      for (var c2 in mapa) {
        if (!Object.prototype.hasOwnProperty.call(mapa, c2)) continue;
        var limpio = nombreDe(mapa[c2]);
        for (var m = 0; m < marcosApp.length; m++) if (marcosApp[m] === limpio) esDeColor = true;
      }
      if (!esDeColor) return;

      function marcoDelColor() {
        var p = puestoDelColor(caja);
        return (p && caja.getAttribute("data-marco-" + p)) || "";
      }

      var desc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, "src");
      if (!desc || !desc.set || !desc.get) return;
      try {
        Object.defineProperty(HTMLImageElement.prototype, "src", {
          configurable: true,
          enumerable: desc.enumerable,
          get: function () { return desc.get.call(this); },
          set: function (v) {
            var val = v;
            try {
              var limpia = nombreDe(v);
              for (var i = 0; i < marcosApp.length; i++) {
                if (limpia !== marcosApp[i]) continue;
                var m = marcoDelColor();
                if (m) val = m;
                break;
              }
            } catch (e) { /* ante la duda, la de siempre */ }
            desc.set.call(this, val);
          },
        });
      } catch (e) { /* navegador que no deja redefinir: se queda el de serie */ }

      /**
       * AL CAMBIAR DE COLOR CON EL EDITOR ABIERTO.
       *
       * El editor pide el mockup UNA sola vez, al montarse. Si el cliente
       * cambia el color despues de generar, el aro se quedaba del color
       * anterior —rojo siempre— porque nadie le vuelve a pedir la imagen.
       *
       * Aqui se le cierra y se le vuelve a abrir con el MISMO diseño: al
       * montarse otra vez pide el marco y entonces ya le toca el del color
       * elegido. Cerrar no pierde nada —el diseño vive en el estado del
       * widget, no en el editor— pero si devuelve el zoom y la posicion a su
       * sitio, que es lo razonable cuando cambia la pieza.
       */
      var ultimoMarco = nombreDe(marcoDelColor());
      var recolocando = false;
      RAIZ.addEventListener("change", function (e) {
        var t = e.target;
        if (!t || !t.closest || !t.closest(".pz-prod__pastilla")) return;
        if (recolocando) return;
        var nuevo = nombreDe(marcoDelColor());
        if (!nuevo || nuevo === ultimoMarco) return;      // no ha cambiado el marco
        ultimoMarco = nuevo;
        var modal = document.querySelector(".pr-modal");
        if (!modal || !document.body.contains(modal)) return;   // sin editor abierto no hay nada que hacer
        recolocando = true;
        setTimeout(function () {
          try {
            var cerrar = modal.querySelector("[data-pr-cancel]");
            if (cerrar) cerrar.click();
          } catch (e2) { /* si no se deja cerrar, se queda como estaba */ }
          setTimeout(function () {
            try { window.dispatchEvent(new CustomEvent("portrait:open-editor")); } catch (e3) {}
            recolocando = false;
          }, 150);
        }, 60);
      });
    })();

    (function vistaPrevia() {
      var caja = RAIZ.querySelector("[data-pzx-previa]");
      if (!caja) return;
      var hueco = caja.querySelector(".pzx-previa__marco");
      var img = caja.querySelector("[data-pzx-previa-img]");
      var espera = caja.querySelector("[data-pzx-previa-espera]");
      if (!hueco || !img) return;

      function num(clave, porDefecto) {
        var n = parseFloat(caja.getAttribute("data-" + clave));
        return isNaN(n) ? porDefecto : n;
      }
      var ENCIMA = caja.getAttribute("data-orden") !== "debajo";
      var CIRCULO = caja.getAttribute("data-forma") !== "rect";
      var A_GALERIA = caja.getAttribute("data-a-galeria") === "1";
      var CON_CANCION = caja.getAttribute("data-cancion") === "1";
      // `contener` mete la figura entera en la ventana; `cubrir` la llena y
      // recorta. A un retrato recortado —el que devuelve el personalizador—
      // cubrir le come la cabeza, asi que el atrapasol pide contener.
      var CONTENER = caja.getAttribute("data-encaje") === "contener";
      // Con que se pinta el hueco ANTES de pegar la imagen. Hace falta
      // cuando el diseño llega sobre transparencia: sin esto se ve por
      // debajo la foto de catalogo que trae la plantilla.
      var FONDO_VENTANA = (caja.getAttribute("data-fondo-ventana") || "").trim();

      function elegidos() {
        var s = [];
        var radios = RAIZ.querySelectorAll(".pz-prod__pastilla input");
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked) s.push(String(radios[i].value || "").trim().toLowerCase());
        }
        return s;
      }
      function todosLosValores() {
        var s = [];
        var radios = RAIZ.querySelectorAll(".pz-prod__pastilla input");
        for (var i = 0; i < radios.length; i++) s.push(String(radios[i].value || "").trim().toLowerCase());
        return s;
      }

      // La plantilla del color elegido; si ninguno casa, la de siempre.
      //
      // Cada hueco puede traer ADEMAS su propia ventana: dos fotos del mismo
      // producto en blanco y en negro no tienen por que estar hechas desde
      // el mismo sitio, y con una sola ventana la foto caeria torcida en una
      // de las dos. Si el hueco no la trae, manda la de arriba.
      function plantillaElegida() {
        var sel = elegidos();
        for (var i = 1; i <= 4; i++) {
          var v = (caja.getAttribute("data-valor-" + i) || "").trim().toLowerCase();
          var u = caja.getAttribute("data-base-" + i) || "";
          if (v && u && sel.indexOf(v) !== -1) {
            return { url: u, ventana: ventanaDe(caja.getAttribute("data-ventana-" + i)),
                     tinte: (caja.getAttribute("data-tinte-" + i) || "").trim(), conColor: true };
          }
        }
        // Y si los nombres no casan —idioma distinto del español—, por el puesto.
        var p = puestoDelColor(caja);
        var up = p ? (caja.getAttribute("data-base-" + p) || "") : "";
        if (up) {
          return { url: up, ventana: ventanaDe(caja.getAttribute("data-ventana-" + p)),
                   tinte: (caja.getAttribute("data-tinte-" + p) || "").trim(), conColor: true };
        }
        return { url: caja.getAttribute("data-base") || "", ventana: null, tinte: "", conColor: false };
      }
      function ventanaDe(txt) {
        if (!txt) return null;
        var n = String(txt).split(",").map(function (s) { return parseFloat(s.trim()); });
        if (n.length !== 4 || n.some(isNaN)) return null;
        return { x: n[0], y: n[1], w: n[2], h: n[3] };
      }

      // Las plantillas se guardan segun se van pidiendo: cambiar de color
      // adelante y atras no vuelve a bajarlas.
      var guardadas = {};
      function pedirPlantilla(url, luego) {
        if (!url) { luego(null); return; }
        var g = guardadas[url];
        if (g && g.listo) { luego(g.img); return; }
        if (g) { g.cola.push(luego); return; }
        var im = new Image();
        im.crossOrigin = "anonymous";
        guardadas[url] = { img: im, listo: false, cola: [luego] };
        im.onload = function () {
          var e = guardadas[url];
          e.listo = true;
          e.cola.splice(0).forEach(function (f) { f(im); });
        };
        im.onerror = function () {
          var e = guardadas[url];
          e.cola.splice(0).forEach(function (f) { f(null); });
          delete guardadas[url];
        };
        im.src = url;
      }

      // ¿ESTA FICHA LLEVA FOTO? El cuadro de letra solo la lleva en los
      // modelos «CON TU FOTO»; el disco siempre. Mismo criterio que el
      // bloque de subir foto: si el producto no tiene ese valor, se ve
      // siempre.
      // Por SUBCADENA, como `tds-subir-foto`: asi «CON TU FOTO» casa con
      // «BLANCO CON TU FOTO» y no hay que listar los modelos uno a uno.
      function casa(lista, activadores) {
        return lista.some(function (v) {
          return activadores.some(function (a) { return v.indexOf(a) !== -1; });
        });
      }
      function activadoresDe(attr) {
        return (caja.getAttribute(attr) || "").split(",")
          .map(function (s) { return s.trim().toLowerCase(); })
          .filter(function (s) { return s; });
      }
      function toca() {
        var quiere = activadoresDe("data-mostrar-si");
        if (!quiere.length) return true;
        if (!casa(todosLosValores(), quiere)) return true;   // el producto no tiene esa opcion
        return casa(elegidos(), quiere);
      }

      /**
       * EL MODELO LISO NO LLEVA FOTO.
       *
       * El cuadro se vende en blanco y negro a secas y en blanco y negro CON
       * TU FOTO. Si el cliente sube una foto y luego se pasa al liso, la foto
       * no se compra —el bloque de subida la aparca— y tampoco se puede
       * enseñar: su plantilla no tiene hueco donde meterla, asi que quedaria
       * pegada encima del diseño.
       */
      function pegaFoto() {
        var quiere = activadoresDe("data-foto-si");
        if (!quiere.length) return true;
        if (!casa(todosLosValores(), quiere)) return true;
        return casa(elegidos(), quiere);
      }

      /**
       * DE DONDE SALE LA IMAGEN QUE VA DENTRO.
       *
       * Dos caminos, y el atrapasol estrena el segundo:
       *
       *  · EL CAMPO DEL TEMA (`tds-subir-foto`): el disco y el cuadro de
       *    letra, que no tienen editor.
       *  · EL PERSONALIZADOR: ahi la imagen no esta en el DOM del tema. El
       *    widget la sube y escribe el resultado en las properties del
       *    formulario. Se prefiere el DISEÑO —lo que se va a imprimir— y
       *    mientras no lo haya se cae a la foto recien subida, para que el
       *    cliente vea su pieza en cuanto la suelta y no solo al terminar.
       */
      function valorProp(nombre) {
        var sel = 'input[name="properties[' + nombre + ']"]';
        var n = RAIZ.querySelector(sel) || document.querySelector(sel);
        var v = n && n.value ? String(n.value).trim() : "";
        return /^https?:/.test(v) ? v : "";
      }
      // LA FOTO CRUDA NO SE TRATA COMO UN DISEÑO. Mientras el cliente no
      // genera nada, lo unico que hay es la foto que acaba de subir: una
      // foto entera, con su fondo. Esa llena la ventana («cubrir»), porque
      // contenerla la dejaria flotando entre dos franjas blancas. El
      // diseño, en cambio, viene recortado y hay que contenerlo entero.
      var fuenteCruda = false;
      function urlDeLaFoto() {
        fuenteCruda = false;
        var n = RAIZ.querySelector("[data-tds-foto-img]");
        if (n && n.getAttribute("src") && /^(https?:|data:|blob:)/.test(n.src)) return n.src;
        // DEL EDITOR, SOLO EL DISEÑO. Antes, mientras no habia diseño, se
        // enseñaba aqui la foto que el cliente acababa de subir: con su
        // jardin, su salon y su fondo. Dentro del cristal eso no es el
        // producto, es el material de partida. Se espera al diseño, que
        // llega recortado; hasta entonces se ve la pieza vacia, que ya dice
        // de que color va a ser.
        return valorProp("Dise\u00f1o sin efecto") || valorProp("_Dise\u00f1o generado");
      }

      function laCancion() {
        var sp = RAIZ.querySelector("[data-tds-spotify]");
        if (!sp) return null;
        function leer(prop) {
          var n = document.querySelector('input[name="properties[' + prop + ']"]');
          return n && n.value ? n.value : "";
        }
        var t = leer(sp.getAttribute("data-prop-cancion") || "Canción");
        var a = leer(sp.getAttribute("data-prop-artista") || "Artista");
        return t ? { titulo: t, artista: a } : null;
      }

      /**
       * EL MONTAJE, ARRIBA EN LA GALERIA.
       *
       * La galeria no sabe pintar un diseño: lo que hace es CEDER el marco
       * al editor mientras esta abierto. Al cerrarlo vuelven las fotos de
       * catalogo y el cliente pierde de vista lo que acaba de montar. Asi
       * que aqui se le mete una foto mas, la primera: la pieza limpia con su
       * diseño. Se clona la primera diapositiva para heredar el envoltorio
       * del tema y se marca `data-pz-generada`, que es lo que la ficha ya
       * sabe quitar cuando se empieza de cero.
       */
      function pintarEnLaGaleria(datos) {
        var tira = RAIZ.querySelector(".pz-prod__tira");
        if (!tira || !tira.firstElementChild) return;
        var hueco = tira.querySelector("[data-pz-generada]");
        if (!hueco) {
          hueco = tira.firstElementChild.cloneNode(true);
          hueco.setAttribute("data-pz-generada", "1");
          hueco.removeAttribute("id");
          Array.prototype.forEach.call(hueco.querySelectorAll("source"), function (f) {
            f.removeAttribute("srcset");
          });
          tira.insertBefore(hueco, tira.firstElementChild);
        }
        var im = hueco.querySelector("img");
        if (!im) return;
        im.removeAttribute("srcset");
        im.removeAttribute("sizes");
        im.removeAttribute("data-src");
        im.loading = "eager";
        if (im.src !== datos) im.src = datos;
        // Y que se vea: la primera vez se lleva el carrusel hasta ella.
        if (!tira.dataset.pzYaEnsenada) {
          tira.dataset.pzYaEnsenada = "1";
          setTimeout(function () {
            try { tira.scrollTo({ left: 0, behavior: "smooth" }); }
            catch (e) { tira.scrollLeft = 0; }
          }, 250);
        }
      }

      var lienzo = document.createElement("canvas");
      lienzo.style.cssText = "display:block;width:100%;height:auto";
      var ctx = lienzo.getContext("2d");
      var puesto = false;

      function recortar(txt, ancho) {
        var s = String(txt);
        while (s.length > 4 && ctx.measureText(s).width > ancho) s = s.slice(0, -1);
        return s.length < String(txt).length ? s.replace(/\s+\S*$/, "") + "…" : s;
      }
      function pintarCancion(w, h) {
        var c = laCancion();
        if (!c) return;
        var x = num("cancion-x", 30) / 100 * w;
        var y = num("cancion-y", 72) / 100 * h;
        var ancho = num("cancion-w", 40) / 100 * w;
        ctx.save();
        ctx.fillStyle = caja.getAttribute("data-cancion-color") || "#ffffff";
        ctx.textBaseline = "top";
        var tam = Math.max(10, Math.round(ancho * 0.085));
        ctx.font = "600 " + tam + "px Helvetica, Arial, sans-serif";
        ctx.fillText(recortar(c.titulo, ancho), x, y);
        if (c.artista) {
          ctx.globalAlpha = 0.78;
          ctx.font = "400 " + Math.round(tam * 0.72) + "px Helvetica, Arial, sans-serif";
          ctx.fillText(recortar(c.artista, ancho), x, y + tam * 1.25);
        }
        ctx.restore();
      }

      /**
       * LA FORMA DEL HUECO DE LA GALERIA.
       *
       * El carrusel del tema pinta con `object-fit: contain` dentro de un
       * recuadro apaisado, y la plantilla es cuadrada o de pie: el montaje
       * salia centrado con DOS BANDAS BLANCAS a los lados. Asi que el lienzo
       * se hace del alto de la plantilla y del ancho que pida el hueco, y las
       * bandas se rellenan con la propia plantilla ampliada y desenfocada: el
       * fondo que ya tiene el diseño, no un blanco que no esta en ningun
       * sitio.
       */
      function ratioGaleria() {
        var g = RAIZ.querySelector(".pz-prod__tira img");
        var r = g && g.getBoundingClientRect();
        if (r && r.width > 40 && r.height > 40) return r.width / r.height;
        return 0;
      }

      /**
       * TEÑIR LA PIEZA SIN CAMBIAR DE FOTO.
       *
       * El disco de vinilo se vende en negro, dorado, azul y rosado, y de
       * eso no hay cuatro fotos: hay una, la del negro. Pero el color no
       * cambia la escena, solo el material, asi que se tiñe el ANILLO —la
       * pieza menos la ventana de la foto— sobre la misma plantilla.
       *
       * Se pinta con mezcla y no a pelo para que las estrias del vinilo
       * sigan viendose: «screen» sobre un material oscuro, «multiply» sobre
       * uno claro. El anillo se recorta con la regla par-impar, que es lo
       * que deja un agujero limpio donde va la foto.
       */
      function tenir(color, W, H, bx, by, bw, bh, V) {
        var z = ventanaDe(caja.getAttribute("data-tinte-zona"));
        if (!color || !z) return;
        var zx = bx + z.x / 100 * bw, zy = by + z.y / 100 * bh;
        var zw = z.w / 100 * bw, zh = z.h / 100 * bh;
        var vx = bx + V.x / 100 * bw, vy = by + V.y / 100 * bh;
        var vw = V.w / 100 * bw, vh = V.h / 100 * bh;
        ctx.save();
        try {
          if (typeof Path2D === "function") {
            var p = new Path2D();
            p.ellipse(zx + zw / 2, zy + zh / 2, zw / 2, zh / 2, 0, 0, Math.PI * 2);
            p.ellipse(vx + vw / 2, vy + vh / 2, vw / 2, vh / 2, 0, 0, Math.PI * 2);
            ctx.clip(p, "evenodd");
          } else {
            ctx.beginPath();
            ctx.ellipse(zx + zw / 2, zy + zh / 2, zw / 2, zh / 2, 0, 0, Math.PI * 2);
            ctx.clip();
          }
          ctx.globalCompositeOperation = caja.getAttribute("data-tinte-mezcla") || "screen";
          ctx.fillStyle = color;
          ctx.fillRect(0, 0, W, H);
        } catch (e) { /* navegador sin mezclas: se queda sin teñir */ }
        ctx.restore();
      }

      /**
       * CON QUE SE RELLENAN LAS BANDAS DE LOS LADOS.
       *
       * El hueco de la galeria es apaisado y la plantilla no, asi que sobra
       * sitio a izquierda y derecha. Estaba la plantilla ampliada y
       * desenfocada, pero un desenfoque al lado de una foto nitida se lee
       * como un error de imprenta. Por defecto se pinta ahora un DEGRADADO
       * tomado de la propia plantilla —el tono de su borde de arriba y el de
       * abajo—, que continua la escena sin inventarse nada.
       */
      function tonoDeLaPlantilla(base, parte) {
        var m = document.createElement("canvas");
        m.width = 1; m.height = 1;
        var mx = m.getContext("2d");
        var h = base.naturalHeight, w = base.naturalWidth;
        var y = parte === "arriba" ? 0 : Math.round(h * 0.92);
        mx.drawImage(base, 0, y, w, Math.max(1, Math.round(h * 0.08)), 0, 0, 1, 1);
        var d = mx.getImageData(0, 0, 1, 1).data;
        return "rgb(" + d[0] + "," + d[1] + "," + d[2] + ")";
      }
      function rellenarFondo(base, W, H, w0, h0) {
        var modo = caja.getAttribute("data-fondo") || "degradado";
        if (modo === "borroso") {
          ctx.save();
          try { if ("filter" in ctx) ctx.filter = "blur(26px)"; } catch (e) { /* da igual */ }
          var rc = Math.max(W / w0, H / h0) * 1.14;
          ctx.drawImage(base, (W - w0 * rc) / 2, (H - h0 * rc) / 2, w0 * rc, h0 * rc);
          ctx.restore();
          return;
        }
        if (modo === "fijo") {
          ctx.fillStyle = caja.getAttribute("data-fondo-color") || "#f4f4f4";
          ctx.fillRect(0, 0, W, H);
          return;
        }
        try {
          var arriba = tonoDeLaPlantilla(base, "arriba");
          if (modo === "liso") { ctx.fillStyle = arriba; ctx.fillRect(0, 0, W, H); return; }
          var abajo = tonoDeLaPlantilla(base, "abajo");
          var g = ctx.createLinearGradient(0, 0, 0, H);
          g.addColorStop(0, arriba);
          g.addColorStop(1, abajo);
          ctx.fillStyle = g;
          ctx.fillRect(0, 0, W, H);
        } catch (e) {
          // plantilla de otro dominio sin permiso: no se deja leer un pixel.
          ctx.fillStyle = caja.getAttribute("data-fondo-color") || "#f4f4f4";
          ctx.fillRect(0, 0, W, H);
        }
      }

      function montar(base, foto, ventana, tinte) {
        var w0 = base.naturalWidth, h0 = base.naturalHeight;
        if (!w0 || !h0) return;
        // Tope de 1000 px: por encima no se nota y el dataURL se dispara.
        var escala = Math.min(1, 1000 / Math.max(w0, h0));
        var bw = Math.round(w0 * escala), bh = Math.round(h0 * escala);
        // LAS BANDAS SON COSA DE LA GALERIA. El hueco de arriba es apaisado
        // y por eso el lienzo se ensancha hasta su forma. Cuando el montaje
        // NO sube a la galeria —se enseña aqui, debajo del paso— ensancharlo
        // solo añade dos bandas de relleno a los lados de la pieza.
        var ratio = (A_GALERIA ? ratioGaleria() : 0) || (bw / bh);
        var W, H;
        if (ratio >= bw / bh) { H = bh; W = Math.round(bh * ratio); }
        else { W = bw; H = Math.round(bw / ratio); }
        lienzo.width = W; lienzo.height = H;
        ctx.clearRect(0, 0, W, H);
        var bx = Math.round((W - bw) / 2), by = Math.round((H - bh) / 2);

        if (W > bw || H > bh) rellenarFondo(base, W, H, w0, h0);

        var V = ventana || { x: num("x", 30), y: num("y", 30), w: num("w", 40), h: num("h", 40) };
        // La ventana va en % DE LA PLANTILLA, no del lienzo: hay que correrla
        // hasta donde la plantilla ha caido.
        var vx = bx + V.x / 100 * bw, vy = by + V.y / 100 * bh;
        var vw = V.w / 100 * bw, vh = V.h / 100 * bh;

        function conFoto() {
          if (!foto) return;
          ctx.save();
          ctx.beginPath();
          if (CIRCULO && ctx.ellipse) ctx.ellipse(vx + vw / 2, vy + vh / 2, vw / 2, vh / 2, 0, 0, Math.PI * 2);
          else ctx.rect(vx, vy, vw, vh);
          ctx.clip();
          // EL HUECO, PRIMERO. El diseño del personalizador llega recortado
          // —el sujeto sobre transparencia—, y sin pintar el hueco se veia
          // por debajo la foto de catalogo de la plantilla.
          if (FONDO_VENTANA) { ctx.fillStyle = FONDO_VENTANA; ctx.fill(); }
          // Encajada como `cover` —llena la ventana sin deformarse— salvo
          // que se pida `contener`, que mete la figura entera.
          var r = (CONTENER && !fuenteCruda)
            ? Math.min(vw / foto.naturalWidth, vh / foto.naturalHeight)
            : Math.max(vw / foto.naturalWidth, vh / foto.naturalHeight);
          var fw = foto.naturalWidth * r, fh = foto.naturalHeight * r;
          ctx.drawImage(foto, vx + (vw - fw) / 2, vy + (vh - fh) / 2, fw, fh);
          ctx.restore();
        }
        if (ENCIMA) { conFoto(); ctx.drawImage(base, bx, by, bw, bh); }
        else { ctx.drawImage(base, bx, by, bw, bh); conFoto(); }
        tenir(tinte, W, H, bx, by, bw, bh, V);
        if (CON_CANCION) pintarCancion(W, H);

        if (!puesto) { img.style.display = "none"; hueco.appendChild(lienzo); puesto = true; }
        if (espera) espera.hidden = true;

        // SIN FOTO TAMBIEN, si el color tiene plantilla propia: el cliente
        // elige «blanco» y tiene que ver el blanco arriba en ese momento, no
        // despues de subir la foto.
        // A LA GALERIA, SOLO CON EL DISEÑO. Mientras lo unico que hay es la
        // foto cruda que el cliente acaba de subir —con su fondo, su salon,
        // su jardin— arriba se queda la foto de catalogo: el montaje de
        // verdad es el que lleva el diseño recortado.
        function nota(t) { try { caja.setAttribute("data-pz-previa-estado", String(t).slice(0, 70)); } catch (e) {} }
        if (!A_GALERIA) nota("galeria apagada");
        else if (fuenteCruda) nota("galeria: todavia es la foto cruda");
        else if (!foto && !conColorAhora) nota("galeria: nada que enviar");
        else {
          try {
            var datos = lienzo.toDataURL("image/jpeg", 0.88);
            // `true` = este montaje manda sobre la instantanea del editor:
            // es el que lleva la pieza limpia, sin la pared de la escena.
            if (datos && datos.length > 1000) {
              pintarEnLaGaleria(datos);
              nota("galeria: puesto");
            } else nota("galeria: dataURL corto");
          } catch (e) { nota("galeria: lienzo contaminado"); }
        }
      }

      var ultimaFirma = "", conColorAhora = false;
      function repasar() {
        caja.hidden = !toca();
        if (caja.hidden) return;
        var elegida = plantillaElegida();
        conColorAhora = !!elegida.conColor;
        var urlBase = elegida.url;
        if (!urlBase) return;
        var urlFoto = pegaFoto() ? urlDeLaFoto() : "";
        var c = laCancion();
        var firma = urlBase + "|" + (elegida.tinte || "") + "|" + urlFoto + "|" + (c ? c.titulo + "·" + c.artista : "");
        if (firma === ultimaFirma) return;
        ultimaFirma = firma;
        if (espera && urlFoto) espera.hidden = false;
        pedirPlantilla(urlBase, function (base) {
          if (!base) { if (espera) espera.hidden = true; return; }
          if (!urlFoto) { montar(base, null, elegida.ventana, elegida.tinte); return; }
          var f = new Image();
          f.crossOrigin = "anonymous";
          // EL ARO LO PONE LA PLANTILLA DE AQUI, no el recorte: pide el
          // diseño tal cual o saldrian dos aros, uno sobre otro.
          f.dataset.pzCrudo = "1";
          f.onload = function () { montar(base, f, elegida.ventana, elegida.tinte); };
          f.onerror = function () {
            // Sin permiso de otro dominio: se reintenta sin pedirlo, aunque
            // entonces el lienzo quede contaminado y no viaje a la galeria.
            var g = new Image();
            g.dataset.pzCrudo = "1";
            g.onload = function () { montar(base, g, elegida.ventana, elegida.tinte); };
            g.onerror = function () { if (espera) espera.hidden = true; };
            g.src = urlFoto;
          };
          f.src = urlFoto;
        });
      }

      var relojPrevia = null;
      function repasarPronto() {
        if (relojPrevia) clearTimeout(relojPrevia);
        relojPrevia = setTimeout(function () { relojPrevia = null; repasar(); }, 180);
      }
      ["change", "click", "input"].forEach(function (ev) {
        RAIZ.addEventListener(ev, repasarPronto, true);
      });
      if (typeof MutationObserver === "function") {
        var mini = RAIZ.querySelector("[data-tds-foto-img]");
        if (mini) new MutationObserver(repasarPronto).observe(mini, { attributes: true, attributeFilter: ["src"] });
        var form = RAIZ.querySelector("form[action*='/cart/add']") || RAIZ;
        new MutationObserver(repasarPronto).observe(form, { childList: true, subtree: true });
        // La miniatura del personalizador: cambia en cuanto el cliente
        // suelta la foto, antes de que haya diseño ninguno.
        var mirilla = RAIZ.querySelector("[data-pr-preview]");
        if (mirilla) new MutationObserver(repasarPronto).observe(mirilla, { attributes: true, attributeFilter: ["src"] });
      }
      // GUARDAR NO MUEVE EL DOM. Las properties con el diseño ya existen y
      // el widget solo les cambia el valor, que no dispara ningun observador.
      // El aviso de guardado si llega, asi que se repasa un poco despues.
      window.addEventListener("portrait:confirmed", function () { setTimeout(repasarPronto, 400); });
      repasar();
    })();

  }  // fin de arrancar()

  arrancar();

  /**
   * VOLVER ATRAS NO BORRA NADA.
   *
   * Antes, al volver con la flecha de «atras» se volvia a arrancar la ficha
   * entera y se dejaba todo en «No». La idea era evitar que el navegador
   * restaurase las casillas sin que nuestro resumen se enterara, pero en
   * esta vuelta no hace falta y hacia dano: `persisted` significa que la
   * pagina vuelve VIVA de la memoria del navegador —con su estado, su
   * editor y su diseno intactos—, asi que no hay nada que resincronizar...
   * y volver a arrancar enganchaba por segunda vez todos los oyentes, que
   * es de donde salian los contadores dobles y los saltos raros.
   *
   * Asi que al volver no se toca nada: se repinta, por si el precio de la
   * variante lo cambio el tema, y punto. El reinicio sigue existiendo para
   * la carga de verdad (ahi si restaura formularios el navegador) y ahora
   * tambien para cuando se sube una foto DISTINTA.
   */
  window.addEventListener("pageshow", function (e) {
    if (!e || !e.persisted) return;
    if (typeof window.__pztPintar === "function") window.__pztPintar();
    if (typeof window.__pztAltoGaleria === "function") window.__pztAltoGaleria();
  });

  // Uno solo para toda la vida de la pagina: avisa al `pintar` que este
  // vigente en ese momento, no al que hubiera cuando se engancho.
  window.addEventListener("dedicatoria:change", function () {
    setTimeout(function () {
      if (typeof window.__pztPintar === "function") window.__pztPintar();
    }, 0);
  });

  // Uno solo para toda la vida de la pagina: el scroll llama mucho, asi que
  // el calculo va en el fotograma siguiente y no en cada evento.
  (function vigilarScroll() {
    var pedido = false;
    function pedir() {
      if (pedido) return;
      pedido = true;
      (window.requestAnimationFrame || setTimeout)(function () {
        pedido = false;
        if (typeof window.__pztAltoGaleria === "function") window.__pztAltoGaleria();
      });
    }
    window.addEventListener("scroll", pedir, { passive: true });
    window.addEventListener("resize", pedir);
    window.addEventListener("orientationchange", pedir);
  })();

  // Uno solo para toda la vida de la pagina, igual que el de la dedicatoria.
  window.addEventListener("portrait:editor-ready", function (e) {
    if (typeof window.__pztDisenoNuevo === "function") {
      window.__pztDisenoNuevo(e && e.detail && e.detail.url);
    }
  });

  // El editor repinta la seccion en cada cambio de ajuste: hay que volver a
  // engancharlo todo sobre el DOM nuevo.
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector("[data-pz-producto]")) {
      arrancar();
    }
  });

  // Al seleccionar un bloque en el editor, Shopify lo desplaza a la vista.
  // Si estuviera tapado por los pasos que se esconden, el merchant no veria
  // lo que esta configurando — por eso en el editor no se tapa nada (ver
  // `taparElResto`), y aqui solo se repasa por si acaso.
  document.addEventListener("shopify:block:select", function () {
    document.querySelectorAll(".pz-prod__bloque[hidden]").forEach(function (b) {
      if (window.Shopify && window.Shopify.designMode) b.hidden = false;
    });
  });
})();
